/* ========================================================================
   DRIVE IQ — TRAVEL / VACATION MODE JS V16.8 GOLF DIAGNOSTICS + EXPANDED DISCOVERY + V16.7 COMPACT DOCK + V16.6 GOLF DISCOVERY + GOOGLE PHOTO SDK + V16.5 CATEGORY TRUTH IQ + PHOTO KEY BRIDGE + V16.3 GOOGLE PLACE PHOTOS + V16.2 DESTINATION AUTHORITY + TRIP-STYLE INTELLIGENCE + SEARCH + LOCAL IQ
   ES5-safe. No optional chaining. No arrow functions. No external assets
   beyond Mapbox GL, Geoapify, and optional Google Places proxy calls.
======================================================================== */

/* V16.1 STYLE-SWITCH SYNC
   - Clears stale Travel Scan pins/cards immediately when trip style changes.
   - Cancels any in-flight scan from the previous trip style.
   - Re-runs the selected trip style's primary scan near the destination.
   - Keeps Search Any Stop visually synced to Near Destination after destination selection.
   - Lets Place IQ trip-fit reasoning wrap instead of being clipped.
*/

/* V15 TRIP STYLES IQ
   - Wires Travel Mode Trip Styles: Beach Weekend, Bachelor/Bachelorette,
     College Town, Gameday, Golf Trip, Food & Wine, and Family Adventure.
   - Stores selected trip style in the Travel IQ trip builder.
   - Adds style-aware scan hints, contextual query boosts, and destination-first planning.

   V13 SEARCH ANY STOP + LOCAL IQ
   - Wires the V13 HTML Search Any Stop panel.
   - Literal free-text search for businesses, places, addresses, and categories.
   - Supports Near Me, Near Destination, and Along Route scopes.
   - Typed results never inherit the active scan category or false scan labels.
   - Adds Add Stop and Route Here actions, map pins, exact-match scoring,
     route-aware proximity, and safe GPS/destination fallbacks.

   V12 LOCAL IQ / TRAVEL SCANS
   - HTML locked: JS-only intelligence upgrade.
   - Adds Along Route scanning scope.
   - Adds Live Music, Waterfront, Patio, Hidden Gems, and Scenic scan lanes.
   - Strengthens Place IQ cards with venue names, contextual tags, open/rating/distance metadata, Worth the Drive language, and Add Stop actions.
   - Keeps curated 6-8 result philosophy and map-first behavior.
*/
(function(){
"use strict";

if(window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V16_1__){ return; }
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V16_1__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V16__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V15__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V15_1_MAP_FIRST__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V13__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V12__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V11__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V10__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V9__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V8__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V7__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V6__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V5__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V4__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V3__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V2__ = true;
window.__DRIVE_IQ_TRAVEL_VACATION_MODE_JS_V1__ = true;

var MAPBOX_TOKEN = String(window.DRIVE_IQ_MAPBOX_TOKEN || "");
var GEOAPIFY_KEY = String(window.DRIVE_IQ_GEOAPIFY_KEY || "");
var GOOGLE_PLACES_KEY = String(window.DRIVE_IQ_GOOGLE_PLACES_KEY || window.GOOGLE_PLACES_KEY || "");
var GOOGLE_PLACES_PROXY_URL = String(window.DRIVE_IQ_GOOGLE_PLACES_PROXY_URL || "");
var DRIVE_MODE_URL = String(window.DRIVE_IQ_DRIVE_MODE_URL || "/pages/drive-mode");
var TRAVEL_HOME_URL = String(window.DRIVE_IQ_HOME_URL || window.DRIVE_IQ_START_URL || "/pages/start-drive");

var map = null;
var mapLoaded = false;
var lastFix = null;
var dest = null;
var routeGeo = null;
var routeReady = false;
var searchTimer = null;
var destinationSearchToken = 0; /* V16.2: discard stale city search responses */
var gpsWatchId = null;
var travelScanToken = 0;
var travelScanResults = [];
var travelScanCategory = "";
var travelScanScope = "near_me";
var travelInfoVoiceEnabled = true;
var manualTravelScanScope = "";
var travelScanCollapsed = false;
var foodIQOpen = false;
var foodIQMoreOpen = false;
var stopSearchScope = "near_me";
var stopSearchToken = 0;
var stopSearchResults = [];
var stopSearchTimer = null;
var activeTravelTripStyle = "general";
var activeTravelTripStyleLabel = "General Trip";

var LS = {
  LAST_FIX:"diq_last_gps_v1",
  DEST:"diq_dest_v1",
  ROUTE_GEO:"diq_route_geo_v1",
  ROUTE_INTEL:"diq_route_intel_v1",
  DRIVE_ON:"diq_drive_on_v1",
  ACTIVE_DRIVE_ID:"diq_active_drive_id_v1",
  DRIVE_PAYLOAD:"diq_drive_payload_v1",
  UPGRADE_INTENT:"diq_upgrade_intent_v1",
  FAVORITE_STOPS:"diq_place_iq_favorite_stops_v1",
  DISCOVERY_DROPS:"diq_place_iq_drops_v1",
  PLACE_RATINGS:"diq_place_iq_ratings_v1",
  TRIP_BUILDER:"diq_travel_iq_trip_builder_v1",
  SAVED_TRIPS:"diq_travel_iq_saved_trips_v1",
  TASTE_PROFILE:"diq_place_iq_taste_profile_v1",
  TRIP_STYLE:"diq_travel_iq_trip_style_v1"
};

function byId(id){ return document.getElementById(id); }

function finite(v){ return typeof v === "number" && isFinite(v); }

function clean(v){ return String(v || "").replace(/\s+/g," ").trim(); }

function safeParse(v){
  try{ return JSON.parse(String(v || "")); }
  catch(e){ return null; }
}

function lsGet(k){
  try{ return localStorage.getItem(k); }
  catch(e){ return null; }
}

function lsSet(k,v){
  try{ localStorage.setItem(k,String(v)); }
  catch(e){}
}

function lsJSON(k,v){
  try{ localStorage.setItem(k,JSON.stringify(v)); }
  catch(e){}
}

function lsRemove(k){
  try{ localStorage.removeItem(k); }
  catch(e){}
}

function esc(v){
  return String(v == null ? "" : v)
    .replace(/&/g,"&amp;")
    .replace(/</g,"&lt;")
    .replace(/>/g,"&gt;")
    .replace(/"/g,"&quot;")
    .replace(/'/g,"&#39;");
}

function setIntel(text,kind){
  var el = byId("diqPillIntel");
  if(!el){ return; }
  el.className = "diqPill";
  if(kind === "green"){ el.className = "diqPill green"; }
  else if(kind === "blue"){ el.className = "diqPill blue"; }
  else if(kind === "gold"){ el.className = "diqPill gold"; }
  else if(kind === "red"){ el.className = "diqPill red"; }
  el.textContent = String(text || "SEARCH READY").toUpperCase();
}

function setGps(text,kind){
  var el = byId("diqPillGps");
  if(!el){ return; }
  el.className = "diqPill";
  if(kind === "green"){ el.className = "diqPill green"; }
  else if(kind === "blue"){ el.className = "diqPill blue"; }
  else if(kind === "gold"){ el.className = "diqPill gold"; }
  else if(kind === "red"){ el.className = "diqPill red"; }
  el.textContent = text || "LOCATING GPS";
}

function subline(text){
  var el = byId("diqSubline");
  if(el){ el.textContent = text || "Search destination • Lock GPS • Draw route"; }
}

function toast(text){
  var el = byId("diqToast");
  if(!el){ return; }
  el.textContent = text || "Ready";
  el.className = "diqToast on";
  window.setTimeout(function(){ el.className = "diqToast"; },1500);
}

function miles(lat1,lng1,lat2,lng2){
  var R = 3958.8;
  var dLat = (Number(lat2) - Number(lat1)) * Math.PI / 180;
  var dLng = (Number(lng2) - Number(lng1)) * Math.PI / 180;
  var a1 = Number(lat1) * Math.PI / 180;
  var a2 = Number(lat2) * Math.PI / 180;
  var x = Math.sin(dLat/2) * Math.sin(dLat/2) +
    Math.sin(dLng/2) * Math.sin(dLng/2) * Math.cos(a1) * Math.cos(a2);
  return R * 2 * Math.atan2(Math.sqrt(x),Math.sqrt(1 - x));
}

function fmtMiles(mi){
  var n = Number(mi);
  if(!finite(n)){ return "--"; }
  if(n < .1){ return "0.1 mi"; }
  if(n >= 100){ return String(Math.round(n)) + " mi"; }
  return String(Math.round(n * 10) / 10) + " mi";
}

function fmtTime(seconds){
  var m = Math.round(Number(seconds || 0) / 60);
  var h;
  var r;
  if(!finite(m) || m <= 0){ return "--"; }
  h = Math.floor(m / 60);
  r = m % 60;
  if(h <= 0){ return String(r) + " min"; }
  if(r <= 0){ return String(h) + " hr"; }
  return String(h) + " hr " + String(r) + " min";
}

function emptyFC(){
  return { type:"FeatureCollection", features:[] };
}

function pointFC(lng,lat,props){
  return {
    type:"FeatureCollection",
    features:[{
      type:"Feature",
      properties:props || {},
      geometry:{ type:"Point", coordinates:[Number(lng),Number(lat)] }
    }]
  };
}

function routeFC(feature){
  return { type:"FeatureCollection", features:[feature] };
}

function removeLayer(id){
  try{ if(map && map.getLayer(id)){ map.removeLayer(id); } }catch(e){}
}

function removeSource(id){
  try{ if(map && map.getSource(id)){ map.removeSource(id); } }catch(e){}
}

function ensureMapSources(){
  if(!mapLoaded || !map){ return; }

  try{
    if(!map.getSource("diq-you")){
      map.addSource("diq-you",{ type:"geojson", data:emptyFC() });

      map.addLayer({
        id:"diq-you-halo",
        type:"circle",
        source:"diq-you",
        paint:{
          "circle-radius":["interpolate",["linear"],["zoom"],8,14,14,24,18,34],
          "circle-color":"#28ffbe",
          "circle-opacity":0.20,
          "circle-blur":1
        }
      });

      map.addLayer({
        id:"diq-you-dot",
        type:"circle",
        source:"diq-you",
        paint:{
          "circle-radius":["interpolate",["linear"],["zoom"],8,6,14,9,18,12],
          "circle-color":"#28ffbe",
          "circle-stroke-color":"#061018",
          "circle-stroke-width":4,
          "circle-opacity":1
        }
      });

      map.addLayer({
        id:"diq-you-label",
        type:"symbol",
        source:"diq-you",
        layout:{
          "text-field":"YOU",
          "text-size":10,
          "text-offset":[0,1.8],
          "text-font":["Open Sans Bold","Arial Unicode MS Bold"]
        },
        paint:{
          "text-color":"#b6ffeb",
          "text-halo-color":"#061018",
          "text-halo-width":1.4
        }
      });
    }
  }catch(e){}
}

function setYou(lng,lat){
  if(!mapLoaded || !map){ return; }
  ensureMapSources();
  if(!map.getSource("diq-you")){ return; }

  try{
    map.getSource("diq-you").setData(pointFC(lng,lat,{ label:"YOU" }));
    if(map.getLayer("diq-you-halo")){ map.moveLayer("diq-you-halo"); }
    if(map.getLayer("diq-you-dot")){ map.moveLayer("diq-you-dot"); }
    if(map.getLayer("diq-you-label")){ map.moveLayer("diq-you-label"); }
  }catch(e){}
}

function clearDestPin(){
  removeLayer("diq-dest-label");
  removeLayer("diq-dest-core");
  removeLayer("diq-dest-halo");
  removeSource("diq-dest");
}

function drawDestPin(){
  if(!mapLoaded || !map || !dest){ return; }

  clearDestPin();

  try{
    map.addSource("diq-dest",{ type:"geojson", data:pointFC(dest.lng,dest.lat,{ label:"DEST" }) });

    map.addLayer({
      id:"diq-dest-halo",
      type:"circle",
      source:"diq-dest",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],8,16,14,28,18,40],
        "circle-color":"#00e5ff",
        "circle-opacity":0.22,
        "circle-blur":1
      }
    });

    map.addLayer({
      id:"diq-dest-core",
      type:"circle",
      source:"diq-dest",
      paint:{
        "circle-radius":["interpolate",["linear"],["zoom"],8,7,14,10,18,14],
        "circle-color":"#00e5ff",
        "circle-stroke-color":"#061018",
        "circle-stroke-width":4,
        "circle-opacity":1
      }
    });

    map.addLayer({
      id:"diq-dest-label",
      type:"symbol",
      source:"diq-dest",
      layout:{
        "text-field":"DEST",
        "text-size":10,
        "text-offset":[0,1.8],
        "text-font":["Open Sans Bold","Arial Unicode MS Bold"]
      },
      paint:{
        "text-color":"#d9fbff",
        "text-halo-color":"#061018",
        "text-halo-width":1.4
      }
    });
  }catch(e){}
}

function clearRouteLine(){
  removeLayer("diq-route-line");
  removeLayer("diq-route-glow");
  removeSource("diq-route");
}

function drawRoute(fc){
  if(!mapLoaded || !map || !fc){ return; }

  clearRouteLine();

  try{
    map.addSource("diq-route",{ type:"geojson", data:fc, lineMetrics:true });

    map.addLayer({
      id:"diq-route-glow",
      type:"line",
      source:"diq-route",
      layout:{ "line-cap":"round", "line-join":"round" },
      paint:{
        "line-color":"#00e5ff",
        "line-width":22,
        "line-opacity":0.32
      }
    });

    map.addLayer({
      id:"diq-route-line",
      type:"line",
      source:"diq-route",
      layout:{ "line-cap":"round", "line-join":"round" },
      paint:{
        "line-gradient":["interpolate",["linear"],["line-progress"],0,"#28ffbe",0.55,"#00e5ff",1,"#ffffff"],
        "line-width":["interpolate",["linear"],["zoom"],8,5,13,7,17,9],
        "line-opacity":0.98
      }
    });
  }catch(e){}

  drawDestPin();
  fitRoute();
}

function flyTo(lng,lat,zoom){
  if(!mapLoaded || !map){ return; }
  try{
    map.easeTo({
      center:[Number(lng),Number(lat)],
      zoom:Number(zoom || 14),
      duration:700,
      essential:true
    });
  }catch(e){}
}

function flattenRouteCoords(geometry){
  var out = [];
  var coords;
  var i;
  var j;

  if(!geometry){ return out; }

  coords = geometry.coordinates || [];

  if(geometry.type === "LineString"){
    for(i=0;i<coords.length;i++){
      if(coords[i] && coords[i].length >= 2){ out.push(coords[i]); }
    }
  }else if(geometry.type === "MultiLineString"){
    for(i=0;i<coords.length;i++){
      for(j=0;j<coords[i].length;j++){
        if(coords[i][j] && coords[i][j].length >= 2){ out.push(coords[i][j]); }
      }
    }
  }

  return out;
}

function getActiveRouteFeature(){
  var saved;
  var sourceData;

  if(routeGeo && routeGeo.features && routeGeo.features.length){
    return routeGeo.features[0];
  }

  saved = safeParse(lsGet(LS.ROUTE_GEO));
  if(saved && saved.features && saved.features.length){
    routeGeo = saved;
    routeReady = true;
    return saved.features[0];
  }

  try{
    if(map && map.getSource && map.getSource("diq-route") && map.getSource("diq-route")._data){
      sourceData = map.getSource("diq-route")._data;
      if(sourceData && sourceData.features && sourceData.features.length){
        routeGeo = sourceData;
        routeReady = true;
        return sourceData.features[0];
      }
    }
  }catch(e){}

  return null;
}

function fitRoute(){
  var feature;
  var coords;
  var bounds;
  var i;
  var vh;

  if(!mapLoaded || !map || !window.mapboxgl){ return false; }

  feature = getActiveRouteFeature();
  if(!feature || !feature.geometry){ return false; }

  coords = flattenRouteCoords(feature.geometry);
  if(!coords.length){ return false; }

  try{
    bounds = new mapboxgl.LngLatBounds(coords[0],coords[0]);

    for(i=1;i<coords.length;i++){
      bounds.extend(coords[i]);
    }

    if(lastFix && finite(Number(lastFix.lng)) && finite(Number(lastFix.lat))){
      bounds.extend([Number(lastFix.lng),Number(lastFix.lat)]);
    }

    if(dest && finite(Number(dest.lng)) && finite(Number(dest.lat))){
      bounds.extend([Number(dest.lng),Number(dest.lat)]);
    }

    vh = window.innerHeight || 844;

    map.fitBounds(bounds,{
      padding:{
        top:Math.round(Math.max(210,vh * .30)),
        right:48,
        bottom:Math.round(Math.max(240,vh * .33)),
        left:48
      },
      duration:950,
      maxZoom:13.25,
      essential:true
    });

    return true;
  }catch(e){}

  return false;
}

function centerMap(){
  var didFit;

  didFit = fitRoute();

  if(didFit){
    setIntel("CENTERED","green");
    subline("Route centered • Start Drive when ready");
    toast("Route centered");
    return;
  }

  if(dest && finite(Number(dest.lng)) && finite(Number(dest.lat))){
    flyTo(dest.lng,dest.lat,15);
    setIntel("DEST CENTER","green");
    toast("Destination centered");
    return;
  }

  if(lastFix && finite(Number(lastFix.lng)) && finite(Number(lastFix.lat))){
    flyTo(lastFix.lng,lastFix.lat,15.5);
    setIntel("GPS CENTER","green");
    toast("GPS centered");
    return;
  }

  toast("No GPS yet");
  requestGPS(true);
}

function looksAddress(q){
  var s = clean(q).toLowerCase();
  if(/^\d{2,}\s+[a-z0-9]/i.test(s)){ return true; }
  return /\d/.test(s) && /\b(st|street|rd|road|ave|avenue|blvd|boulevard|dr|drive|ln|lane|ct|court|cir|circle|pkwy|parkway|hwy|highway|way|pl|place|trl|trail)\b/i.test(s);
}

function kindForFeature(p,q){
  var rt = String(p.result_type || "").toLowerCase();
  var txt = String((p.name || "") + " " + (p.formatted || "")).toLowerCase();

  if(looksAddress(q) || rt === "building" || rt === "street"){ return "Address"; }
  if(rt === "city" || rt === "postcode" || rt === "county" || rt === "state"){ return "Area"; }
  if(txt.indexOf("airport") > -1){ return "Airport"; }
  if(txt.indexOf("hotel") > -1){ return "Hotel"; }
  if(txt.indexOf("restaurant") > -1 || txt.indexOf("food") > -1){ return "Food"; }
  if(txt.indexOf("school") > -1){ return "School"; }
  if(txt.indexOf("park") > -1){ return "Park"; }
  return "Place";
}

function normalizeFeature(feature,q){
  var p;
  var lat;
  var lng;
  var label;
  var full;
  var item;

  if(!feature || !feature.properties){ return null; }

  p = feature.properties;
  lat = Number(p.lat);
  lng = Number(p.lon);

  if(!finite(lat) || !finite(lng)){ return null; }

  label = String(p.name || p.address_line1 || p.formatted || q || "Destination");
  full = String(p.formatted || p.address_line2 || "");

  item = {
    label:label,
    full:full,
    lat:lat,
    lng:lng,
    kind:kindForFeature(p,q),
    distMiles:null
  };

  if(lastFix){
    item.distMiles = miles(lastFix.lat,lastFix.lng,lat,lng);
  }

  return item;
}

function scoreItem(item,q){
  var score = 0;
  var query = clean(q).toLowerCase();
  var label = clean(item && item.label).toLowerCase();
  var txt = String((item.label || "") + " " + (item.full || "")).toLowerCase();
  var addressQuery = looksAddress(q);

  if(query && label === query){ score += 320; }
  else if(query && label.indexOf(query) === 0){ score += 235; }
  else if(query && txt.indexOf(query) > -1){ score += 150; }

  if(addressQuery){
    if(item.kind === "Address"){ score += 280; }
    else{ score -= 90; }
  }else{
    /* A trip destination such as "Panama City Beach" should beat
       "Panama Circle" even when that street is physically closer. */
    if(item.kind === "Area"){ score += 210; }
    else if(item.kind === "Place"){ score += 125; }
    else if(item.kind === "Address"){ score -= 55; }
  }

  if(finite(item.distMiles) && addressQuery){
    if(item.distMiles < 3){ score += 55; }
    else if(item.distMiles < 10){ score += 35; }
    else if(item.distMiles < 25){ score += 18; }
    else{ score -= Math.min(45,Math.round(item.distMiles / 12)); }
  }

  return score;
}

function dedupe(items){
  var seen = {};
  var out = [];
  var i;
  var item;
  var key;

  for(i=0;i<items.length;i++){
    item = items[i];
    if(!item){ continue; }
    key = String(Number(item.lat).toFixed(5)) + "," + String(Number(item.lng).toFixed(5)) + "|" + String(item.label || "").toLowerCase();
    if(seen[key]){ continue; }
    seen[key] = true;
    out.push(item);
  }

  return out;
}

function geoUrl(query,mode){
  var url = "https://api.geoapify.com/v1/geocode/" + mode +
    "?text=" + encodeURIComponent(query) +
    "&limit=10&format=geojson&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);

  /* Destination planning is global. Do not let current GPS pull a city search
     toward similarly named nearby streets. Keep proximity bias for explicit
     street-address searches where it is actually useful. */
  if(lastFix && looksAddress(query)){
    url += "&bias=proximity:" + encodeURIComponent(String(lastFix.lng)) + "," + encodeURIComponent(String(lastFix.lat));
  }

  return url;
}

function clearResults(){
  var box = byId("diqResults");
  if(!box){ return; }
  box.style.display = "none";
  box.innerHTML = "";
  box.__items = [];
}

function showResults(items){
  var box = byId("diqResults");
  var html = "";
  var i;
  var item;
  var dist;
  var nodes;

  if(!box){ return; }

  if(!items || !items.length){
    box.style.display = "block";
    box.innerHTML = '<div class="diqResultItem"><div class="diqResultTitle">No strong matches yet</div><div class="diqResultSub">Try a full address, city, business, store, school, hotel, airport, or restaurant.</div></div>';
    return;
  }

  for(i=0;i<items.length;i++){
    item = items[i];
    dist = finite(item.distMiles) ? fmtMiles(item.distMiles) + " from you" : "Route-ready";
    html += '<div class="diqResultItem" data-index="' + String(i) + '">' +
      '<div class="diqResultTop">' +
        '<div class="diqResultTitle">' + esc(item.label) + '</div>' +
        '<div class="diqResultBadge">' + esc(item.kind || "Place") + '</div>' +
      '</div>' +
      '<div class="diqResultSub">' + esc(dist + (item.full ? " • " + item.full : "")) + '</div>' +
    '</div>';
  }

  box.__items = items;
  box.innerHTML = html;
  box.style.display = "block";

  nodes = box.querySelectorAll(".diqResultItem");
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(){
      var index = Number(this.getAttribute("data-index"));
      var picked = box.__items && box.__items[index];
      if(picked){ chooseDestination(picked); }
    };
  }
}

function geocode(q){
  var query = clean(q);
  var urls;
  var all = [];
  var done = 0;

  destinationSearchToken += 1;
  var requestToken = destinationSearchToken;
  if(!query || query.length < 2){ clearResults(); return; }

  if(!GEOAPIFY_KEY){
    setIntel("NO GEO KEY","red");
    toast("Missing Geoapify key");
    return;
  }

  setIntel("SEARCHING","blue");

  urls = [geoUrl(query,"autocomplete"),geoUrl(query,"search")];

  function finish(){
    var scored;
    done += 1;

    if(done < urls.length || requestToken !== destinationSearchToken){ return; }

    all = dedupe(all);
    scored = all.sort(function(a,b){ return scoreItem(b,query) - scoreItem(a,query); });

    showResults(scored.slice(0,8));

    if(scored.length){ setIntel("RESULTS","green"); }
    else{ setIntel("NO MATCH","gold"); }
  }

  function fetchUrl(url){
    try{
      fetch(url)
        .then(function(res){ return res.json(); })
        .then(function(data){
          var features = data && data.features ? data.features : [];
          var i;
          var item;

          for(i=0;i<features.length;i++){
            item = normalizeFeature(features[i],query);
            if(item){ all.push(item); }
          }

          finish();
        })
        .catch(function(){ finish(); });
    }catch(e){ finish(); }
  }

  fetchUrl(urls[0]);
  fetchUrl(urls[1]);
}

function chooseDestination(item){
  var input = byId("diqDestInput");

  /* V16.2: new destination invalidates every previous discovery response. */
  destinationSearchToken += 1;
  travelScanToken += 1;
  stopSearchToken += 1;
  travelScanResults = [];
  stopSearchResults = [];
  stopTravelScanLoading();
  clearTravelPins();
  clearTravelChipState();
  clearFoodChipState();
  closeFoodIQPanel();
  closeTravelInfoCard();
  try{ renderPlaceIQDeck([],"preview"); }catch(e){}

  dest = {
    label:String(item.label || "Destination"),
    full:String(item.full || ""),
    lat:Number(item.lat),
    lng:Number(item.lng),
    kind:String(item.kind || "Place")
  };

  routeGeo = null;
  routeReady = false;

  lsJSON(LS.DEST,dest);
  try{ var plan = loadTripBuilder(); plan.destination = dest; plan.tripStyle = selectedTripStylePayload(); saveTripBuilder(plan); syncTravelTripStyleUI(); }catch(e){}
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);

  if(input){ input.value = dest.label; }

  clearResults();
  clearStopSearchResults();
  clearRouteLine();
  drawDestPin();
  updateRoutePanel(null);

  manualTravelScanScope = "near_destination";
  updateTravelScanScope();

  /* V16.1: once a destination is chosen, Search Any Stop should agree with
     the Travel Scan context instead of still highlighting Around Me. */
  stopSearchScope = "near_destination";
  syncStopSearchScope();

  setIntel("DEST SET","green");
  subline("Destination saved • Plan trip or scan Place IQ");
  toast("Destination selected");

  flyTo(dest.lng,dest.lat,15.2);
}

function acceptFix(pos,center){
  var c = pos && pos.coords ? pos.coords : {};
  var lat = Number(c.latitude);
  var lng = Number(c.longitude);

  if(!finite(lat) || !finite(lng)){ return false; }

  lastFix = {
    lat:lat,
    lng:lng,
    acc:Number(c.accuracy || 0),
    ts:Date.now(),
    heading:finite(Number(c.heading)) ? Number(c.heading) : null,
    speed:finite(Number(c.speed)) ? Number(c.speed) : 0
  };

  lsJSON(LS.LAST_FIX,lastFix);

  setGps("GPS LOCKED","green");
  updateTravelScanScope();
  setIntel(routeReady ? "ROUTE READY" : (dest ? "DEST SET" : "SEARCH READY"), routeReady ? "green" : (dest ? "green" : "blue"));

  setYou(lng,lat);

  if(center){ flyTo(lng,lat,15.5); }

  return true;
}

function requestGPS(center){
  if(!navigator || !navigator.geolocation){
    setGps("GPS NONE","red");
    setIntel("GPS NEEDED","red");
    toast("GPS unavailable");
    return false;
  }

  setGps("LOCATING GPS","blue");

  try{
    navigator.geolocation.getCurrentPosition(
      function(pos){ acceptFix(pos,!!center); },
      function(){
        if(!lastFix){
          setGps("GPS BLOCKED","red");
          setIntel("ENABLE GPS","red");
          toast("Enable location for GPS pin");
        }
      },
      { enableHighAccuracy:true, timeout:18000, maximumAge:0 }
    );

    if(!gpsWatchId){
      gpsWatchId = navigator.geolocation.watchPosition(
        function(pos){ acceptFix(pos,false); },
        function(){},
        { enableHighAccuracy:true, timeout:22000, maximumAge:5000 }
      );
    }
  }catch(e){
    setGps("GPS ERROR","red");
    return false;
  }

  return true;
}

function restoreGPS(){
  var saved = safeParse(lsGet(LS.LAST_FIX));

  if(saved && finite(Number(saved.lat)) && finite(Number(saved.lng))){
    lastFix = {
      lat:Number(saved.lat),
      lng:Number(saved.lng),
      acc:Number(saved.acc || 0),
      ts:Number(saved.ts || 0),
      heading:finite(Number(saved.heading)) ? Number(saved.heading) : null,
      speed:finite(Number(saved.speed)) ? Number(saved.speed) : 0
    };

    setGps("GPS SAVED","green");
    setYou(lastFix.lng,lastFix.lat);
  }

  requestGPS(!lastFix);
}

function buildRoute(){
  var waypoints;
  var url;

  if(!dest){
    toast("Choose a destination first");
    setIntel("NEED DEST","gold");
    return;
  }

  if(!lastFix){
    toast("Lock GPS first");
    setIntel("NEED GPS","gold");
    requestGPS(true);
    return;
  }

  if(!GEOAPIFY_KEY){
    toast("Missing Geoapify key");
    setIntel("NO GEO KEY","red");
    return;
  }

  waypoints = String(lastFix.lat) + "," + String(lastFix.lng) + "|" + String(dest.lat) + "," + String(dest.lng);

  url = "https://api.geoapify.com/v1/routing?waypoints=" +
    encodeURIComponent(waypoints) +
    "&mode=drive&details=instruction_details&format=geojson&apiKey=" +
    encodeURIComponent(GEOAPIFY_KEY);

  setIntel("ROUTING","blue");
  subline("Building route…");

  try{
    fetch(url)
      .then(function(res){ return res.json(); })
      .then(function(data){ handleRoute(data); })
      .catch(function(){
        setIntel("ROUTE FAIL","red");
        toast("Route failed");
      });
  }catch(e){
    setIntel("ROUTE FAIL","red");
  }
}


function firstFiniteNumber(list){
  var i;
  var n;
  for(i=0;i<list.length;i++){
    n = Number(list[i]);
    if(finite(n) && n > 0){ return n; }
  }
  return 0;
}

function normalizeDurationSeconds(v){
  var n = Number(v);
  if(!finite(n) || n <= 0){ return 0; }
  if(n > 604800){ n = n / 1000; }
  return n;
}

function routeDurationSecondsFromFeature(feature){
  var p = feature && feature.properties ? feature.properties : {};
  var candidates = [];
  var legs = p.legs || p.route_legs || [];
  var segs = p.segments || [];
  var i;

  candidates.push(p.time);
  candidates.push(p.duration);
  candidates.push(p.durationSeconds);
  candidates.push(p.duration_seconds);
  candidates.push(p.travel_time);
  candidates.push(p.travelTime);

  for(i=0;i<legs.length;i++){
    if(legs[i]){
      candidates.push(legs[i].time);
      candidates.push(legs[i].duration);
      candidates.push(legs[i].durationSeconds);
      candidates.push(legs[i].duration_seconds);
    }
  }

  for(i=0;i<segs.length;i++){
    if(segs[i]){
      candidates.push(segs[i].time);
      candidates.push(segs[i].duration);
      candidates.push(segs[i].durationSeconds);
      candidates.push(segs[i].duration_seconds);
    }
  }

  return normalizeDurationSeconds(firstFiniteNumber(candidates));
}

function routeDistanceMetersFromFeature(feature){
  var p = feature && feature.properties ? feature.properties : {};
  var candidates = [];
  var legs = p.legs || p.route_legs || [];
  var segs = p.segments || [];
  var i;
  var sum = 0;

  candidates.push(p.distance);
  candidates.push(p.distanceMeters);
  candidates.push(p.distance_meters);
  candidates.push(p.length);
  candidates.push(p.length_meters);

  for(i=0;i<legs.length;i++){
    if(legs[i]){
      candidates.push(legs[i].distance);
      candidates.push(legs[i].distanceMeters);
      candidates.push(legs[i].distance_meters);
    }
  }

  for(i=0;i<segs.length;i++){
    if(segs[i]){
      sum += firstFiniteNumber([segs[i].distance,segs[i].distanceMeters,segs[i].distance_meters]);
    }
  }
  if(sum > 0){ candidates.push(sum); }

  return firstFiniteNumber(candidates);
}

function estimateDurationFromDistanceMeters(distanceMeters){
  var mi = Number(distanceMeters || 0) * 0.000621371;
  var mph = 58;
  if(mi < 5){ mph = 28; }
  else if(mi < 25){ mph = 42; }
  else if(mi < 90){ mph = 55; }
  else { mph = 61; }
  if(!finite(mi) || mi <= 0){ return 0; }
  return Math.round((mi / mph) * 3600);
}

function handleRoute(data){
  var features = data && data.features ? data.features : [];
  var feature;
  var props;
  var distanceMeters;
  var durationSeconds;
  var mi;
  var score;
  var intel;

  if(!features.length){
    setIntel("NO ROUTE","red");
    toast("No route found");
    return;
  }

  feature = features[0];
  props = feature.properties || {};
  distanceMeters = routeDistanceMetersFromFeature(feature);
  durationSeconds = routeDurationSecondsFromFeature(feature);
  if(!durationSeconds && distanceMeters){ durationSeconds = estimateDurationFromDistanceMeters(distanceMeters); }
  mi = distanceMeters * 0.000621371;

  score = 92;
  if(mi > 30){ score -= 4; }
  if(mi > 80){ score -= 5; }
  if(mi > 180){ score -= 6; }
  if(score < 70){ score = 70; }

  feature.properties = feature.properties || {};
  feature.properties.distanceMeters = distanceMeters;
  feature.properties.durationSeconds = durationSeconds;

  routeGeo = routeFC(feature);
  routeReady = true;

  intel = {
    routeScore:score,
    miles:Math.round(mi * 10) / 10,
    durationLabel:fmtTime(durationSeconds),
    destination:dest,
    summary:"Score " + String(score) + " • " + fmtTime(durationSeconds)
  };

  lsJSON(LS.ROUTE_GEO,routeGeo);
  lsJSON(LS.ROUTE_INTEL,intel);
  try{ var plan = loadTripBuilder(); plan.destination = dest; plan.routeGeo = routeGeo; plan.routeIntel = intel; saveTripBuilder(plan); }catch(e){}

  drawRoute(routeGeo);
  updateRoutePanel(intel);

  if(!manualTravelScanScope || manualTravelScanScope === "near_me"){ manualTravelScanScope = "near_destination"; }
  updateTravelScanScope();

  stopSearchScope = "near_destination";
  syncStopSearchScope();

  setIntel("ROUTE READY","green");
  subline("Route ready • Trip plan saved • Start Travel when ready");
  toast("Route ready");
}

function updateRoutePanel(intel){
  var score = byId("diqRouteScore");
  var title = byId("diqRouteTitle");
  var sub = byId("diqRouteSub");

  if(!score || !title || !sub){ return; }

  if(!intel){
    score.textContent = "--";
    title.textContent = dest ? String(dest.label || "Destination selected") : "Choose a destination";
    sub.textContent = dest ? "Tap Route Now to draw the route." : "Your GPS pin, destination pin, and route will appear here.";
    return;
  }

  score.textContent = String(intel.routeScore || "--");
  title.textContent = dest ? String(dest.label || "Route ready") : "Route ready";
  sub.textContent = String(intel.durationLabel || "--") + " • " + String(intel.miles || "--") + " mi • Destination pin locked";
}

function restoreState(){
  var savedDest = safeParse(lsGet(LS.DEST));
  var savedRoute = safeParse(lsGet(LS.ROUTE_GEO));
  var savedIntel = safeParse(lsGet(LS.ROUTE_INTEL));
  var input = byId("diqDestInput");

  restoreTravelTripStyle();
  if(savedDest && finite(Number(savedDest.lat)) && finite(Number(savedDest.lng))){
    dest = savedDest;
    if(input){ input.value = String(dest.label || ""); }
    drawDestPin();
  }

  if(savedRoute && savedRoute.features && savedRoute.features.length){
    routeGeo = savedRoute;
    routeReady = true;
    drawRoute(routeGeo);
  }

  if(dest && !manualTravelScanScope){ manualTravelScanScope = "near_destination"; }
  updateTravelScanScope();
  if(dest){
    stopSearchScope = "near_destination";
    syncStopSearchScope();
  }
  updateRoutePanel(savedIntel || null);
  try{ renderTripBuilderShell(loadTripBuilder()); renderMemoryShell(); }catch(e){}
}

function clearRoute(){
  dest = null;
  routeGeo = null;
  routeReady = false;

  lsRemove(LS.DEST);
  lsRemove(LS.ROUTE_GEO);
  lsRemove(LS.ROUTE_INTEL);
  lsRemove(LS.DRIVE_PAYLOAD);
  lsRemove(LS.DRIVE_ON);

  if(byId("diqDestInput")){ byId("diqDestInput").value = ""; }

  clearResults();
  clearRouteLine();
  clearDestPin();
  updateRoutePanel(null);

  manualTravelScanScope = "";
  closeFoodIQPanel();
  updateTravelScanScope();

  stopSearchScope = "near_me";
  syncStopSearchScope();

  setIntel("READY","green");
  subline("Search destination • Lock GPS • Draw route");
  toast("Cleared");
}

function startDrive(){
  var driveId;

  if(!dest){
    toast("Choose a destination first");
    setIntel("NEED DEST","gold");
    return;
  }

  if(!routeReady || !routeGeo){
    toast("Drawing route first");
    buildRoute();
    return;
  }

  driveId = "diq_" + String(Date.now());

  lsSet(LS.ACTIVE_DRIVE_ID,driveId);
  lsSet(LS.DRIVE_ON,"1");
  lsJSON(LS.DRIVE_PAYLOAD,{
    drive_id:driveId,
    mode:"travel",
    destination:dest,
    route:routeGeo,
    route_intel:safeParse(lsGet(LS.ROUTE_INTEL)),
    trip_builder:loadTripBuilder(),
    started_at:new Date().toISOString()
  });

  setIntel("OPENING","green");
  toast("Opening Drive Mode");

  window.setTimeout(function(){
    window.location.href = DRIVE_MODE_URL;
  },300);
}


function userHasPlusEntitlement(){
  var keys = [
    "diq_plus_active_v1",
    "diq_subscription_active_v1",
    "diq_iap_active_v1",
    "diq_entitled_v1",
    "diq_drive_iq_plus_active",
    "diq_dev_pro_unlocked_v1",
    "diq_founding_driver_free_v1"
  ];
  var i;
  var v;
  for(i=0;i<keys.length;i++){
    v = String(lsGet(keys[i]) || "").toLowerCase();
    if(v === "1" || v === "true" || v === "yes" || v === "active"){ return true; }
  }
  try{
    if(window.DRIVE_IQ_PLUS_ACTIVE === true || window.DRIVE_IQ_IAP_ACTIVE === true || window.DRIVE_IQ_ENTITLED === true){ return true; }
  }catch(e){}
  return false;
}

function normalizeProductId(productId){
  var raw = String(productId || "").toLowerCase();
  if(raw.indexOf("year") > -1 || raw.indexOf("annual") > -1){
    return "com.loveforlocals.driveiq.plus.yearly";
  }
  return "com.loveforlocals.driveiq.plus.monthly";
}

function applePurchasePayload(productId,source){
  var pid = normalizeProductId(productId);
  return {
    type:"DRIVE_IQ_PURCHASE",
    action:"purchase",
    command:"purchase",
    source:String(source || "travel_mode"),
    product_id:pid,
    productId:pid,
    sku:pid,
    id:pid,
    mode:"travel",
    ts:new Date().toISOString()
  };
}

function postToNativeHandler(name,payload){
  try{
    if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers[name] && window.webkit.messageHandlers[name].postMessage){
      window.webkit.messageHandlers[name].postMessage(payload);
      return true;
    }
  }catch(e){}
  return false;
}

function fireApplePurchaseSheet(productId,source){
  var payload = applePurchasePayload(productId,source);
  var fired = false;
  var handlers = [
    "driveIQPurchase",
    "driveIQIAP",
    "driveIQStoreKit",
    "storeKit",
    "purchase",
    "iap",
    "nativePurchase",
    "subscriptions",
    "driveIQPlus"
  ];
  var i;

  lsJSON(LS.UPGRADE_INTENT,payload);
  try{ window.DRIVE_IQ_LAST_PURCHASE_INTENT = payload; }catch(e0){}

  for(i=0;i<handlers.length;i++){
    if(postToNativeHandler(handlers[i],payload)){ fired = true; }
  }

  try{
    if(window.webkit && window.webkit.messageHandlers && window.webkit.messageHandlers.slx && window.webkit.messageHandlers.slx.postMessage){
      window.webkit.messageHandlers.slx.postMessage({
        action:"purchase",
        command:"purchase",
        type:"DRIVE_IQ_PURCHASE",
        source:payload.source,
        product_id:payload.product_id,
        productId:payload.productId,
        payload:payload
      });
      fired = true;
    }
  }catch(e1){}

  try{
    if(window.DriveIQNative && typeof window.DriveIQNative.purchaseProduct === "function"){
      window.DriveIQNative.purchaseProduct(payload.product_id);
      fired = true;
    }
  }catch(e2){}

  try{
    if(window.Capacitor && window.Capacitor.Plugins && window.Capacitor.Plugins.Purchases && typeof window.Capacitor.Plugins.Purchases.purchaseProduct === "function"){
      window.Capacitor.Plugins.Purchases.purchaseProduct({ productIdentifier:payload.product_id });
      fired = true;
    }
  }catch(e3){}

  try{
    window.dispatchEvent(new CustomEvent("driveiq:purchase",{
      detail:payload
    }));
  }catch(e4){}

  return fired;
}

function openUpgradeSheet(){
  var sheet = byId("diqUpgradeSheet");

  if(userHasPlusEntitlement()){
    toast("Drive IQ Plus active");
    setIntel("PLUS ACTIVE","green");
    subline("Drive IQ Plus is active");
    return;
  }

  if(sheet){ sheet.className = "diqUpgradeSheet on"; }

  /*
    Travel Mode should also ask the native iOS shell to open the Apple
    purchase sheet immediately when the user taps Upgrade. The web sheet
    stays as a fallback/chooser if the native bridge is unavailable.
  */
  if(fireApplePurchaseSheet("com.loveforlocals.driveiq.plus.monthly","travel_upgrade_button")){
    toast("Opening Apple sheet");
    setIntel("APPLE SHEET","gold");
    subline("Opening Drive IQ Plus purchase sheet");
  }else{
    toast("Drive IQ Plus");
    setIntel("PLUS READY","gold");
    subline("Choose Monthly or Yearly to continue");
  }
}

function closeUpgradeSheet(){
  var sheet = byId("diqUpgradeSheet");
  if(sheet){ sheet.className = "diqUpgradeSheet"; }
}

function beginUpgrade(productId){
  var pid = normalizeProductId(productId);

  if(userHasPlusEntitlement()){
    toast("Drive IQ Plus active");
    setIntel("PLUS ACTIVE","green");
    subline("Drive IQ Plus is active");
    closeUpgradeSheet();
    return;
  }

  if(fireApplePurchaseSheet(pid,"travel_plus_button")){
    toast("Opening Apple sheet");
    setIntel("APPLE SHEET","gold");
    subline("Opening Drive IQ Plus purchase sheet");
  }else{
    toast("Purchase bridge not detected");
    setIntel("BRIDGE READY","gold");
    subline("Purchase intent saved • rebuild native app if Apple sheet does not appear");
  }
}


function shellSafeBack(){
  try{
    if(window.webkit && window.webkit.messageHandlers){
      if(window.webkit.messageHandlers.driveIQBack && window.webkit.messageHandlers.driveIQBack.postMessage){
        window.webkit.messageHandlers.driveIQBack.postMessage({ type:"BACK_TO_DRIVE_IQ_HOME", source:"travel", url:TRAVEL_HOME_URL });
        return false;
      }
      if(window.webkit.messageHandlers.slx && window.webkit.messageHandlers.slx.postMessage){
        window.webkit.messageHandlers.slx.postMessage({ action:"navigate", url:TRAVEL_HOME_URL, source:"travel_back" });
      }
    }
  }catch(e1){}
  try{ window.location.replace(TRAVEL_HOME_URL); }
  catch(e2){ try{ window.location.href = TRAVEL_HOME_URL; }catch(e3){} }
  return false;
}

function isTravelBackTarget(el){
  var node = el;
  var count = 0;
  while(node && count < 6){
    if(node.id === "travelBackBtn" || node.id === "diqTravelBack" || node.id === "diqBack" || node.id === "driveIqBack"){ return true; }
    if(node.getAttribute){
      if(node.getAttribute("data-diq-shell-back") === "1" || node.getAttribute("data-diq-back") === "1" || node.getAttribute("data-travel-back") === "1"){ return true; }
      if(String(node.className || "").indexOf("diqBack") > -1 || String(node.className || "").indexOf("travelBack") > -1){ return true; }
    }
    node = node.parentNode;
    count += 1;
  }
  return false;
}

function bindShellBack(){
  var nodes;
  var i;
  var selectors = ["#travelBackBtn","#diqTravelBack","#diqBack","#driveIqBack",".diqBack",".travelBack","[data-diq-shell-back]","[data-diq-back]","[data-travel-back]"];
  for(i=0;i<selectors.length;i++){
    try{
      nodes = document.querySelectorAll(selectors[i]);
      for(var j=0;j<nodes.length;j++){
        nodes[j].onclick = function(e){
          if(e && e.preventDefault){ e.preventDefault(); }
          if(e && e.stopPropagation){ e.stopPropagation(); }
          return shellSafeBack();
        };
      }
    }catch(e1){}
  }
  try{
    document.addEventListener("click",function(e){
      if(e && isTravelBackTarget(e.target)){
        if(e.preventDefault){ e.preventDefault(); }
        if(e.stopImmediatePropagation){ e.stopImmediatePropagation(); }
        else if(e.stopPropagation){ e.stopPropagation(); }
        shellSafeBack();
        return false;
      }
      return true;
    },true);
  }catch(e2){}
}


function normText(v){
  return String(v || "").toLowerCase().replace(/[^a-z0-9]+/g," ").replace(/\s+/g," ").trim();
}

function titleCase(text){
  var s = clean(text);
  if(!s){ return ""; }
  return s.replace(/\w\S*/g,function(w){
    if(w.length <= 2){ return w.toUpperCase(); }
    return w.charAt(0).toUpperCase() + w.substr(1).toLowerCase();
  });
}

function isAddressLikeName(name){
  var s = clean(name);
  if(!s){ return true; }
  return /^\d{2,}\s+[A-Za-z0-9]/.test(s) ||
    (/^\d/.test(s) && /\b(st|street|rd|road|ave|avenue|blvd|boulevard|dr|drive|ln|lane|ct|court|cir|circle|pkwy|parkway|hwy|highway|way)\b/i.test(s));
}

function placeDisplayName(item){
  var name = clean(item && (item.name || item.label || item.title));
  var alt = clean(item && (item.placeName || item.businessName));
  var fallback = clean(item && item.full);
  if(name && !isAddressLikeName(name)){ return name; }
  if(alt && !isAddressLikeName(alt)){ return alt; }
  if(fallback && !isAddressLikeName(fallback)){ return fallback.split(",")[0]; }
  return name || alt || "Place IQ Stop";
}

function categoryEmoji(cat){
  cat = String(cat || "").toLowerCase();
  if(cat.indexOf("hotel") > -1 || cat.indexOf("lodging") > -1){ return "🏨"; }
  if(cat.indexOf("coffee") > -1 || cat.indexOf("cafe") > -1){ return "☕"; }
  if(cat.indexOf("food") > -1 || cat.indexOf("restaurant") > -1 || cat.indexOf("dinner") > -1){ return "🍔"; }
  if(cat.indexOf("family") > -1 || cat.indexOf("attraction") > -1){ return "👨‍👩‍👧"; }
  if(cat.indexOf("shopping") > -1){ return "🛍️"; }
  if(cat.indexOf("popular") > -1 || cat.indexOf("night") > -1 || cat.indexOf("bar") > -1){ return "🌙"; }
  if(cat.indexOf("golf") > -1){ return "⛳"; }
  if(cat.indexOf("wine") > -1){ return "🍷"; }
  if(cat.indexOf("local") > -1 || cat.indexOf("hidden") > -1){ return "🏆"; }
  if(cat.indexOf("beach") > -1 || cat.indexOf("scenic") > -1){ return "🏖️"; }
  if(cat.indexOf("fuel") > -1){ return "⛽"; }
  if(cat.indexOf("parking") > -1){ return "🅿️"; }
  return "📍";
}

function placeIQCategoryLabel(cat){
  cat = String(cat || "").toLowerCase();
  if(cat === "preview"){ return "Top Picks"; }
  if(cat === "popular" || cat === "popular_tonight" || cat === "nightlife"){ return "Popular Tonight"; }
  if(cat === "live_music"){ return "Live Music"; }
  if(cat === "golf_trip"){ return "Golf Trip"; }
  if(cat === "food_wine"){ return "Food & Wine"; }
  if(cat === "waterfront"){ return "Waterfront"; }
  if(cat === "patio"){ return "Patio"; }
  if(cat === "hidden_gems"){ return "Hidden Gems"; }
  if(cat === "scenic"){ return "Scenic IQ"; }
  if(cat === "local" || cat === "local_picks"){ return "Local Picks"; }
  if(cat === "hotels"){ return "Hotel IQ"; }
  if(cat === "family"){ return "Family IQ"; }
  if(cat === "shopping"){ return "Local Shopping"; }
  if(cat === "food" || isFoodIQCat(cat)){ return "Food IQ"; }
  if(cat === "coffee"){ return "Coffee IQ"; }
  if(cat === "beach"){ return "Beach IQ"; }
  if(cat === "attractions"){ return "Worth the Drive"; }
  return titleCase(cat || "Place IQ");
}

function placeIQBadge(item,cat){
  var text = normText((item && (item.label || item.full || item.category || item.kind)) || "");
  cat = String(cat || "").toLowerCase();
  if(cat === "popular" || cat === "popular_tonight" || cat === "nightlife"){ return "🌙 POPULAR TONIGHT"; }
  if(cat === "live_music"){ return "🎵 LIVE / VENUE"; }
  if(cat === "golf_trip"){ return "⛳ GOLF STOP"; }
  if(cat === "food_wine"){ return "🍷 FOOD & WINE"; }
  if(cat === "waterfront"){ return "🌊 WATERFRONT"; }
  if(cat === "patio"){ return "🍺 PATIO / OUTDOOR"; }
  if(cat === "hidden_gems"){ return "🏆 HIDDEN GEM"; }
  if(cat === "scenic"){ return "🌅 SCENIC IQ"; }
  if(cat === "local" || cat === "local_picks"){ return "🏆 LOCAL PICK"; }
  if(cat === "hotels"){
    if(text.indexOf("drury") > -1 || text.indexOf("hampton") > -1 || text.indexOf("holiday inn") > -1 || text.indexOf("marriott") > -1 || text.indexOf("hilton") > -1){ return "🏨 BEST OVERNIGHT"; }
    return "🏨 STAY HERE";
  }
  if(cat === "family"){ return "👨‍👩‍👧 FAMILY FAVORITE"; }
  if(cat === "shopping"){ return "🛍️ LOCAL FIND"; }
  if(cat === "coffee" || cat === "food_cafe"){ return "☕ MORNING FAVORITE"; }
  if(cat === "beach"){ return "🏖️ WORTH THE VIEW"; }
  if(cat === "attractions"){ return "🔥 WORTH THE DRIVE"; }
  if(cat === "food_local"){ return "🏆 LOCAL FAVORITE"; }
  if(cat === "food_quick"){ return "⚡ QUICK BITE"; }
  if(cat === "food_family"){ return "👨‍👩‍👧 FAMILY FRIENDLY"; }
  if(cat === "food_seafood"){ return "🦐 SEAFOOD PICK"; }
  if(cat === "food_dessert"){ return "🍦 SWEET STOP"; }
  if(cat === "food_dinner"){ return "🍽️ DINNER PICK"; }
  if(cat === "food_bbq"){ return "🔥 BBQ TRAIL"; }
  if(cat === "food_breakfast"){ return "🍳 BREAKFAST PICK"; }
  return "⭐ WORTH THE STOP";
}

function placeIQWhy(item,cat){
  var text = normText(placeDisplayName(item) + " " + (item && item.full ? item.full : ""));
  cat = String(cat || "").toLowerCase();
  if(cat === "popular" || cat === "popular_tonight" || cat === "nightlife"){ return "A traveler-friendly social stop with food, local energy, and an easy evening vibe."; }
  if(cat === "live_music"){ return "A venue-style stop that may have music, nightlife, or local energy worth checking before you go."; }
  if(cat === "golf_trip"){ return "A golf-focused stop for tee times, practice, clubhouse meals, or a group trip anchor."; }
  if(cat === "food_wine"){ return "A food-and-drink stop for wineries, breweries, cocktail lounges, or memorable local dining."; }
  if(cat === "waterfront"){ return "A water-view stop that can make the route feel more memorable than just getting there."; }
  if(cat === "patio"){ return "A good outdoor/seating stop when the vibe matters as much as the destination."; }
  if(cat === "hidden_gems"){ return "A less-obvious local discovery that feels more memorable than a generic near-me result."; }
  if(cat === "scenic"){ return "A photo-worthy or relaxing stop that adds a little adventure to the drive."; }
  if(cat === "local" || cat === "local_picks"){ return "A stronger local-style pick when you want something that feels less touristy."; }
  if(cat === "hotels"){
    if(text.indexOf("drury") > -1){ return "Reliable overnight pick with strong traveler appeal, easy access, and family-friendly value."; }
    return "A practical overnight option near your route or destination.";
  }
  if(cat === "family"){ return "A family-friendly stop that gives kids something better to do than just sit in the car."; }
  if(cat === "shopping"){ return "Useful for local finds, outlets, gifts, or a quick browse near your trip."; }
  if(cat === "coffee" || cat === "food_cafe"){ return "Good for a quick reset, coffee stop, or morning travel break."; }
  if(cat === "beach" || cat === "attractions"){ return "A memorable stop when you want the trip to feel like more than just the drive."; }
  if(cat === "food" || isFoodIQCat(cat)){ return "A stronger food stop based on route fit, category match, and travel usefulness."; }
  return "A useful stop that fits your trip without making you dig through endless listings.";
}

function placeIQScore(item,cat){
  var score = 72;
  var rating = Number(item && item.rating);
  var reviews = Number(item && (item.reviews || item.reviewCount || item.user_ratings_total));
  var dist = Number(item && (item.centerMiles || item.distMiles));
  var text = normText(placeDisplayName(item) + " " + (item && item.full ? item.full : "") + " " + (item && item.sourceQuery ? item.sourceQuery : ""));
  if(finite(rating)){ score += Math.round((rating - 3.8) * 12); }
  if(finite(reviews)){
    if(reviews > 1500){ score += 10; }
    else if(reviews > 500){ score += 7; }
    else if(reviews > 100){ score += 4; }
  }
  if(finite(dist)){
    if(dist <= 0.25){ score += 13; }
    else if(dist <= 1.5){ score += 9; }
    else if(dist <= 4){ score += 5; }
    else if(dist > 14){ score -= 8; }
  }
  if(item && item.openNow === true){ score += 5; }
  if(isAddressLikeName(placeDisplayName(item))){ score -= 25; }
  score += categoryIntentScore(item,cat);
  score += personalPreferenceBoost(item,cat);
  if(cat === "hotels" && /drury|hampton|holiday inn|marriott|hilton|comfort|la quinta|best western|home2|tru by hilton|hyatt|embassy suites/i.test(text)){ score += 12; }
  if((cat === "popular" || cat === "popular_tonight") && /bar|grill|pub|tap|tavern|sports|patio|brew|music|restaurant/i.test(text)){ score += 11; }
  if((cat === "local" || cat === "local_picks" || cat === "food_local") && /walmart|target|mcdonald|burger king|wendy|subway|taco bell/.test(text)){ score -= 10; }
  score += Math.round(travelStyleScore(item,cat) * 0.32);
  if(score < 45){ score = 45; }
  if(score > 99){ score = 99; }
  return score;
}

function worthStars(score){
  var n = Number(score || 0);
  if(n >= 88){ return "★★★★★"; }
  if(n >= 78){ return "★★★★☆"; }
  return "★★★☆☆";
}

function enrichPlaceIQItem(item,cat){
  if(!item){ return item; }
  item.displayName = placeDisplayName(item);
  item.placeIQBadge = travelStyleFitLabel(item,cat) || placeIQBadge(item,cat);
  item.placeIQWhy = travelStyleWhy(item,cat) || placeIQWhy(item,cat);
  item.placeIQScore = placeIQScore(item,cat);
  item.travelStyleFitScore = travelStyleScore(item,cat);
  item.placeIQStars = worthStars(item.placeIQScore);
  item.placeIQCategory = placeIQCategoryLabel(cat);
  item.placeIQEmoji = categoryEmoji(cat);
  item.isAddressOnly = isAddressLikeName(item.displayName);
  if(item.source === "geoapify_places" || item.source === "google_places"){ travelV165TrustPresentation(item,cat); }
  return item;
}

function finalizePlaceIQResults(items,cat){
  var out = [];
  var i;
  var item;
  if(!items){ return []; }
  for(i=0;i<items.length;i++){
    item = enrichPlaceIQItem(items[i],cat);
    if(item && item.displayName){ out.push(item); }
  }
  out = dedupe(out);
  out.sort(function(a,b){ return Number(b.placeIQScore || 0) - Number(a.placeIQScore || 0); });
  return out.slice(0,8);
}

function getJSONList(key){
  var v = safeParse(lsGet(key));
  return v && v.length ? v : [];
}

function saveFavoriteStop(item){
  var list = getJSONList(LS.FAVORITE_STOPS);
  var key = String((item && (item.place_id || item.id || item.displayName || item.label)) || "").toLowerCase();
  var i;
  if(!item){ return false; }
  for(i=0;i<list.length;i++){
    if(String((list[i].place_id || list[i].id || list[i].displayName || list[i].label) || "").toLowerCase() === key){ return true; }
  }
  list.unshift({ label:item.displayName || item.label, full:item.full || "", lat:item.lat, lng:item.lng, category:item.placeIQCategory || travelScanCategory, badge:item.placeIQBadge || "", score:item.placeIQScore || 0, savedAt:new Date().toISOString() });
  if(list.length > 75){ list = list.slice(0,75); }
  lsJSON(LS.FAVORITE_STOPS,list);
  try{ learnPreferenceFromItem(item,"save"); }catch(e){}
  renderMemoryShell();
  toast("Saved to Favorite Stops");
  return true;
}

function saveDiscoveryDrop(item,rating,tags){
  var list = getJSONList(LS.DISCOVERY_DROPS);
  if(!item){ return false; }
  list.unshift({ label:item.displayName || item.label, full:item.full || "", lat:item.lat, lng:item.lng, rating:Number(rating || 5), tags:tags || [], category:item.placeIQCategory || travelScanCategory, badge:item.placeIQBadge || "", ts:new Date().toISOString() });
  if(list.length > 150){ list = list.slice(0,150); }
  lsJSON(LS.DISCOVERY_DROPS,list);
  toast("Discovery saved");
  return true;
}

function shareDiscovery(item){
  try{ learnPreferenceFromItem(item,"share"); }catch(e){}
  var title = item && (item.displayName || item.label) ? String(item.displayName || item.label) : "Drive IQ Discovery";
  var text = "I found " + title + " with Drive IQ — " + String(item && item.placeIQBadge ? item.placeIQBadge : "Worth the Stop") + ".";
  try{
    if(navigator.share){ navigator.share({ title:"Drive IQ Discovery", text:text }); return true; }
  }catch(e){}
  try{ window.prompt("Copy your Drive IQ discovery:", text); }catch(e2){}
  return false;
}

/* V16.3 Photo IQ: separate image enrichment from destination/route authority.
   A Google photo is attached only after a geographically and textually matched
   place is found and its image loads. No guessed or unrelated photos. */
var travelPhotoCache = {};
var travelPhotoPending = {};
var travelPhotoDiagnostics={keyFound:false,lookups:0,matched:0,loaded:0,failed:0,lastError:""};
function travelPhotoKey(){
  var aliases=["DRIVE_IQ_GOOGLE_PLACES_KEY","DRIVE_IQ_GOOGLE_PLACES_API_KEY","DRIVE_IQ_GOOGLE_MAPS_KEY","DRIVE_IQ_GOOGLE_MAPS_API_KEY","DRIVE_IQ_GOOGLE_API_KEY","DRIVE_IQ_GOOGLE_KEY","DIQ_GOOGLE_KEY","DIQ_GOOGLE_PLACES_KEY","SLX_GOOGLE_KEY","SLX_GOOGLE_MAPS_KEY","SLX_GOOGLE_PLACES_KEY","GOOGLE_MAPS_API_KEY","GOOGLE_PLACES_API_KEY","GOOGLE_API_KEY","GOOGLE_KEY","GOOGLE_MAPS_KEY","GOOGLE_PLACES_KEY"];
  var i,v,nodes,src,match;
  for(i=0;i<aliases.length;i++){
    v=clean(window[aliases[i]] || "");
    if(v && v.length>16 && !/^(undefined|null|YOUR_|REPLACE_|AIza\.{3})/i.test(v)){
      travelPhotoDiagnostics.keyFound=true; return v;
    }
  }
  try{
    nodes=document.querySelectorAll('script[src*="maps.googleapis.com/maps/api/js"],script[src*="places.googleapis.com"],meta[name="google-maps-api-key"],meta[name="google-places-api-key"]');
    for(i=0;i<nodes.length;i++){
      src=String(nodes[i].src || nodes[i].content || "");
      match=src.match(/[?&]key=([^&#]+)/i);
      v=match ? decodeURIComponent(match[1]) : (nodes[i].tagName.toLowerCase()==="meta" ? src : "");
      if(v && v.length>16){ travelPhotoDiagnostics.keyFound=true; return v; }
    }
  }catch(e){}
  return clean(GOOGLE_PLACES_KEY || "");
}
window.DriveIQTravelPhotoStatus=function(){
  var d=travelPhotoDiagnostics;
  return {keyConfigured:!!travelPhotoKey(),proxyConfigured:!!GOOGLE_PLACES_PROXY_URL,
    sdkState:travelGoogleSDKState,lookups:d.lookups,matched:d.matched,loaded:d.loaded,failed:d.failed,lastError:d.lastError};
};
function travelPhotoName(item){ return clean(item && (item.displayName || item.name || item.label) || ""); }
function travelPhotoCacheKey(item){
  return normText(travelPhotoName(item)) + "|" + Number(item.lat).toFixed(3) + "," + Number(item.lng).toFixed(3);
}
function travelPhotoUrlFromRef(ref){
  var key=travelPhotoKey();
  if(!ref){ return ""; }
  if(/^https:\/\//i.test(ref)){ return ref; }
  if(GOOGLE_PLACES_PROXY_URL && ref.indexOf("places/") !== 0){
    return GOOGLE_PLACES_PROXY_URL + "?photo_reference=" + encodeURIComponent(ref) + "&maxwidth=960";
  }
  if(!key){ return ""; }
  if(ref.indexOf("places/") === 0 && ref.indexOf("/photos/") > -1){
    return "https://places.googleapis.com/v1/" + ref + "/media?maxWidthPx=960&key=" + encodeURIComponent(key);
  }
  return "https://maps.googleapis.com/maps/api/place/photo?maxwidth=960&photo_reference=" + encodeURIComponent(ref) + "&key=" + encodeURIComponent(key);
}
function maybeGooglePhotoUrl(item){
  if(!item){ return ""; }
  return clean(item.travelPhotoUrl || item.photoUrl || item.imageUrl ||
    travelPhotoUrlFromRef(item.photo_reference || item.photoReference ||
      item.googlePhotoName || (item.photos && item.photos[0] &&
      (item.photos[0].name || item.photos[0].photo_reference)) || ""));
}
function travelPhotoNameMatches(want,found){
  var a=normText(want), b=normText(found), aa,bb,i,hits=0;
  if(!a || !b){ return false; }
  if(a===b || (a.length>5 && b.indexOf(a)>-1) || (b.length>5 && a.indexOf(b)>-1)){ return true; }
  aa=a.split(" ").filter(function(w){ return w.length>2 && !/^(the|and|for|near|park|place|restaurant)$/.test(w); });
  bb=b.split(" ");
  for(i=0;i<aa.length;i++){ if(bb.indexOf(aa[i])>-1){ hits++; } }
  return aa.length>=2 && hits>=Math.max(2,Math.ceil(aa.length*.7));
}
function travelPhotoVerify(url,cb){
  if(!url){ cb(""); return; }
  var im=new Image(), settled=false;
  im.onload=function(){ if(!settled){ settled=true; cb(url); } };
  im.onerror=function(){ if(!settled){ settled=true; cb(""); } };
  im.src=url;
}
/* V16.6: Use the Google Maps JavaScript Places library in a browser rather
   than relying exclusively on Places REST requests, which may fail in WebKit.
   Never assume the API is enabled or a valid key is present. */
var travelGoogleSDKState="idle", travelGoogleSDKWaiters=[];
function travelGooglePlacesReady(cb){
  var key=travelPhotoKey(), script, done=false;
  function finish(ok,reason){
    var waiters=travelGoogleSDKWaiters.slice(),i;
    if(done){ return; } done=true;
    travelGoogleSDKState=ok ? "ready" : "failed";
    travelGoogleSDKWaiters=[];
    if(!ok && reason){ travelPhotoDiagnostics.lastError=reason; }
    for(i=0;i<waiters.length;i++){ try{ waiters[i](ok); }catch(e){} }
  }
  if(window.google && window.google.maps && window.google.maps.places && window.google.maps.places.PlacesService){
    travelGoogleSDKState="ready"; cb(true); return;
  }
  if(travelGoogleSDKState==="failed"){ cb(false); return; }
  travelGoogleSDKWaiters.push(cb);
  if(travelGoogleSDKState==="loading"){ return; }
  if(!key){ finish(false,"Google Places key missing on Travel IQ page"); return; }
  /* If another script already loaded Maps without Places, don't inject a
     second Maps JS instance: this requires the page to include libraries=places. */
  if(window.google && window.google.maps){
    finish(false,"Google Maps loaded without Places library; enable libraries=places"); return;
  }
  travelGoogleSDKState="loading";
  script=document.createElement("script"); script.async=true; script.defer=true;
  script.src="https://maps.googleapis.com/maps/api/js?key="+encodeURIComponent(key)+"&libraries=places&loading=async";
  script.onload=function(){
    if(window.google && window.google.maps && window.google.maps.places && window.google.maps.places.PlacesService){ finish(true); }
    else{ finish(false,"Google Places JavaScript library unavailable"); }
  };
  script.onerror=function(){ finish(false,"Google Maps JS failed to load (check key, referrer restrictions, billing and Places API)"); };
  window.setTimeout(function(){ if(travelGoogleSDKState==="loading"){ finish(false,"Google Maps JS timed out"); } },10000);
  (document.head || document.body).appendChild(script);
}
function travelGooglePlaceSearch(item,cb){
  var name=travelPhotoName(item),lat=Number(item.lat),lng=Number(item.lng);
  if(!name || !finite(lat) || !finite(lng)){ cb(null); return; }
  travelGooglePlacesReady(function(ready){
    if(!ready){ cb(null); return; }
    try{
      var svc=new google.maps.places.PlacesService(document.createElement("div"));
      svc.textSearch({query:name+" near "+(dest ? clean(dest.label+" "+(dest.full||"")) : ""),
        location:new google.maps.LatLng(lat,lng),radius:12000},function(results,status){
        var i,r,loc,d;
        if(status!==google.maps.places.PlacesServiceStatus.OK || !results){
          travelPhotoDiagnostics.lastError="Places text search: "+String(status); cb(null); return;
        }
        for(i=0;i<results.length;i++){
          r=results[i]; loc=r.geometry && r.geometry.location;
          if(!loc || !travelPhotoNameMatches(name,r.name||"")){ continue; }
          d=miles(lat,lng,loc.lat(),loc.lng());
          if(d>2.5){ continue; }
          cb(r); return;
        }
        cb(null);
      });
    }catch(e){ travelPhotoDiagnostics.lastError="Places SDK search: "+String(e.message||e); cb(null); }
  });
}
function travelGooglePhotoFromSDK(item,cb){
  travelGooglePlaceSearch(item,function(place){
    var url="";
    if(place && place.photos && place.photos.length && place.photos[0].getUrl){
      try{ url=place.photos[0].getUrl({maxWidth:960}); }catch(e){}
    }
    if(place && place.place_id){ item.place_id=item.place_id||place.place_id; }
    if(url){ travelPhotoDiagnostics.matched++; travelPhotoVerify(url,cb); }
    else{ cb(""); }
  });
}
function travelPhotoResolve(item,cb){
  var key,cacheKey,url,name,lat,lng,query;
  if(!item){ cb(""); return; }
  cacheKey=travelPhotoCacheKey(item);
  if(Object.prototype.hasOwnProperty.call(travelPhotoCache,cacheKey)){
    cb(travelPhotoCache[cacheKey]); return;
  }
  if(travelPhotoPending[cacheKey]){ travelPhotoPending[cacheKey].push(cb); return; }
  travelPhotoPending[cacheKey]=[cb];
  function finish(photo){
    var listeners=travelPhotoPending[cacheKey] || [],i;
    delete travelPhotoPending[cacheKey];
    if(photo){ travelPhotoCache[cacheKey]=photo; }
    if(photo){ travelPhotoDiagnostics.loaded++; }else{ travelPhotoDiagnostics.failed++; }
    if(photo){ item.travelPhotoUrl=photo; }
    for(i=0;i<listeners.length;i++){ try{ listeners[i](photo || ""); }catch(e){} }
  }
  url=maybeGooglePhotoUrl(item);
  if(url){ travelPhotoVerify(url,finish); return; }
  key=travelPhotoKey(); name=travelPhotoName(item);
  lat=Number(item.lat); lng=Number(item.lng);
  if(!key || !name || !finite(lat) || !finite(lng) || !window.fetch){
    travelPhotoDiagnostics.lastError=!key ? "Google Places key not available on Travel page" : "Photo lookup prerequisites unavailable";
    finish(""); return;
  }
  travelPhotoDiagnostics.lookups++;
  travelGooglePhotoFromSDK(item,function(sdkUrl){
    if(sdkUrl){ finish(sdkUrl); return; }
    travelPhotoResolveREST();
  });
  function travelPhotoResolveREST(){
  /* Google Places New Text Search: bias to the actual place pin, never the
     user's GPS or a previous destination. Limit to three candidates. */
  query=name + (item.full ? " " + clean(item.full) : (dest && dest.label ? " near " + clean(dest.label + " " + (dest.full || "")) : ""));
  try{
    fetch("https://places.googleapis.com/v1/places:searchText",{
      method:"POST",
      headers:{"Content-Type":"application/json","X-Goog-Api-Key":key,
        "X-Goog-FieldMask":"places.id,places.displayName,places.location,places.photos"},
      body:JSON.stringify({textQuery:query,maxResultCount:3,
        locationBias:{circle:{center:{latitude:lat,longitude:lng},radius:3500}}})
    }).then(function(res){ if(!res.ok){ throw Error("Google photo lookup unavailable"); } return res.json(); })
    .then(function(data){
      var places=data && data.places || [],i,p,loc,d,photoRef;
      for(i=0;i<places.length;i++){
        p=places[i]; loc=p.location || {};
        if(!p.photos || !p.photos.length || !p.photos[0].name){ continue; }
        if(!travelPhotoNameMatches(name,p.displayName && p.displayName.text || "")){ continue; }
        if(!finite(Number(loc.latitude)) || !finite(Number(loc.longitude))){ continue; }
        d=miles(lat,lng,Number(loc.latitude),Number(loc.longitude));
        if(d>2.5){ continue; }
        photoRef=p.photos[0].name;
        url=travelPhotoUrlFromRef(photoRef);
        item.place_id=item.place_id || p.id || "";
        travelPhotoDiagnostics.matched++;
        travelPhotoVerify(url,finish);
        return;
      }
      finish("");
    }).catch(function(err){ travelPhotoDiagnostics.lastError=String(err && err.message || "Google Places request failed"); finish(""); });
  }catch(e){ travelPhotoDiagnostics.lastError="Google Places request failed"; finish(""); }
  }
}
function travelPhotoPaintDeck(item,index,token,url){
  var deck=byId("diqPlaceCards"),node,photo,img;
  if(!url || token!==travelScanToken || !deck || !deck.__items || deck.__items[index]!==item){ return; }
  node=deck.querySelector('[data-place-iq-index="'+String(index)+'"] .diqPlacePhoto');
  if(!node){ return; }
  node.innerHTML="";
  img=document.createElement("img"); img.src=url; img.alt=travelPhotoName(item);
  img.style.cssText="display:block;width:100%;height:100%;object-fit:cover;";
  node.appendChild(img);
  node.className="diqPlacePhoto diqPlacePhotoReal";
}
function hydrateTravelPhotos(items){
  var token=travelScanToken,i;
  for(i=0;i<Math.min((items||[]).length,8);i++){
    (function(item,index){
      travelPhotoResolve(item,function(url){
        travelPhotoPaintDeck(item,index,token,url);
        var preview=byId("diqTravelInfoCard"),photo=byId("diqTravelInfoPhoto");
        if(url && preview && preview.__travelPhotoItem===item && photo){
          photo.innerHTML='<img src="'+esc(url)+'" alt="'+esc(travelPhotoName(item))+'" />';
          photo.className="photo hasPhoto";
        }
      });
    })(items[i],i);
  }
}




/* ========================================================================
   TRAVEL IQ V15 — TRIP STYLES IQ
   Travel owns planning. Adventure owns live discovery.
======================================================================== */

var TRAVEL_TRIP_STYLES = {
  general:{
    label:"General Trip",
    emoji:"🗺️",
    primary:"preview",
    scans:["preview","local","food","coffee"],
    hint:"Pick a destination, then scan hotels, food, essentials, and local picks."
  },
  beach_weekend:{
    label:"Beach Weekend",
    emoji:"🏖️",
    primary:"beach",
    scans:["beach","waterfront","food_seafood","popular","coffee"],
    hint:"Plan beaches, waterfront meals, coffee, seafood, parking, and rainy-day backups."
  },
  bachelorette:{
    label:"Bachelorette Trip",
    emoji:"💍",
    primary:"popular",
    scans:["food_breakfast","patio","live_music","shopping","coffee"],
    hint:"Plan brunch, rooftops, patios, photo spots, walkable districts, and safe nightlife."
  },
  bachelor:{
    label:"Bachelor Trip",
    emoji:"🎩",
    primary:"golf_trip",
    scans:["golf_trip","popular","live_music","food_steakhouse","patio"],
    hint:"Plan golf, breweries, sports bars, steakhouse dinners, waterfront stops, and late-night food."
  },
  college_town:{
    label:"College Town",
    emoji:"🎓",
    primary:"popular",
    scans:["popular","live_music","coffee","food_quick","parking"],
    hint:"Plan student favorites, walkable districts, live music, coffee, parking, and late-night eats."
  },
  gameday:{
    label:"Gameday Weekend",
    emoji:"🏈",
    primary:"parking",
    scans:["parking","popular","food_quick","coffee","live_music"],
    hint:"Plan parking, tailgate supply stops, sports bars, coffee, quick bites, and post-game options."
  },
  golf_trip:{
    label:"Golf Trip",
    emoji:"⛳",
    primary:"golf_trip",
    scans:["golf_trip","food_breakfast","popular","food_steakhouse","coffee"],
    hint:"Plan courses, ranges, breakfast, clubhouse-style food, sports bars, and route-ready stops."
  },
  food_wine:{
    label:"Food & Wine",
    emoji:"🍷",
    primary:"food_wine",
    scans:["food_wine","food_dinner","patio","local","coffee"],
    hint:"Plan wineries, breweries, chef-driven restaurants, cocktail lounges, patios, and local favorites."
  },
  family:{
    label:"Family Adventure",
    emoji:"👨‍👩‍👧",
    primary:"family",
    scans:["family","food_family","beach","attractions","coffee"],
    hint:"Plan kid-friendly stops, easy meals, attractions, parks, beaches, and reset breaks."
  }
};

function travelTripStyleConfig(style){
  style = String(style || "general");
  return TRAVEL_TRIP_STYLES[style] || TRAVEL_TRIP_STYLES.general;
}

function selectedTripStylePayload(){
  var cfg = travelTripStyleConfig(activeTravelTripStyle);
  return {
    key:activeTravelTripStyle,
    label:cfg.label,
    emoji:cfg.emoji,
    scans:cfg.scans,
    primary:cfg.primary,
    hint:cfg.hint,
    updatedAt:travelIQNow()
  };
}

function restoreTravelTripStyle(){
  var saved = safeParse(lsGet(LS.TRIP_STYLE));
  var plan = safeParse(lsGet(LS.TRIP_BUILDER));
  var key = "";
  if(saved && saved.key){ key = String(saved.key); }
  else if(plan && plan.tripStyle && plan.tripStyle.key){ key = String(plan.tripStyle.key); }
  if(!key || !TRAVEL_TRIP_STYLES[key]){ key = "general"; }
  activeTravelTripStyle = key;
  activeTravelTripStyleLabel = travelTripStyleConfig(key).label;
  syncTravelTripStyleUI();
}

function syncTravelTripStyleUI(){
  var nodes;
  var i;
  var hint;
  var cfg = travelTripStyleConfig(activeTravelTripStyle);
  try{
    nodes = document.querySelectorAll ? document.querySelectorAll("[data-trip-style]") : [];
    for(i=0;i<nodes.length;i++){
      if(nodes[i].getAttribute("data-trip-style") === activeTravelTripStyle){
        if(String(nodes[i].className || "").indexOf(" on") < 0){ nodes[i].className = String(nodes[i].className || "") + " on"; }
        nodes[i].setAttribute("aria-pressed","true");
      }else{
        nodes[i].className = String(nodes[i].className || "").replace(/\s+on/g,"");
        nodes[i].setAttribute("aria-pressed","false");
      }
    }
  }catch(e1){}
  hint = byId("diqTripStyleHint");
  if(hint){
    hint.textContent = cfg.emoji + " " + cfg.label + " • " + cfg.hint;
  }
}

function invalidateTravelScanForStyleChange(){
  /* Any request launched by the previous style becomes stale immediately. */
  travelScanToken += 1;
  travelScanResults = [];
  travelScanCategory = "";

  stopTravelScanLoading();
  clearTravelPins();
  clearTravelChipState();
  clearFoodChipState();
  closeFoodIQPanel();
  closeTravelInfoCard();

  /* Remove any old Place IQ deck content while the new style scans. */
  try{ renderPlaceIQDeck([], "preview"); }catch(e1){}

  setIntel("STYLE READY","blue");
}

function selectTravelTripStyle(style,label,shouldScan){
  var cfg;
  var plan;
  if(!TRAVEL_TRIP_STYLES[String(style || "")]){ style = "general"; }
  activeTravelTripStyle = String(style || "general");
  cfg = travelTripStyleConfig(activeTravelTripStyle);
  activeTravelTripStyleLabel = clean(label || cfg.label);
  lsJSON(LS.TRIP_STYLE, selectedTripStylePayload());
  syncTravelTripStyleUI();

  plan = loadTripBuilder();
  plan.tripStyle = selectedTripStylePayload();
  if(dest){ plan.destination = dest; }
  saveTripBuilder(plan);

  /* V16.1: a trip-style change is a new discovery context. Never leave
     pins/cards from the previous style on screen. */
  invalidateTravelScanForStyleChange();
  setTravelScanCollapsed(true);

  setIntel("STYLE SET","green");
  subline(cfg.label + " selected • " + (dest ? "Refreshing picks near destination" : "Choose a destination to plan it"));
  toast(cfg.label + " selected");

  if(shouldScan && dest){
    manualTravelScanScope = "near_destination";
    stopSearchScope = "near_destination";
    updateTravelScanScope();
    syncStopSearchScope();
    startTravelScan(cfg.primary || "preview");
  }else if(shouldScan && !dest){
    stopSearchScope = "near_me";
    syncStopSearchScope();
    toast("Choose a destination for " + cfg.label);
  }
}

function bindTravelTripStyles(){
  var grid = byId("diqTripStyleGrid") || byId("diqTripStyles");
  if(grid){
    grid.onclick = function(e){
      var target = e && e.target ? e.target : null;
      var count = 0;
      while(target && count < 5){
        if(target.getAttribute && target.getAttribute("data-trip-style")){
          selectTravelTripStyle(target.getAttribute("data-trip-style"), target.getAttribute("data-trip-label") || "", true);
          if(e && e.preventDefault){ e.preventDefault(); }
          return false;
        }
        target = target.parentNode;
        count += 1;
      }
      return true;
    };
  }
  syncTravelTripStyleUI();
}

function travelStyleQueryBoosts(style,cat,center){
  var out = [];
  var city = center && center.label ? String(center.label) : "";
  var place = city || (dest && dest.label ? String(dest.label) : "");
  function add(q){ if(q){ out.push(q); if(place){ out.push(q + " " + place); } } }

  style = String(style || activeTravelTripStyle || "general");
  cat = String(cat || "");

  if(style === "bachelorette"){
    if(cat === "popular" || cat === "patio" || cat === "live_music"){ add("rooftop bar"); add("cocktail lounge"); add("dance club"); add("walkable nightlife district"); add("live music bar"); }
    if(cat === "food_breakfast" || cat === "food" || cat === "food_dinner"){ add("brunch restaurant"); add("group friendly restaurant"); add("cute brunch spot"); }
    if(cat === "shopping"){ add("boutique shopping"); add("photo spots"); }
  }

  if(style === "bachelor"){
    if(cat === "golf_trip"){ add("golf course"); add("driving range"); add("country club"); add("public golf course"); }
    if(cat === "popular" || cat === "patio" || cat === "live_music"){ add("sports bar"); add("brewery"); add("whiskey bar"); add("bar and grill"); }
    if(cat === "food_steakhouse" || cat === "food_dinner"){ add("steakhouse"); add("barbecue"); add("sports bar restaurant"); }
  }

  if(style === "college_town" || style === "gameday"){
    if(cat === "popular" || cat === "live_music"){ add("college bar"); add("sports bar"); add("student favorite restaurant"); add("downtown nightlife"); add("live music venue"); }
    if(cat === "coffee"){ add("coffee near campus"); add("study cafe"); }
    if(cat === "parking"){ add("stadium parking"); add("public parking downtown"); add("campus parking"); }
    if(cat === "food_quick" || cat === "food"){ add("late night food"); add("pizza"); add("burgers"); }
  }

  if(style === "golf_trip"){
    if(cat === "golf_trip"){ add("golf course"); add("public golf course"); add("driving range"); add("country club"); add("golf club"); }
    if(cat === "food_breakfast"){ add("breakfast near golf course"); }
    if(cat === "popular"){ add("sports bar"); add("brewery"); }
  }

  if(style === "food_wine"){
    if(cat === "food_wine"){ add("winery"); add("wine bar"); add("brewery"); add("cocktail lounge"); add("distillery"); }
    if(cat === "food_dinner" || cat === "local"){ add("fine dining"); add("chef restaurant"); add("local favorite restaurant"); }
    if(cat === "patio"){ add("patio restaurant"); add("rooftop bar"); }
  }

  if(style === "beach_weekend"){
    if(cat === "beach" || cat === "waterfront"){ add("public beach access"); add("beach bar"); add("waterfront restaurant"); add("marina restaurant"); }
    if(cat === "food_seafood"){ add("seafood restaurant"); add("oyster bar"); }
    if(cat === "popular"){ add("beach bar live music"); add("waterfront nightlife"); }
  }

  if(style === "family"){
    if(cat === "family" || cat === "attractions"){ add("kids activities"); add("mini golf"); add("aquarium"); add("water park"); add("family attraction"); }
    if(cat === "food_family"){ add("family restaurant"); add("ice cream"); add("pizza restaurant"); }
  }

  return dedupeQueryList(out);
}

function addTravelStyleQueries(cat,queries,center){
  var out = [];
  var boosts;
  var i;
  queries = queries || [];
  for(i=0;i<queries.length;i++){ out.push(queries[i]); }
  boosts = travelStyleQueryBoosts(activeTravelTripStyle,cat,center);
  for(i=0;i<boosts.length;i++){ out.push(boosts[i]); }
  return dedupeQueryList(out);
}

function travelTripStyleContextText(){
  var cfg = travelTripStyleConfig(activeTravelTripStyle);
  if(!cfg || activeTravelTripStyle === "general"){ return ""; }
  return cfg.emoji + " " + cfg.label;
}


/* ========================================================================
   TRAVEL IQ V16 — TRIP-STYLE RESULT INTELLIGENCE
   Ranking stays additive: category match + distance + personal taste remain
   authoritative, while the selected trip style acts as a strong tie-breaker.
======================================================================== */
function travelStyleText(item){
  return normText(
    (item && (item.displayName || item.label || "")) + " " +
    (item && item.full ? item.full : "") + " " +
    (item && item.sourceQuery ? item.sourceQuery : "")
  );
}

function travelStyleScore(item,cat){
  var style = String(activeTravelTripStyle || "general");
  var txt = travelStyleText(item);
  var score = 0;
  if(style === "general"){ return 0; }

  if(style === "beach_weekend"){
    if(/beach|waterfront|ocean|gulf|bay|harbor|harbour|marina|pier|boardwalk|shore|sunset|seafood|oyster|shrimp|fish|surf/.test(txt)){ score += 78; }
    if(/coffee|cafe|breakfast|brunch|boutique|shopping|souvenir|ice cream/.test(txt)){ score += 34; }
    if(/industrial|warehouse|office park|residential|apartment/.test(txt)){ score -= 45; }
  }else if(style === "bachelorette"){
    if(/brunch|rooftop|cocktail|spa|salon|boutique|photo|mural|live music|nightclub|dance|patio|wine bar/.test(txt)){ score += 78; }
    if(/walkable|downtown|district|rideshare|hotel/.test(txt)){ score += 28; }
    if(/truck stop|industrial|warehouse|auto parts/.test(txt)){ score -= 50; }
  }else if(style === "bachelor"){
    if(/golf|driving range|brewery|sports bar|steak|bbq|barbecue|whiskey|fishing|boat|marina|live music/.test(txt)){ score += 78; }
    if(/patio|grill|taproom|pub/.test(txt)){ score += 28; }
  }else if(style === "college_town"){
    if(/campus|university|college|student|downtown|coffee|cafe|pizza|burger|late night|live music|bar|pub/.test(txt)){ score += 72; }
    if(/parking|garage|walkable|bookstore/.test(txt)){ score += 28; }
  }else if(style === "gameday"){
    if(/stadium|arena|parking|tailgate|sports bar|campus|university|college|breakfast|coffee|pizza|burger/.test(txt)){ score += 82; }
    if(/grocery|market|walmart|target|liquor|convenience/.test(txt)){ score += 28; }
    if(/museum|spa|boutique/.test(txt)){ score -= 20; }
  }else if(style === "golf_trip"){
    if(/golf|course|country club|driving range|practice range|clubhouse|tee/.test(txt)){ score += 92; }
    if(/breakfast|brunch|steak|sports bar|brewery|grill|coffee/.test(txt)){ score += 34; }
  }else if(style === "food_wine"){
    if(/winery|wine bar|vineyard|brewery|distillery|cocktail|tasting|chef|fine dining|bistro|local restaurant|dessert|bakery/.test(txt)){ score += 82; }
    if(/patio|rooftop|waterfront|scenic/.test(txt)){ score += 28; }
    if(/fast food|drive thru|truck stop/.test(txt)){ score -= 28; }
  }else if(style === "family"){
    if(/family|kids|children|aquarium|zoo|museum|park|playground|mini golf|arcade|water park|ice cream|pizza|family restaurant/.test(txt)){ score += 84; }
    if(/easy parking|parking|indoor|visitor center/.test(txt)){ score += 26; }
    if(/nightclub|adult entertainment|casino|hookah/.test(txt)){ score -= 120; }
    if(/bar|tavern|pub/.test(txt) && !/restaurant|grill|family/.test(txt)){ score -= 45; }
  }

  /* Directly reward the scan lanes chosen for this trip style. */
  try{
    var cfg = travelTripStyleConfig(style);
    var i;
    if(cfg && cfg.primary === cat){ score += 42; }
    if(cfg && cfg.scans){
      for(i=0;i<cfg.scans.length;i++){
        if(cfg.scans[i] === cat){ score += 24; break; }
      }
    }
  }catch(e){}

  return score;
}

function travelStyleFitLabel(item,cat){
  var style = String(activeTravelTripStyle || "general");
  var txt = travelStyleText(item);
  if(style === "general"){ return ""; }
  if(style === "beach_weekend" && /beach|waterfront|ocean|gulf|harbor|marina|seafood|sunset|boardwalk/.test(txt)){ return "🏖️ GOOD FOR BEACH TRIP"; }
  if(style === "bachelorette" && /brunch|rooftop|cocktail|spa|boutique|photo|live music|dance|patio/.test(txt)){ return "💍 FITS THE WEEKEND"; }
  if(style === "bachelor" && /golf|brewery|sports bar|steak|bbq|whiskey|fishing|boat|live music/.test(txt)){ return "🎩 GROUP TRIP PICK"; }
  if(style === "college_town" && /campus|university|college|student|downtown|coffee|pizza|live music|bar/.test(txt)){ return "🎓 COLLEGE TOWN PICK"; }
  if(style === "gameday" && /stadium|arena|parking|tailgate|sports|campus|breakfast|coffee/.test(txt)){ return "🏈 GAMEDAY READY"; }
  if(style === "golf_trip" && /golf|course|driving range|clubhouse|tee/.test(txt)){ return "⛳ GOLF TRIP PICK"; }
  if(style === "food_wine" && /winery|wine|brewery|distillery|cocktail|tasting|chef|fine dining|bistro/.test(txt)){ return "🍷 FOOD + WINE PICK"; }
  if(style === "family" && /family|kids|children|aquarium|zoo|museum|park|mini golf|arcade|water park|ice cream/.test(txt)){ return "👨‍👩‍👧 FAMILY FIT"; }
  return "";
}

function travelStyleWhy(item,cat){
  var style = String(activeTravelTripStyle || "general");
  var txt = travelStyleText(item);
  if(style === "general"){ return ""; }
  if(style === "beach_weekend" && /beach|waterfront|ocean|gulf|harbor|marina|seafood|sunset|boardwalk/.test(txt)){ return "Fits your Beach Weekend with water, views, seafood, or an easy coastal stop near the trip."; }
  if(style === "bachelorette" && /brunch|rooftop|cocktail|spa|boutique|photo|live music|dance|patio/.test(txt)){ return "Fits your Bachelorette Trip with brunch, drinks, photos, shopping, music, or a group-friendly vibe."; }
  if(style === "bachelor" && /golf|brewery|sports bar|steak|bbq|whiskey|fishing|boat|live music/.test(txt)){ return "Fits your Bachelor Trip with golf, food, drinks, sports, music, or an easy group stop."; }
  if(style === "college_town" && /campus|university|college|student|downtown|coffee|pizza|live music|bar/.test(txt)){ return "Fits your College Town trip with campus energy, walkable favorites, coffee, food, or nightlife."; }
  if(style === "gameday" && /stadium|arena|parking|tailgate|sports|campus|breakfast|coffee/.test(txt)){ return "Fits Gameday with parking, tailgate support, quick food, coffee, or a sports-focused stop."; }
  if(style === "golf_trip" && /golf|course|driving range|clubhouse|tee/.test(txt)){ return "Fits your Golf Trip as a course, range, clubhouse, or golf-centered stop worth building around."; }
  if(style === "food_wine" && /winery|wine|brewery|distillery|cocktail|tasting|chef|fine dining|bistro/.test(txt)){ return "Fits your Food & Wine trip with a tasting, local drink, chef-driven meal, or memorable dining stop."; }
  if(style === "family" && /family|kids|children|aquarium|zoo|museum|park|mini golf|arcade|water park|ice cream/.test(txt)){ return "Fits your Family Adventure with kid-friendly fun, an easy break, or a low-stress stop everyone can enjoy."; }
  return "";
}


/* ========================================================================
   TRAVEL IQ V11 — PERSISTENT TRIP BUILDER + PERSONAL PLACE IQ
======================================================================== */
function travelIQNow(){ return new Date().toISOString(); }

function loadTripBuilder(){
  var plan = safeParse(lsGet(LS.TRIP_BUILDER));
  if(plan && typeof plan === "object"){ return plan; }
  return { version:"v16", destination:null, tripStyle:selectedTripStylePayload(), stops:[], favorites:[], createdAt:travelIQNow(), updatedAt:travelIQNow() };
}

function saveTripBuilder(plan){
  if(!plan){ plan = loadTripBuilder(); }
  plan.version = "v16";
  if(!plan.tripStyle || activeTravelTripStyle !== "general"){ plan.tripStyle = selectedTripStylePayload(); }
  plan.updatedAt = travelIQNow();
  lsJSON(LS.TRIP_BUILDER,plan);
  renderTripBuilderShell(plan);
  renderMemoryShell();
  return plan;
}

function currentTripBuilder(){
  var plan = loadTripBuilder();
  if(dest){ plan.destination = dest; }
  if(routeGeo){ plan.routeGeo = routeGeo; }
  plan.routeIntel = safeParse(lsGet(LS.ROUTE_INTEL));
  return saveTripBuilder(plan);
}

function addStopToTripBuilder(item){
  var plan = loadTripBuilder();
  var key;
  var i;
  if(!item){ return; }
  item = enrichPlaceIQItem(item,travelScanCategory);
  key = String((item.place_id || item.id || item.displayName || item.label || "") + "|" + Number(item.lat).toFixed(5) + "," + Number(item.lng).toFixed(5)).toLowerCase();
  for(i=0;i<(plan.stops || []).length;i++){
    if(String(plan.stops[i].key || "").toLowerCase() === key){ toast("Already in trip"); return; }
  }
  if(!plan.stops){ plan.stops = []; }
  plan.stops.push({
    key:key,
    label:item.displayName || item.label,
    full:item.full || "",
    lat:item.lat,
    lng:item.lng,
    category:item.placeIQCategory || travelScanCategory,
    badge:item.placeIQBadge || "",
    score:item.placeIQScore || 0,
    addedAt:travelIQNow()
  });
  saveTripBuilder(plan);
  toast("Added to trip plan");
}

function saveTripSnapshot(){
  var plan = currentTripBuilder();
  var list = getJSONList(LS.SAVED_TRIPS);
  var name = plan.destination && plan.destination.label ? String(plan.destination.label) : "Saved Travel IQ Trip";
  plan.name = name;
  plan.savedAt = travelIQNow();
  list.unshift(plan);
  if(list.length > 20){ list = list.slice(0,20); }
  lsJSON(LS.SAVED_TRIPS,list);
  toast("Trip saved");
  setIntel("TRIP SAVED","green");
}

function loadTasteProfile(){
  var p = safeParse(lsGet(LS.TASTE_PROFILE));
  if(p && typeof p === "object"){ return p; }
  return { version:"v11", scores:{}, saves:0, routes:0, shares:0, updatedAt:travelIQNow() };
}

function bumpTaste(key,amount){
  var p = loadTasteProfile();
  if(!key){ return; }
  if(!p.scores){ p.scores = {}; }
  p.scores[key] = Number(p.scores[key] || 0) + Number(amount || 1);
  p.updatedAt = travelIQNow();
  lsJSON(LS.TASTE_PROFILE,p);
}

function learnPreferenceFromItem(item,action){
  var txt;
  var amt = action === "route" ? 3 : (action === "share" ? 2 : 1);
  if(!item){ return; }
  txt = normText((item.displayName || item.label || "") + " " + (item.full || "") + " " + (item.placeIQCategory || ""));
  if(txt.indexOf("coffee") > -1 || txt.indexOf("starbucks") > -1 || txt.indexOf("espresso") > -1 || txt.indexOf("cafe") > -1){ bumpTaste("coffee",amt); }
  if(txt.indexOf("matcha") > -1 || txt.indexOf("tea") > -1){ bumpTaste("matcha_tea",amt); }
  if(txt.indexOf("smoothie") > -1 || txt.indexOf("juice") > -1 || txt.indexOf("nutrition") > -1 || txt.indexOf("healthy") > -1){ bumpTaste("nutrition",amt); }
  if(txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1 || txt.indexOf("smokehouse") > -1){ bumpTaste("bbq",amt); }
  if(txt.indexOf("hotel") > -1 || txt.indexOf("inn") > -1 || txt.indexOf("suites") > -1){ bumpTaste("hotels",amt); }
  if(txt.indexOf("family") > -1 || txt.indexOf("kids") > -1 || txt.indexOf("arcade") > -1 || txt.indexOf("mini golf") > -1){ bumpTaste("family",amt); }
  if(txt.indexOf("beach") > -1 || txt.indexOf("park") > -1 || txt.indexOf("scenic") > -1 || txt.indexOf("waterfront") > -1){ bumpTaste("scenic",amt); }
  if(txt.indexOf("bar") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("patio") > -1 || txt.indexOf("music") > -1){ bumpTaste("popular_tonight",amt); }
  if(action === "route"){ var p = loadTasteProfile(); p.routes = Number(p.routes || 0) + 1; lsJSON(LS.TASTE_PROFILE,p); }
  if(action === "share"){ var ps = loadTasteProfile(); ps.shares = Number(ps.shares || 0) + 1; lsJSON(LS.TASTE_PROFILE,ps); }
}

function personalPreferenceBoost(item,cat){
  var p = loadTasteProfile();
  var s = p.scores || {};
  var txt = normText((item && (item.displayName || item.label || "")) + " " + (item && item.full ? item.full : ""));
  var boost = 0;
  if((cat === "coffee" || cat === "food_cafe") && s.coffee){ boost += Math.min(18,Number(s.coffee) * 2); }
  if((txt.indexOf("matcha") > -1 || txt.indexOf("tea") > -1) && s.matcha_tea){ boost += Math.min(16,Number(s.matcha_tea) * 2); }
  if((txt.indexOf("smoothie") > -1 || txt.indexOf("juice") > -1 || txt.indexOf("nutrition") > -1) && s.nutrition){ boost += Math.min(16,Number(s.nutrition) * 2); }
  if((cat === "food_bbq" || txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1) && s.bbq){ boost += Math.min(18,Number(s.bbq) * 2); }
  if(cat === "hotels" && s.hotels){ boost += Math.min(14,Number(s.hotels) * 2); }
  if(cat === "family" && s.family){ boost += Math.min(14,Number(s.family) * 2); }
  if((cat === "beach" || cat === "attractions") && s.scenic){ boost += Math.min(14,Number(s.scenic) * 2); }
  if((cat === "popular" || cat === "popular_tonight") && s.popular_tonight){ boost += Math.min(14,Number(s.popular_tonight) * 2); }
  return boost;
}

function categoryIntentScore(item,cat){
  var txt = normText((item && (item.displayName || item.label || "")) + " " + (item && item.full ? item.full : "") + " " + (item && item.sourceQuery ? item.sourceQuery : ""));
  var score = 0;
  var wrong = 0;
  if(cat === "coffee"){
    if(/coffee|starbucks|cafe|espresso|latte|matcha|tea|smoothie|nutrition/.test(txt)){ score += 65; }
    if(/outlet|mall|shopping center|department store|clothing|shoe store/.test(txt)){ wrong += 75; }
  }
  if(cat === "groceries"){
    if(/grocery|supermarket|market|kroger|publix|walmart|target|aldi|whole foods|trader joe/.test(txt)){ score += 65; }
    if(/outlet|mall|clothing|shoe|restaurant/.test(txt)){ wrong += 55; }
  }
  if(cat === "hotels"){
    if(/hotel|inn|suites|motel|lodging|resort|drury|hampton|holiday inn|marriott|hilton|comfort|la quinta|best western|home2|hyatt/.test(txt)){ score += 70; }
    if(/restaurant|shopping|store|apartments/.test(txt)){ wrong += 50; }
  }
  if(cat === "family"){
    if(/family|kids|children|arcade|mini golf|trampoline|urban air|playground|museum|zoo|aquarium|park|ice cream/.test(txt)){ score += 58; }
  }
  if(cat === "popular" || cat === "popular_tonight"){
    if(/bar|grill|pub|tap|tavern|sports|patio|brew|music|restaurant|happy hour|open late/.test(txt)){ score += 60; }
  }
  if(cat === "live_music"){
    if(/music|live|venue|bar|pub|grill|theater|theatre|stage|concert|jazz|blues|brew|taproom|nightclub/.test(txt)){ score += 72; }
  }
  if(cat === "waterfront"){
    if(/waterfront|river|lake|beach|marina|pier|harbor|harbour|boardwalk|boat|landing|shore|creek|bay/.test(txt)){ score += 70; }
  }
  if(cat === "patio"){
    if(/patio|outdoor|beer garden|courtyard|terrace|rooftop|yard|deck|porch|brewery|tavern|bar|grill/.test(txt)){ score += 68; }
  }
  if(cat === "hidden_gems"){
    if(/local|historic|downtown|alley|market|mural|boutique|bakery|cafe|trail|overlook|park|hidden|gem/.test(txt)){ score += 58; }
    if(/walmart|target|mcdonald|burger king|wendy|subway|taco bell/.test(txt)){ wrong += 42; }
  }
  if(cat === "scenic"){
    if(/scenic|overlook|view|park|trail|waterfall|lake|river|garden|sunset|photo|historic|landmark/.test(txt)){ score += 68; }
  }
  if(cat === "local"){
    if(/local|downtown|cafe|grill|market|bakery|bbq|barbecue|boutique|coffee|restaurant/.test(txt)){ score += 42; }
    if(/walmart|target|mcdonald|burger king|wendy|subway|taco bell/.test(txt)){ wrong += 35; }
  }
  return score - wrong;
}

function googlePlacesProxyUrl(query,center){
  if(!GOOGLE_PLACES_PROXY_URL){ return ""; }
  return GOOGLE_PLACES_PROXY_URL + "?query=" + encodeURIComponent(query) + (center ? "&lat=" + encodeURIComponent(center.lat) + "&lng=" + encodeURIComponent(center.lng) : "");
}

function normalizeGooglePlace(g,cat,center){
  var loc = g && g.geometry && g.geometry.location ? g.geometry.location : {};
  var lat = Number(loc.lat);
  var lng = Number(loc.lng);
  var item;
  if(!finite(lat) || !finite(lng)){ return null; }
  item = {
    label:clean(g.name || "Place"),
    name:clean(g.name || ""),
    full:clean(g.formatted_address || g.vicinity || ""),
    lat:lat,
    lng:lng,
    kind:placeIQCategoryLabel(cat),
    rating:finite(Number(g.rating)) ? Number(g.rating) : null,
    reviews:finite(Number(g.user_ratings_total)) ? Number(g.user_ratings_total) : null,
    openNow:g.opening_hours && g.opening_hours.open_now === true,
    place_id:g.place_id || "",
    photo_reference:g.photos && g.photos[0] && g.photos[0].photo_reference ? g.photos[0].photo_reference : "",
    source:"google_places",
    googleTypes:g.types || (g.primaryType ? [g.primaryType] : []),
    verifiedCategories:[]
  };
  if(center && finite(Number(center.lat)) && finite(Number(center.lng))){ item.centerMiles = miles(center.lat,center.lng,lat,lng); item.distMiles = item.centerMiles; }
  return enrichPlaceIQItem(item,cat);
}

function renderTripBuilderShell(plan){
  var box = byId("diqTripTimeline");
  var title = byId("diqRouteTitle");
  var sub = byId("diqRouteSub");
  var html = "";
  var i;
  var stop;
  plan = plan || loadTripBuilder();
  if(!box){ return; }
  if(plan.tripStyle && plan.tripStyle.label && plan.tripStyle.key !== "general"){
    html += '<div class="diqTripStep"><div class="diqTripStepIcon">' + esc(plan.tripStyle.emoji || "✨") + '</div><div><div class="diqTripStepTitle">' + esc(plan.tripStyle.label || "Trip Style") + '</div><div class="diqTripStepSub">' + esc(plan.tripStyle.hint || "Travel IQ is shaping the plan around this trip.") + '</div></div><div class="diqTripStepChip">STYLE</div></div>';
  }
  if(plan.destination){
    html += '<div class="diqTripStep"><div class="diqTripStepIcon">📍</div><div><div class="diqTripStepTitle">' + esc(plan.destination.label || "Destination") + '</div><div class="diqTripStepSub">Destination saved for this Travel IQ plan.</div></div><div class="diqTripStepChip">DEST</div></div>';
  }else{
    html += '<div class="diqTripStep"><div class="diqTripStepIcon">📍</div><div><div class="diqTripStepTitle">Choose destination</div><div class="diqTripStepSub">Search a city, hotel, beach, venue, or address.</div></div><div class="diqTripStepChip">START</div></div>';
  }
  if(plan.stops && plan.stops.length){
    for(i=0;i<Math.min(plan.stops.length,5);i++){
      stop = plan.stops[i];
      html += '<div class="diqTripStep"><div class="diqTripStepIcon">⭐</div><div><div class="diqTripStepTitle">' + esc(stop.label || "Saved stop") + '</div><div class="diqTripStepSub">' + esc((stop.badge || stop.category || "Place IQ") + (stop.score ? " • " + String(stop.score) : "")) + '</div></div><div class="diqTripStepChip">STOP</div></div>';
    }
  }else{
    html += '<div class="diqTripStep"><div class="diqTripStepIcon">⭐</div><div><div class="diqTripStepTitle">Add places worth stopping</div><div class="diqTripStepSub">Coffee, food, hotels, local picks, family stops, and hidden gems.</div></div><div class="diqTripStepChip">PLACE IQ</div></div>';
  }
  box.innerHTML = html;
  if(title && plan.destination && (!routeReady || !routeGeo)){ title.textContent = "Planning: " + String(plan.destination.label || "Trip"); }
  if(sub && plan.stops && plan.stops.length && (!routeReady || !routeGeo)){ sub.textContent = String(plan.stops.length) + " saved stops • Start Travel when ready"; }
}

function renderMemoryShell(){
  var favs = getJSONList(LS.FAVORITE_STOPS);
  var drops = getJSONList(LS.DISCOVERY_DROPS);
  var tiles = document.querySelectorAll ? document.querySelectorAll(".diqMemoryTileSub") : [];
  if(tiles && tiles.length > 0){ tiles[0].textContent = String(favs.length) + " places worth remembering"; }
  if(tiles && tiles.length > 1){ tiles[1].textContent = String(drops.length) + " discovery moments saved"; }
}

function localIQTags(item,cat){
  var tags = [];
  var txt = normText((item && (item.displayName || item.label || "")) + " " + (item && item.full ? item.full : "") + " " + (item && item.sourceQuery ? item.sourceQuery : ""));
  if(item && item.openNow === true){ tags.push("🟢 Open"); }
  if(finite(Number(item && item.rating))){ tags.push(String(Math.round(Number(item.rating) * 10) / 10) + "★"); }
  if(finite(Number(item && item.centerMiles))){ tags.push(fmtMiles(item.centerMiles)); }
  if(cat === "live_music" || /live music|concert|venue|stage|music/.test(txt)){ tags.push("🎵 Venue"); }
  if(cat === "waterfront" || /waterfront|river|lake|beach|marina|pier/.test(txt)){ tags.push("🌊 Water"); }
  if(cat === "patio" || /patio|outdoor|rooftop|beer garden|courtyard/.test(txt)){ tags.push("☀ Patio"); }
  if(cat === "hidden_gems"){ tags.push("🏆 Local"); }
  if(cat === "scenic" || /scenic|overlook|trail|park|view|sunset/.test(txt)){ tags.push("📸 Scenic"); }
  if(tags.length < 3){ tags.push("Worth the Stop"); }
  return tags.slice(0,5).join(" • ");
}

function localIQMeta(item,cat){
  var parts = [];
  var reviews = Number(item && (item.reviews || item.reviewCount || item.user_ratings_total));
  if(finite(Number(item && item.rating))){ parts.push(String(Math.round(Number(item.rating) * 10) / 10) + "★"); }
  if(finite(reviews) && reviews > 0){ parts.push(String(Math.round(reviews)) + " reviews"); }
  if(finite(Number(item && item.centerMiles))){ parts.push(fmtMiles(item.centerMiles)); }
  if(item && item.openNow === true){ parts.push("Open now"); }
  if(!parts.length){ parts.push("Drive IQ pick"); }
  return parts.join(" • ");
}

function renderPlaceIQDeck(items,cat){
  var deck = byId("diqPlaceCards");
  var html = "";
  var i;
  var item;
  var meta;
  var tags;
  if(!deck){ return; }
  items = items && items.length ? items : [];
  for(i=0;i<Math.min(items.length,8);i++){
    item = enrichPlaceIQItem(items[i],cat || travelScanCategory);
    meta = localIQMeta(item,cat || travelScanCategory);
    tags = localIQTags(item,cat || travelScanCategory);
    html += '<div class="diqPlaceCard" data-place-iq-index="' + String(i) + '">' +
      '<div class="diqPlacePhoto"><div class="diqPlacePhotoIcon">' + esc(item.placeIQEmoji || "📍") + '</div></div>' +
      '<div class="diqPlaceBody"><div class="diqPlaceBadge">' + esc(item.placeIQBadge || "WORTH THE STOP") + '</div>' +
      '<div class="diqPlaceName">' + esc(item.displayName || item.label || "Place IQ Stop") + '</div>' +
      '<div class="diqPlaceMeta">' + esc(meta + " • Verified place category") + '</div>' +
      '<div class="diqPlaceWhy">' + esc(item.placeIQWhy || "A useful stop that fits your trip.") + '</div>' +
      '<div class="diqPlaceWhy" style="margin-top:6px;color:rgba(255,255,255,.62);font-size:10px;">' + esc(tags) + '</div>' +
      '<div class="diqPlaceActions"><button class="diqPlaceAction" data-place-iq-save="' + String(i) + '" type="button">SAVE</button><button class="diqPlaceAction" data-place-iq-share="' + String(i) + '" type="button">SHARE</button><button class="diqPlaceAction route" data-place-iq-route="' + String(i) + '" type="button">ADD STOP</button></div></div></div>';
  }
  if(!html){ deck.__items=[]; deck.innerHTML=""; return; }
  deck.__items = items;
  deck.innerHTML = html;
  bindPlaceIQDeckActions();
  hydrateTravelPhotos(items);
}

function bindPlaceIQDeckActions(){
  var deck = byId("diqPlaceCards");
  var nodes;
  var i;
  if(!deck){ return; }
  nodes = deck.querySelectorAll ? deck.querySelectorAll("[data-place-iq-index]") : [];
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){
      var t = e && e.target ? e.target : null;
      if(t && t.getAttribute && (t.getAttribute("data-place-iq-save") || t.getAttribute("data-place-iq-share") || t.getAttribute("data-place-iq-route"))){ return; }
      var idx = Number(this.getAttribute("data-place-iq-index"));
      if(deck.__items && deck.__items[idx]){ openTravelInfoCard(deck.__items[idx]); }
    };
  }
  nodes = deck.querySelectorAll ? deck.querySelectorAll("[data-place-iq-save]") : [];
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){ if(e && e.stopPropagation){ e.stopPropagation(); } var idx = Number(this.getAttribute("data-place-iq-save")); if(deck.__items && deck.__items[idx]){ saveFavoriteStop(deck.__items[idx]); addStopToTripBuilder(deck.__items[idx]); learnPreferenceFromItem(deck.__items[idx],"save"); } };
  }
  nodes = deck.querySelectorAll ? deck.querySelectorAll("[data-place-iq-share]") : [];
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){ if(e && e.stopPropagation){ e.stopPropagation(); } var idx = Number(this.getAttribute("data-place-iq-share")); if(deck.__items && deck.__items[idx]){ learnPreferenceFromItem(deck.__items[idx],"share"); shareDiscovery(deck.__items[idx]); } };
  }
  nodes = deck.querySelectorAll ? deck.querySelectorAll("[data-place-iq-route]") : [];
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){ if(e && e.stopPropagation){ e.stopPropagation(); } var idx = Number(this.getAttribute("data-place-iq-route")); if(deck.__items && deck.__items[idx]){ routeToTravelStop(deck.__items[idx]); } };
  }
}

function routeToTravelStop(item){
  if(!item){ return; }
  item = enrichPlaceIQItem(item,travelScanCategory);
  learnPreferenceFromItem(item,"route");
  addStopToTripBuilder(item);
  try{ localStorage.setItem("diq_added_stop_v1",JSON.stringify({ name:item.displayName || item.label || "Stop", label:item.displayName || item.label || "Stop", lat:item.lat, lng:item.lng, category:item.placeIQCategory || travelScanCategory, badge:item.placeIQBadge || "", source:"travel_iq_v11" })); }catch(e){}
  chooseDestination({ label:item.displayName || item.label || "Travel stop", full:item.full || "", lat:item.lat, lng:item.lng, kind:item.placeIQCategory || "Place IQ" });
  buildRoute();
  closeTravelInfoCard();
  setIntel("STOP READY","green");
  toast("Stop added: " + String(item.displayName || item.label || "stop"));
}


function injectTravelScanStyles(){
  var css;
  var style;
  if(byId("diqTravelScanStyle")){ return; }
  css =
    ".diqTravelScanCard{pointer-events:auto;border-radius:24px;background:linear-gradient(180deg,rgba(5,12,22,.90),rgba(5,12,22,.76));border:1px solid rgba(88,166,255,.20);box-shadow:0 18px 42px rgba(0,0,0,.42),0 0 28px rgba(88,166,255,.08);backdrop-filter:blur(18px);-webkit-backdrop-filter:blur(18px);overflow:hidden;}" +
    ".diqTravelScanInner{padding:10px;}" +
    ".diqTravelScanHead{display:flex;align-items:center;justify-content:space-between;gap:10px;margin-bottom:8px;}" +
    ".diqTravelScanMini{min-height:26px;padding:0 10px;border-radius:999px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.13);color:#fff;font-size:9px;font-weight:1000;letter-spacing:.7px;}" +
    "#diqFoodIQPanel{display:none;margin-top:8px;padding:10px;border-radius:18px;background:rgba(40,255,190,.075);border:1px solid rgba(40,255,190,.20);}" +
    "#diqFoodIQPanel.on{display:block;}" +
    "#diqFoodIQPanel .foodHead{display:flex;align-items:center;justify-content:space-between;gap:8px;margin-bottom:7px;}" +
    "#diqFoodIQPanel .foodTitle{font-size:10px;font-weight:1000;letter-spacing:1px;color:#b6ffeb;text-transform:uppercase;}" +
    "#diqFoodIQPanel .foodClose{min-height:25px;padding:0 10px;border-radius:999px;background:rgba(255,255,255,.06);border:1px solid rgba(255,255,255,.12);color:#fff;font-size:9px;font-weight:1000;letter-spacing:.65px;}" +
    "#diqFoodIQPanel .foodSub{margin:0 0 8px;font-size:11px;font-weight:760;line-height:1.22;color:rgba(255,255,255,.76);}" +
    "#diqFoodIQPanel .foodGrid{display:flex;gap:7px;overflow:auto;-webkit-overflow-scrolling:touch;padding-bottom:2px;margin-top:7px;}" +
    "#diqFoodIQPanel .foodChip{flex:0 0 auto;min-height:34px;padding:0 11px;border-radius:999px;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.14);color:#fff;font-size:9px;font-weight:1000;letter-spacing:.55px;}" +
    "#diqFoodIQPanel .foodChip.primary{color:#061018;background:linear-gradient(135deg,#ffe778,#28ffbe);border-color:rgba(255,255,255,.45);}" +
    "#diqFoodIQPanel .foodChip.more{color:#061018;background:linear-gradient(135deg,#58a6ff,#28ffbe);border-color:rgba(255,255,255,.45);}" +
    "#diqFoodIQMoreGrid{display:none;}" +
    "#diqFoodIQPanel.more #diqFoodIQMoreGrid{display:flex;}" +
    "body.diqFoodIQOpen .diqTravelChipRow,body.diqFoodIQOpen #diqTravelPreviewCard{display:none!important;}" +
    "body.diqFoodIQOpen .diqTravelScanCard{border-color:rgba(40,255,190,.26);box-shadow:0 18px 42px rgba(0,0,0,.42),0 0 28px rgba(40,255,190,.10);}" +
    "body.diqTravelScanCollapsed #diqFoodIQPanel{display:none!important;}" +
    "body.diqTravelScanCollapsed .diqTravelScopeToggle,body.diqTravelScanCollapsed .diqTravelChipRow,body.diqTravelScanCollapsed #diqTravelPreviewCard{display:none!important;}" +
    "body.diqTravelScanCollapsed .diqTravelScanCard{max-height:46px!important;}" +
    "body.diqTravelScanCollapsed .diqTravelScanInner{padding:9px 10px!important;}" +
    ".diqTravelScopeToggle{display:grid;grid-template-columns:1fr 1fr 1fr;gap:7px;margin-bottom:8px;}" +
    ".diqTravelScopeBtn{min-height:32px;border-radius:999px;background:rgba(255,255,255,.055);border:1px solid rgba(255,255,255,.12);color:rgba(255,255,255,.72);font-size:9px;font-weight:1000;letter-spacing:.72px;}" +
    ".diqTravelScopeBtn.on{color:#061018;background:linear-gradient(135deg,#58a6ff,#28ffbe);border-color:rgba(255,255,255,.45);box-shadow:0 10px 22px rgba(0,0,0,.25),0 0 22px rgba(88,166,255,.14);}" +
    "#diqTravelPreviewCard{display:none;margin-top:8px;padding:10px 11px;border-radius:18px;background:rgba(88,166,255,.075);border:1px solid rgba(88,166,255,.18);}" +
    "#diqTravelPreviewCard.on{display:block;}" +
    "#diqTravelPreviewCard .previewTitle{font-size:10px;font-weight:1000;letter-spacing:1px;color:#bcd8ff;text-transform:uppercase;}" +
    "#diqTravelPreviewCard .previewSub{margin-top:4px;font-size:11px;font-weight:760;line-height:1.22;color:rgba(255,255,255,.76);}" +
    ".diqTravelScanTitle{font-size:10px;font-weight:1000;letter-spacing:1.1px;color:#bcd8ff;text-transform:uppercase;}" +
    ".diqTravelScanScope{font-size:9px;font-weight:1000;letter-spacing:.7px;color:#ffe5a6;text-transform:uppercase;white-space:nowrap;}" +
    ".diqTravelChipRow{display:flex;gap:8px;overflow:auto;-webkit-overflow-scrolling:touch;padding-bottom:2px;}" +
    ".diqTravelChip{flex:0 0 auto;min-height:38px;padding:0 13px;border-radius:999px;color:#fff;background:rgba(255,255,255,.07);border:1px solid rgba(255,255,255,.14);font-size:10px;font-weight:1000;letter-spacing:.65px;box-shadow:0 10px 22px rgba(0,0,0,.25);}" +
    ".diqTravelChip.on{color:#061018;background:linear-gradient(135deg,#58a6ff,#28ffbe);border-color:rgba(255,255,255,.45);box-shadow:0 12px 26px rgba(0,0,0,.30),0 0 24px rgba(88,166,255,.18);}" +
    "#diqTravelScanLoading{position:fixed;left:14px;right:14px;bottom:calc(236px + env(safe-area-inset-bottom,0px));z-index:88;border-radius:18px;padding:11px 13px;background:rgba(5,12,22,.96);border:1px solid rgba(88,166,255,.30);box-shadow:0 18px 42px rgba(0,0,0,.44),0 0 26px rgba(88,166,255,.13);color:#fff;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;display:none;pointer-events:none;}" +
    "#diqTravelScanLoading.on{display:flex;align-items:center;gap:10px;}" +
    "#diqTravelScanLoading .pulse{width:12px;height:12px;border-radius:999px;background:#58a6ff;box-shadow:0 0 18px rgba(88,166,255,.68);animation:diqTravelPulse 1.05s ease-in-out infinite;flex:0 0 auto;}" +
    "#diqTravelScanLoading .title{font-size:10px;font-weight:1000;letter-spacing:1px;color:#bcd8ff;text-transform:uppercase;}" +
    "#diqTravelScanLoading .sub{margin-top:2px;font-size:11px;font-weight:820;color:rgba(255,255,255,.78);white-space:nowrap;overflow:hidden;text-overflow:ellipsis;}" +
    "@keyframes diqTravelPulse{0%{transform:scale(.82);opacity:.72;}50%{transform:scale(1.18);opacity:1;}100%{transform:scale(.82);opacity:.72;}}" +
    "#diqTravelInfoCard{position:fixed;left:14px;right:14px;bottom:calc(92px + env(safe-area-inset-bottom,0px));z-index:90;border-radius:22px;padding:12px 12px calc(14px + env(safe-area-inset-bottom,0px));background:rgba(5,12,22,.96);border:1px solid rgba(88,166,255,.30);box-shadow:0 22px 54px rgba(0,0,0,.54),0 0 28px rgba(88,166,255,.11);color:#fff;font-family:system-ui,-apple-system,BlinkMacSystemFont,'Segoe UI',sans-serif;display:none;max-height:42vh;overflow:auto;-webkit-overflow-scrolling:touch;}" +
    "#diqTravelInfoCard.on{display:block;}" +
    "#diqTravelInfoCard .kicker{font-size:9px;font-weight:1000;letter-spacing:1px;color:#bcd8ff;text-transform:uppercase;}" +
    "#diqTravelInfoCard .title{margin-top:4px;font-size:19px;line-height:1.05;font-weight:1000;letter-spacing:-.35px;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;}" +
    "#diqTravelInfoCard .sub{margin-top:6px;color:rgba(255,255,255,.72);font-size:11px;line-height:1.25;font-weight:760;display:block;overflow:visible;}" +
    "#diqTravelInfoCard .actions{display:grid;grid-template-columns:1fr 1fr;gap:9px;margin-top:10px;}" +
    "#diqTravelInfoCard button{min-height:40px;border-radius:15px;border:1px solid rgba(255,255,255,.14);font-size:11px;font-weight:1000;letter-spacing:.45px;}" +
    "#diqTravelInfoCard .route{color:#061018;background:linear-gradient(135deg,#58a6ff,#28ffbe);}" +
    "#diqTravelInfoCard .close{color:#fff;background:rgba(255,255,255,.08);}" +
    "#diqTravelInfoCard .photo{height:118px;border-radius:18px;margin-bottom:10px;background:linear-gradient(135deg,rgba(88,166,255,.18),rgba(40,255,190,.12));border:1px solid rgba(255,255,255,.12);display:flex;align-items:center;justify-content:center;overflow:hidden;}#diqTravelInfoCard .photo.hasPhoto{background:#061018;}#diqTravelInfoCard .photo img{width:100%;height:100%;object-fit:cover;display:block;}#diqTravelInfoCard .fallbackIcon{font-size:36px;filter:drop-shadow(0 0 16px rgba(40,255,190,.25));}#diqTravelInfoCard .fallbackText{margin-left:10px;font-size:10px;font-weight:1000;letter-spacing:1px;color:#b6ffeb;text-transform:uppercase;}#diqTravelInfoCard .meta{font-size:11px;font-weight:950;color:#ffe5a6;margin-bottom:5px;}#diqTravelInfoCard .why{font-size:12px;font-weight:780;color:rgba(255,255,255,.78);line-height:1.3;margin-bottom:6px;}#diqTravelInfoCard .score{font-size:11px;font-weight:1000;color:#b6ffeb;letter-spacing:.25px;}#diqTravelInfoCard .actions{grid-template-columns:1fr 1fr 1fr 1.2fr!important;}#diqTravelInfoCard .save{color:#fff;background:rgba(40,255,190,.12);}#diqTravelInfoCard .share{color:#fff;background:rgba(88,166,255,.13);}@media(orientation:landscape){#diqTravelInfoCard{left:auto;right:14px;bottom:calc(90px + env(safe-area-inset-bottom,0px));width:360px;max-height:48vh;}.diqTravelScanCard{max-width:520px;}}";
  style = document.createElement("style");
  style.id = "diqTravelScanStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));
  try{ document.head.appendChild(style); }catch(e){}
}


function setTravelScanCollapsed(collapsed){
  var btn;
  travelScanCollapsed = !!collapsed;
  try{
    if(travelScanCollapsed){ document.body.classList.add("diqTravelScanCollapsed"); }
    else{ document.body.classList.remove("diqTravelScanCollapsed"); }
  }catch(e){}
  btn = byId("diqTravelScanMini");
  if(btn){ btn.textContent = travelScanCollapsed ? "EXPAND" : "MINIMIZE"; }
  if(mapLoaded && map && routeReady && routeGeo){
    window.setTimeout(function(){ fitRoute(); },90);
  }
}

function toggleTravelScanCollapsed(){
  setTravelScanCollapsed(!travelScanCollapsed);
}

function dedupeQueryList(items){
  var seen = {};
  var out = [];
  var i;
  var key;
  for(i=0;i<items.length;i++){
    key = normText(items[i]);
    if(!key || seen[key]){ continue; }
    seen[key] = true;
    out.push(items[i]);
  }
  return out;
}

function destinationSearchName(center){
  var label = clean(center && center.label ? center.label : (dest && dest.label ? dest.label : ""));
  var full = clean(dest && dest.full ? dest.full : "");
  var text = clean(label + " " + full);
  if(!text){ return "destination"; }
  return text;
}

function addVacationDestinationQueries(cat,queries,center){
  var place = destinationSearchName(center);
  var n = normText(place);
  function add(v){ if(v){ queries.push(v); } }
  if(!center || center.scope !== "near_destination"){ return dedupeQueryList(queries); }

  if(cat === "shopping"){
    add("shopping near " + place);
    add("stores near " + place);
    add("shopping center near " + place);
    add("outlet mall near " + place);
    add("souvenir shops near " + place);
    add("gift shop near " + place);
    add("beach shop near " + place);
    add("surf shop near " + place);
    add("boutique near " + place);
    add("local shops near " + place);
    add("downtown shopping near " + place);
    add("Walmart near " + place);
    add("Target near " + place);
    add("Publix near " + place);
  }

  if(cat === "food"){
    add("restaurants near " + place);
    add("seafood near " + place);
    add("breakfast near " + place);
    add("local restaurants near " + place);
  }else if(isFoodIQCat(cat)){
    var foodQs = foodIntentQueries(cat);
    var fqIndex;
    add(foodIntentLabel(cat) + " near " + place);
    for(fqIndex=0; fqIndex<foodQs.length; fqIndex++){
      add(String(foodQs[fqIndex]) + " near " + place);
    }
  }

  if(cat === "beach"){
    add("public beach access near " + place);
    add("beach access near " + place);
    add("waterfront park near " + place);
    add("pier near " + place);
  }

  if(cat === "family"){
    add("family fun near " + place);
    add("kids activities near " + place);
    add("family attractions near " + place);
    add("indoor activities near " + place);
    add("mini golf near " + place);
    add("arcade near " + place);
    add("trampoline park near " + place);
    add("ice cream near " + place);
    add("parks near " + place);
  }

  if(cat === "hotels"){
    add("hotels near " + place);
    add("lodging near " + place);
    add("motel near " + place);
    add("inn and suites near " + place);
    add("Drury Inn near " + place);
    add("Hampton Inn near " + place);
    add("Holiday Inn Express near " + place);
    add("Hilton hotel near " + place);
    add("Marriott hotel near " + place);
    add("Comfort Suites near " + place);
  }

  if(cat === "popular" || cat === "popular_tonight"){
    add("popular restaurants near " + place);
    add("sports bar near " + place);
    add("bar and grill near " + place);
    add("patio restaurant near " + place);
    add("live music near " + place);
    add("open late restaurants near " + place);
    add("happy hour near " + place);
    add("local hangout near " + place);
  }

  if(cat === "local"){
    add("local favorite restaurants near " + place);
    add("hidden gem restaurants near " + place);
    add("locally owned restaurants near " + place);
    add("best local coffee near " + place);
    add("local shops near " + place);
  }

  if(cat === "essentials" || cat === "preview"){
    add("grocery near " + place);
    add("pharmacy near " + place);
    add("urgent care near " + place);
    add("gas station near " + place);
    add("public parking near " + place);
  }

  if(n.indexOf("destin") > -1){
    if(cat === "food_seafood"){ add("seafood restaurants Destin Florida"); add("waterfront seafood Destin Florida"); add("HarborWalk Village restaurants"); }
    if(cat === "food_family"){ add("family restaurants Destin Florida"); add("kid friendly restaurants Destin Florida"); }
    if(cat === "food_breakfast"){ add("breakfast restaurants Destin Florida"); add("brunch Destin Florida"); }
    if(cat === "shopping" || cat === "preview"){
      add("Destin Commons");
      add("Silver Sands Premium Outlets");
      add("HarborWalk Village shops");
      add("shopping Destin Florida");
      add("souvenir shops Destin Florida");
      add("beach shops Destin Florida");
    }
    if(cat === "food" || cat === "food_local" || cat === "food_seafood" || cat === "food_family" || cat === "food_dinner" || cat === "local" || cat === "preview"){
      add("HarborWalk Village restaurants");
    }
    if(cat === "food" || cat === "food_seafood" || cat === "local" || cat === "preview"){
      add("seafood restaurants Destin Florida");
    }
    if(cat === "food_mexican"){
      add("Mexican restaurants Destin Florida");
      add("taco restaurants Destin Florida");
      add("Tex Mex Destin Florida");
    }
    if(cat === "food_chinese"){
      add("Chinese restaurants Destin Florida");
      add("Asian restaurants Destin Florida");
    }
    if(cat === "food_pizza"){
      add("pizza restaurants Destin Florida");
      add("pizzeria Destin Florida");
    }
    if(cat === "food_bbq"){
      add("BBQ restaurants Destin Florida");
      add("barbecue Destin Florida");
    }
    if(cat === "food_burgers"){
      add("burger restaurants Destin Florida");
    }
    if(cat === "food_italian"){
      add("Italian restaurants Destin Florida");
    }
    if(cat === "food_steakhouse"){
      add("steakhouse Destin Florida");
    }
    if(cat === "food_healthy"){
      add("healthy restaurants Destin Florida");
      add("salad restaurants Destin Florida");
      add("smoothie Destin Florida");
    }
    if(cat === "food_dessert"){
      add("ice cream Destin Florida");
      add("dessert Destin Florida");
      add("bakery Destin Florida");
    }
    if(cat === "food_cafe"){
      add("coffee shops Destin Florida");
      add("cafes Destin Florida");
    }
    if(cat === "beach" || cat === "attractions" || cat === "preview"){
      add("Henderson Beach State Park");
      add("Crystal Beach access Destin");
      add("Destin Harbor Boardwalk");
    }
    if(cat === "family" || cat === "preview"){
      add("Big Kahuna's Water Park");
      add("The Track Destin");
      add("mini golf Destin Florida");
    }
  }

  if(n.indexOf("gulf shores") > -1 || n.indexOf("orange beach") > -1){
    if(cat === "shopping" || cat === "preview"){
      add("Tanger Outlets Foley");
      add("The Wharf Orange Beach shopping");
      add("souvenir shops Gulf Shores");
      add("beach shops Gulf Shores");
    }
  }

  return dedupeQueryList(queries);
}

function travelScanRadius(cat,scope){
  if((activeTravelTripStyle && activeTravelTripStyle !== "general") && scope === "near_destination"){ return 65; }
  if(cat === "golf_trip" || cat === "food_wine"){ return scope === "near_destination" ? 65 : 32; }
  if(scope === "near_destination"){
    if(cat === "shopping" || cat === "preview" || cat === "hotels" || cat === "popular" || cat === "popular_tonight" || cat === "local"){ return 55; }
    if(cat === "food" || isFoodIQCat(cat)){ return 42; }
    if(cat === "beach" || cat === "family" || cat === "attractions"){ return 45; }
    return 38;
  }
  if(cat === "shopping" || cat === "preview" || cat === "hotels" || cat === "popular" || cat === "popular_tonight" || cat === "local"){ return 28; }
  if(cat === "food" || isFoodIQCat(cat)){ return 22; }
  return 18;
}

function routeVisibilityFitPadding(){
  if(travelScanCollapsed){ return { top:210,right:46,bottom:190,left:46 }; }
  return { top:230,right:46,bottom:168,left:46 };
}

function ensureTravelScanUI(){
  var card;
  var searchCard;
  var chips = [
    ["preview","PREVIEW"],["popular","POPULAR TONIGHT"],["local","LOCAL PICKS"],["food","FOOD"],["coffee","COFFEE"],
    ["live_music","LIVE MUSIC"],["waterfront","WATERFRONT"],["patio","PATIO"],["hidden_gems","HIDDEN GEMS"],["scenic","SCENIC"],
    ["hotels","HOTELS"],["groceries","GROCERIES"],["shopping","SHOPPING"],["fuel","FUEL"],["pharmacy","PHARMACY"],
    ["attractions","ATTRACTIONS"],["parking","PARKING"],["beach","BEACH"],["family","FAMILY"],["essentials","ESSENTIALS"]
  ];
  var html = "";
  var i;
  var nodes;

  injectTravelScanStyles();

  if(!byId("diqTravelScanCard")){
    card = document.createElement("div");
    card.id = "diqTravelScanCard";
    card.className = "diqTravelScanCard";
    html += '<div class="diqTravelScanInner">';
    html += '<div class="diqTravelScanHead"><div class="diqTravelScanTitle">TRAVEL SCANS</div><div style="display:flex;align-items:center;gap:8px;"><div class="diqTravelScanScope" id="diqTravelScanScope">NEAR ME</div><button class="diqTravelScanMini" id="diqTravelScanMini" type="button">MINIMIZE</button></div></div>';
    html += '<div class="diqTravelScopeToggle"><button class="diqTravelScopeBtn" id="diqTravelNearMe" type="button">NEAR ME</button><button class="diqTravelScopeBtn" id="diqTravelNearDest" type="button">NEAR DESTINATION</button><button class="diqTravelScopeBtn" id="diqTravelAlongRoute" type="button">ALONG ROUTE</button></div>';
    html += '<div class="diqTravelChipRow">';
    for(i=0;i<chips.length;i++){
      html += '<button class="diqTravelChip" type="button" data-travel-cat="' + esc(chips[i][0]) + '">' + esc(chips[i][1]) + '</button>';
    }
    html += '</div>';
    html += '<div id="diqTravelPreviewCard"><div class="previewTitle">DESTINATION PREVIEW</div><div class="previewSub" id="diqTravelPreviewText">Choose a destination to preview hotels, food, groceries, family stops, beach access, parking, and essentials around arrival.</div></div>';
    html += '<div id="diqFoodIQPanel"><div class="foodHead"><div class="foodTitle">FOOD IQ</div><button class="foodClose" id="diqFoodIQClose" type="button">BACK</button></div><div class="foodSub">Pick a food lane. Drive IQ will show the strongest 5–8 travel-fit options.</div><div class="foodGrid" id="diqFoodIQPrimaryGrid"><button class="foodChip primary" data-food-iq="food_quick" type="button">QUICK BITE</button><button class="foodChip primary" data-food-iq="food_local" type="button">LOCAL FAVORITES</button><button class="foodChip primary" data-food-iq="food_family" type="button">FAMILY FRIENDLY</button><button class="foodChip primary" data-food-iq="food_seafood" type="button">SEAFOOD</button><button class="foodChip" data-food-iq="food_breakfast" type="button">BREAKFAST</button><button class="foodChip" data-food-iq="food_dessert" type="button">DESSERT</button><button class="foodChip" data-food-iq="food_dinner" type="button">DINNER</button><button class="foodChip" data-food-iq="food_cafe" type="button">COFFEE / CAFE</button><button class="foodChip more" id="diqFoodIQMore" type="button">MORE</button></div><div class="foodGrid" id="diqFoodIQMoreGrid"><button class="foodChip" data-food-iq="food_mexican" type="button">MEXICAN</button><button class="foodChip" data-food-iq="food_chinese" type="button">CHINESE</button><button class="foodChip" data-food-iq="food_pizza" type="button">PIZZA</button><button class="foodChip" data-food-iq="food_bbq" type="button">BBQ</button><button class="foodChip" data-food-iq="food_burgers" type="button">BURGERS</button><button class="foodChip" data-food-iq="food_italian" type="button">ITALIAN</button><button class="foodChip" data-food-iq="food_steakhouse" type="button">STEAKHOUSE</button><button class="foodChip" data-food-iq="food_healthy" type="button">HEALTHY</button></div></div>';
    html += '</div>';
    card.innerHTML = html;

    searchCard = document.querySelector ? document.querySelector(".diqSearchCard") : null;
    if(searchCard && searchCard.parentNode){
      try{ searchCard.parentNode.insertBefore(card, searchCard.nextSibling); }catch(e1){}
    }else{
      try{ document.body.appendChild(card); }catch(e2){}
    }
  }

  if(!byId("diqTravelScanLoading")){
    card = document.createElement("div");
    card.id = "diqTravelScanLoading";
    card.innerHTML = '<div class="pulse"></div><div><div class="title" id="diqTravelScanLoadTitle">SCANNING</div><div class="sub" id="diqTravelScanLoadSub">Finding places worth stopping for...</div></div>';
    try{ document.body.appendChild(card); }catch(e3){}
  }

  if(!byId("diqTravelInfoCard")){
    card = document.createElement("div");
    card.id = "diqTravelInfoCard";
    card.innerHTML = '<div class="kicker">PLACE IQ</div><div class="title" id="diqTravelInfoTitle">Travel stop</div><div class="sub" id="diqTravelInfoSub">Ready</div><div class="actions"><button type="button" class="close" id="diqTravelInfoClose">CLOSE</button><button type="button" class="save" id="diqTravelInfoSave">SAVE</button><button type="button" class="share" id="diqTravelInfoShare">SHARE</button><button type="button" class="route" id="diqTravelInfoRoute">ADD STOP</button></div>';
    try{ document.body.appendChild(card); }catch(e4){}
    if(byId("diqTravelInfoClose")){ byId("diqTravelInfoClose").onclick = closeTravelInfoCard; }
  }

  nodes = document.querySelectorAll ? document.querySelectorAll("[data-travel-cat]") : [];
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(){
      startTravelScan(String(this.getAttribute("data-travel-cat") || ""));
    };
  }

  if(byId("diqTravelNearMe")){
    byId("diqTravelNearMe").onclick = function(){
      manualTravelScanScope = "near_me";
      updateTravelScanScope();
      toast("Travel scans set near you");
    };
  }

  if(byId("diqTravelNearDest")){
    byId("diqTravelNearDest").onclick = function(){
      if(!dest || !finite(Number(dest.lat)) || !finite(Number(dest.lng))){
        toast("Choose a destination first");
        return;
      }
      manualTravelScanScope = "near_destination";
      updateTravelScanScope();
      toast("Travel scans set near destination");
    };
  }

  if(byId("diqTravelAlongRoute")){
    byId("diqTravelAlongRoute").onclick = function(){
      if(!routeReady || !routeGeo){
        toast("Plan a route first");
        return;
      }
      manualTravelScanScope = "along_route";
      updateTravelScanScope();
      toast("Travel scans set along route");
    };
  }

  if(byId("diqTravelScanMini")){
    byId("diqTravelScanMini").onclick = function(){ toggleTravelScanCollapsed(); };
  }

  if(byId("diqFoodIQClose")){
    byId("diqFoodIQClose").onclick = closeFoodIQPanel;
  }

  if(byId("diqFoodIQMore")){
    byId("diqFoodIQMore").onclick = function(){ setFoodIQMore(!foodIQMoreOpen); };
  }

  nodes = document.querySelectorAll ? document.querySelectorAll("[data-food-iq]") : [];
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(){
      closeFoodIQPanel();
      startTravelScan(String(this.getAttribute("data-food-iq") || "food_local"));
    };
  }

  setTravelScanCollapsed(travelScanCollapsed);
  updateTravelScanScope();
}

function travelScanCenter(){
  var feature;
  var coords;
  var pick;

  if(manualTravelScanScope === "near_me" && lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
    return { lat:Number(lastFix.lat), lng:Number(lastFix.lng), label:"you", scope:"near_me" };
  }

  if(manualTravelScanScope === "along_route" && routeReady){
    feature = getActiveRouteFeature();
    coords = feature && feature.geometry ? flattenRouteCoords(feature.geometry) : [];
    if(coords && coords.length){
      pick = coords[Math.max(0,Math.min(coords.length - 1,Math.floor(coords.length * 0.55)))];
      if(pick && finite(Number(pick[0])) && finite(Number(pick[1]))){
        return { lat:Number(pick[1]), lng:Number(pick[0]), label:"your route", scope:"along_route" };
      }
    }
  }

  if((manualTravelScanScope === "near_destination" || routeReady) && dest && finite(Number(dest.lat)) && finite(Number(dest.lng))){
    return { lat:Number(dest.lat), lng:Number(dest.lng), label:String(dest.label || "destination"), scope:"near_destination" };
  }

  if(dest && finite(Number(dest.lat)) && finite(Number(dest.lng))){
    return { lat:Number(dest.lat), lng:Number(dest.lng), label:String(dest.label || "destination"), scope:"near_destination" };
  }

  if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
    return { lat:Number(lastFix.lat), lng:Number(lastFix.lng), label:"you", scope:"near_me" };
  }

  return null;
}

function updateTravelScanScope(){
  var el = byId("diqTravelScanScope");
  var center = travelScanCenter();
  var nearMe = byId("diqTravelNearMe");
  var nearDest = byId("diqTravelNearDest");
  var alongRoute = byId("diqTravelAlongRoute");
  var preview = byId("diqTravelPreviewCard");
  var previewText = byId("diqTravelPreviewText");

  if(el){
    if(center && center.scope === "near_destination"){ el.textContent = "NEAR DESTINATION"; }
    else if(center && center.scope === "along_route"){ el.textContent = "ALONG ROUTE"; }
    else{ el.textContent = "NEAR ME"; }
  }

  if(nearMe){ nearMe.className = "diqTravelScopeBtn" + (!center || center.scope === "near_me" ? " on" : ""); }
  if(nearDest){ nearDest.className = "diqTravelScopeBtn" + (center && center.scope === "near_destination" ? " on" : ""); }
  if(alongRoute){ alongRoute.className = "diqTravelScopeBtn" + (center && center.scope === "along_route" ? " on" : ""); }

  if(preview){
    if(dest && finite(Number(dest.lat)) && finite(Number(dest.lng))){
      preview.className = "on";
      if(previewText){
        previewText.textContent = "Preview hotels, food, events, local favorites, parking, scenic stops, and essentials around " + String(dest.label || "your destination") + ".";
      }
    }else{
      preview.className = "";
    }
  }
}

function isFoodIQCat(cat){
  return String(cat || "").indexOf("food_") === 0;
}

function foodIntentLabel(cat){
  if(cat === "food_quick"){ return "Quick Bite"; }
  if(cat === "food_local"){ return "Local Favorites"; }
  if(cat === "food_family"){ return "Family Friendly"; }
  if(cat === "food_seafood"){ return "Seafood"; }
  if(cat === "food_breakfast"){ return "Breakfast"; }
  if(cat === "food_dinner"){ return "Dinner"; }
  if(cat === "food_dessert"){ return "Dessert"; }
  if(cat === "food_cafe"){ return "Coffee / Cafe"; }
  if(cat === "food_mexican"){ return "Mexican"; }
  if(cat === "food_chinese"){ return "Chinese"; }
  if(cat === "food_pizza"){ return "Pizza"; }
  if(cat === "food_bbq"){ return "BBQ"; }
  if(cat === "food_burgers"){ return "Burgers"; }
  if(cat === "food_italian"){ return "Italian"; }
  if(cat === "food_steakhouse"){ return "Steakhouse"; }
  if(cat === "food_healthy"){ return "Healthy"; }
  return "Food IQ";
}

function foodIntentQueries(cat){
  var out = [];
  function add(v){ if(v){ out.push(v); } }
  if(cat === "food_quick"){ add("fast food"); add("quick bite"); add("drive thru restaurant"); add("sandwich shop"); add("burger restaurant"); add("taco restaurant"); add("casual restaurant"); }
  else if(cat === "food_local"){ add("local favorite restaurant"); add("top rated restaurant"); add("best restaurants"); add("local restaurant"); add("downtown restaurant"); add("popular restaurant"); }
  else if(cat === "food_family"){ add("family restaurant"); add("kid friendly restaurant"); add("casual family restaurant"); add("pizza restaurant"); add("burger restaurant"); add("seafood restaurant"); }
  else if(cat === "food_seafood"){ add("seafood restaurant"); add("oyster bar"); add("fish restaurant"); add("shrimp restaurant"); add("waterfront seafood restaurant"); }
  else if(cat === "food_breakfast"){ add("breakfast restaurant"); add("brunch restaurant"); add("diner"); add("pancake house"); add("breakfast cafe"); }
  else if(cat === "food_dinner"){ add("dinner restaurant"); add("restaurant"); add("steakhouse"); add("seafood restaurant"); add("local restaurant"); }
  else if(cat === "food_dessert"){ add("dessert"); add("ice cream"); add("bakery"); add("donut shop"); add("sweet shop"); }
  else if(cat === "food_cafe"){ add("coffee shop"); add("cafe"); add("breakfast cafe"); add("bakery cafe"); add("espresso"); }
  else if(cat === "food_mexican"){ add("Mexican restaurant"); add("taco restaurant"); add("burrito restaurant"); add("tex mex restaurant"); }
  else if(cat === "food_chinese"){ add("Chinese restaurant"); add("Asian restaurant"); add("takeout Chinese"); add("noodle restaurant"); }
  else if(cat === "food_pizza"){ add("pizza restaurant"); add("pizzeria"); add("pizza delivery"); add("Italian pizza"); }
  else if(cat === "food_bbq"){ add("barbecue restaurant"); add("BBQ restaurant"); add("smokehouse"); add("ribs restaurant"); }
  else if(cat === "food_burgers"){ add("burger restaurant"); add("hamburger restaurant"); add("grill restaurant"); add("fast casual burger"); }
  else if(cat === "food_italian"){ add("Italian restaurant"); add("pasta restaurant"); add("pizza restaurant"); }
  else if(cat === "food_steakhouse"){ add("steakhouse"); add("steak restaurant"); add("grill steakhouse"); }
  else if(cat === "food_healthy"){ add("healthy restaurant"); add("salad restaurant"); add("juice bar"); add("smoothie shop"); add("vegetarian restaurant"); add("poke bowl"); }
  else { add("restaurant"); add("food"); }
  return out;
}

function foodIntentBadge(cat){
  if(cat === "food_quick"){ return "QUICK BITE"; }
  if(cat === "food_local"){ return "LOCAL FAVORITE"; }
  if(cat === "food_family"){ return "FAMILY PICK"; }
  if(cat === "food_seafood"){ return "SEAFOOD PICK"; }
  if(cat === "food_breakfast"){ return "BREAKFAST PICK"; }
  if(cat === "food_dinner"){ return "DINNER PICK"; }
  if(cat === "food_dessert"){ return "DESSERT STOP"; }
  if(cat === "food_cafe"){ return "CAFE PICK"; }
  return String(foodIntentLabel(cat) || "FOOD IQ").toUpperCase();
}

function setFoodIQTitle(open){
  var title;
  try{
    title = document.querySelector ? document.querySelector(".diqTravelScanTitle") : null;
    if(title){ title.textContent = open ? "FOOD IQ" : "TRAVEL SCANS"; }
  }catch(e){}
}

function setFoodIQMore(open){
  var panel = byId("diqFoodIQPanel");
  var more = byId("diqFoodIQMore");
  foodIQMoreOpen = !!open;
  if(panel){ panel.className = foodIQOpen ? (foodIQMoreOpen ? "on more" : "on") : ""; }
  if(more){ more.textContent = foodIQMoreOpen ? "LESS" : "MORE"; }
}

function closeFoodIQPanel(){
  var panel = byId("diqFoodIQPanel");
  foodIQOpen = false;
  foodIQMoreOpen = false;
  if(panel){ panel.className = ""; }
  try{ document.body.classList.remove("diqFoodIQOpen"); }catch(e){}
  setFoodIQTitle(false);
  updateTravelScanScope();
}

function openFoodIQPanel(){
  ensureTravelScanUI();
  setTravelScanCollapsed(false);
  foodIQOpen = true;
  foodIQMoreOpen = false;
  try{ document.body.classList.add("diqFoodIQOpen"); }catch(e){}
  setFoodIQTitle(true);
  setFoodIQMore(false);
  setIntel("FOOD IQ","green");
  subline("Choose what kind of food you want");
  toast("Food IQ");
}

function travelCategoryLabel(cat){
  if(isFoodIQCat(cat)){ return foodIntentLabel(cat); }
  if(cat === "preview"){ return "Destination Preview"; }
  if(cat === "hotels"){ return "Hotels"; }
  if(cat === "food"){ return "Food"; }
  if(cat === "coffee"){ return "Coffee"; }
  if(cat === "groceries"){ return "Groceries"; }
  if(cat === "shopping"){ return "Shopping"; }
  if(cat === "fuel"){ return "Fuel"; }
  if(cat === "pharmacy"){ return "Pharmacy"; }
  if(cat === "attractions"){ return "Attractions"; }
  if(cat === "parking"){ return "Parking"; }
  if(cat === "beach"){ return "Beach / Water"; }
  if(cat === "family"){ return "Family Stops"; }
  if(cat === "essentials"){ return "Essentials"; }
  if(cat === "popular" || cat === "popular_tonight"){ return "Popular Tonight"; }
  if(cat === "local"){ return "Local Picks"; }
  return "Travel";
}

function travelCategoryQueries(cat){
  var out = [];
  function add(v){ if(v){ out.push(v); } }
  if(isFoodIQCat(cat)){ return foodIntentQueries(cat); }
  if(cat === "preview"){ add("hotel"); add("resort"); add("restaurant"); add("seafood restaurant"); add("grocery store"); add("pharmacy"); add("gas station"); add("public parking"); add("tourist attraction"); add("beach"); add("public beach access"); add("family attraction"); add("visitor center"); }
  else if(cat === "hotels"){ add("hotel"); add("hotels"); add("resort"); add("lodging"); add("motel"); add("inn and suites"); add("Drury Inn"); add("Hampton Inn"); add("Holiday Inn Express"); add("Marriott hotel"); add("Hilton hotel"); add("Comfort Suites"); add("Best Western"); add("Home2 Suites"); }
  else if(cat === "food"){ add("restaurant"); add("restaurants"); add("food"); add("seafood restaurant"); add("local restaurant"); add("family restaurant"); add("bar and grill"); add("popular restaurant"); }
  else if(cat === "coffee"){ add("coffee"); add("coffee shop"); add("cafe"); add("breakfast cafe"); add("Starbucks"); add("drive thru coffee"); add("espresso"); add("matcha"); add("tea shop"); add("smoothie"); add("nutrition drinks"); }
  else if(cat === "groceries"){ add("grocery store"); add("groceries"); add("supermarket"); add("market"); add("Kroger"); add("Publix"); add("Walmart grocery"); add("Target grocery"); add("Aldi"); add("Whole Foods"); }
  else if(cat === "shopping"){ add("shopping"); add("shopping center"); add("outlet mall"); add("mall"); add("retail store"); add("stores"); add("beach shop"); add("surf shop"); add("gift shop"); add("souvenir shop"); add("boutique"); add("local shops"); add("downtown shopping"); add("Walmart"); add("Target"); add("Publix"); }
  else if(cat === "fuel"){ add("gas station"); add("fuel"); add("convenience store"); add("travel center"); }
  else if(cat === "pharmacy"){ add("pharmacy"); add("drugstore"); add("CVS"); add("Walgreens"); }
  else if(cat === "attractions"){ add("attraction"); add("tourist attraction"); add("museum"); add("aquarium"); add("zoo"); add("theme park"); add("landmark"); add("beach"); add("park"); }
  else if(cat === "parking"){ add("parking"); add("parking lot"); add("parking garage"); add("public parking"); }
  else if(cat === "beach"){ add("beach"); add("public beach access"); add("beach access"); add("waterfront park"); add("boardwalk"); add("pier"); add("marina"); add("boat ramp"); add("lake access"); add("river access"); }
  else if(cat === "family"){ add("family attraction"); add("kids activities"); add("indoor activities"); add("trampoline park"); add("Urban Air"); add("children's museum"); add("playground"); add("water park"); add("mini golf"); add("aquarium"); add("zoo"); add("arcade"); add("ice cream"); add("family restaurant"); add("park"); }
  else if(cat === "golf_trip"){ add("golf course"); add("public golf course"); add("driving range"); add("country club"); add("golf club"); add("tee times"); add("clubhouse restaurant"); }
  else if(cat === "food_wine"){ add("winery"); add("wine bar"); add("brewery"); add("distillery"); add("cocktail lounge"); add("fine dining restaurant"); add("chef restaurant"); add("tasting room"); }
  else if(cat === "popular" || cat === "popular_tonight"){ add("popular restaurants"); add("sports bar"); add("bar and grill"); add("patio restaurant"); add("live music"); add("open late restaurants"); add("happy hour"); add("local hangout"); add("brewery restaurant"); }
  else if(cat === "live_music"){ add("live music venue"); add("live music bar"); add("concert venue"); add("music hall"); add("jazz club"); add("brewery live music"); }
  else if(cat === "waterfront"){ add("waterfront restaurant"); add("waterfront park"); add("marina"); add("harbor"); add("pier"); add("boardwalk"); add("beach bar"); }
  else if(cat === "patio"){ add("patio restaurant"); add("rooftop bar"); add("beer garden"); add("outdoor dining"); add("courtyard restaurant"); add("brewery patio"); }
  else if(cat === "hidden_gems"){ add("hidden gem"); add("local favorite"); add("locally owned restaurant"); add("historic district"); add("local market"); add("mural"); add("overlook"); }
  else if(cat === "scenic"){ add("scenic overlook"); add("sunset spot"); add("waterfront view"); add("scenic park"); add("photo spot"); add("historic landmark"); add("nature trail"); }
  else if(cat === "essentials"){ add("grocery store"); add("pharmacy"); add("urgent care"); add("gas station"); add("Walmart"); add("Target"); add("laundromat"); add("public parking"); add("visitor center"); }
  else { add("local favorite"); add("hidden gem restaurant"); add("top rated restaurant"); add("locally owned restaurant"); add("local coffee shop"); add("local attraction"); add("things to do"); add("visitor center"); add("downtown"); add("beach"); add("waterfront"); }
  return out;
}

function travelGeoUrl(query,mode,center){
  var url = "https://api.geoapify.com/v1/geocode/" + mode +
    "?text=" + encodeURIComponent(query) +
    "&limit=8&format=geojson&apiKey=" + encodeURIComponent(GEOAPIFY_KEY);
  if(center && finite(Number(center.lng)) && finite(Number(center.lat))){
    url += "&bias=proximity:" + encodeURIComponent(String(center.lng)) + "," + encodeURIComponent(String(center.lat));
  }
  return url;
}

function normalizeTravelScanFeature(feature,cat,center){
  var item = normalizeFeature(feature, travelCategoryLabel(cat));
  var d;
  if(!item){ return null; }
  d = center ? miles(center.lat, center.lng, item.lat, item.lng) : null;
  item.scanCategory = cat;
  item.matchLabel = travelCategoryLabel(cat);
  if(isFoodIQCat(cat)){ item.foodBadge = foodIntentBadge(cat); }
  item.centerMiles = d;
  return item;
}

function travelScanScore(item,cat){
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || ""));
  var d = item && finite(Number(item.centerMiles)) ? Number(item.centerMiles) : 9999;
  var score = 0;

  if(cat === "preview" && (txt.indexOf("hotel") > -1 || txt.indexOf("resort") > -1 || txt.indexOf("restaurant") > -1 || txt.indexOf("grocery") > -1 || txt.indexOf("pharmacy") > -1 || txt.indexOf("parking") > -1 || txt.indexOf("beach") > -1 || txt.indexOf("visitor") > -1 || txt.indexOf("attraction") > -1 || txt.indexOf("family") > -1)){ score += 120; }
  if(cat === "preview" && (txt.indexOf("private") > -1 || txt.indexOf("residential") > -1 || txt.indexOf("apartment") > -1)){ score -= 110; }
  if(cat === "hotels" && (txt.indexOf("hotel") > -1 || txt.indexOf("resort") > -1 || txt.indexOf("lodging") > -1 || txt.indexOf("motel") > -1)){ score += 130; }
  if(cat === "food" && (txt.indexOf("restaurant") > -1 || txt.indexOf("food") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("seafood") > -1 || txt.indexOf("cafe") > -1)){ score += 126; }
  if(isFoodIQCat(cat) && (txt.indexOf("restaurant") > -1 || txt.indexOf("food") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("diner") > -1 || txt.indexOf("bar") > -1)){ score += 94; }
  if(cat === "food_quick" && (txt.indexOf("fast") > -1 || txt.indexOf("drive thru") > -1 || txt.indexOf("sandwich") > -1 || txt.indexOf("burger") > -1 || txt.indexOf("taco") > -1 || txt.indexOf("chick") > -1)){ score += 90; }
  if(cat === "food_local" && (txt.indexOf("local") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("seafood") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("harbor") > -1)){ score += 82; }
  if(cat === "food_family" && (txt.indexOf("family") > -1 || txt.indexOf("pizza") > -1 || txt.indexOf("burger") > -1 || txt.indexOf("grill") > -1 || txt.indexOf("diner") > -1 || txt.indexOf("kid") > -1)){ score += 86; }
  if(cat === "food_seafood" && (txt.indexOf("seafood") > -1 || txt.indexOf("oyster") > -1 || txt.indexOf("shrimp") > -1 || txt.indexOf("fish") > -1 || txt.indexOf("crab") > -1 || txt.indexOf("harbor") > -1)){ score += 105; }
  if(cat === "food_breakfast" && (txt.indexOf("breakfast") > -1 || txt.indexOf("brunch") > -1 || txt.indexOf("diner") > -1 || txt.indexOf("pancake") > -1 || txt.indexOf("waffle") > -1 || txt.indexOf("cafe") > -1)){ score += 98; }
  if(cat === "food_dinner" && (txt.indexOf("restaurant") > -1 || txt.indexOf("dinner") > -1 || txt.indexOf("steak") > -1 || txt.indexOf("seafood") > -1 || txt.indexOf("grill") > -1)){ score += 76; }
  if(cat === "food_dessert" && (txt.indexOf("dessert") > -1 || txt.indexOf("ice cream") > -1 || txt.indexOf("bakery") > -1 || txt.indexOf("donut") > -1 || txt.indexOf("sweet") > -1)){ score += 108; }
  if(cat === "food_cafe" && (txt.indexOf("coffee") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("espresso") > -1 || txt.indexOf("bakery") > -1)){ score += 108; }
  if(cat === "food_mexican" && (txt.indexOf("mexican") > -1 || txt.indexOf("taco") > -1 || txt.indexOf("burrito") > -1 || txt.indexOf("tex mex") > -1)){ score += 108; }
  if(cat === "food_chinese" && (txt.indexOf("chinese") > -1 || txt.indexOf("asian") > -1 || txt.indexOf("noodle") > -1 || txt.indexOf("wok") > -1)){ score += 104; }
  if(cat === "food_pizza" && (txt.indexOf("pizza") > -1 || txt.indexOf("pizzeria") > -1)){ score += 110; }
  if(cat === "food_bbq" && (txt.indexOf("bbq") > -1 || txt.indexOf("barbecue") > -1 || txt.indexOf("smokehouse") > -1 || txt.indexOf("ribs") > -1)){ score += 110; }
  if(cat === "food_burgers" && (txt.indexOf("burger") > -1 || txt.indexOf("hamburger") > -1 || txt.indexOf("grill") > -1)){ score += 104; }
  if(cat === "food_italian" && (txt.indexOf("italian") > -1 || txt.indexOf("pasta") > -1 || txt.indexOf("pizza") > -1)){ score += 98; }
  if(cat === "food_steakhouse" && (txt.indexOf("steak") > -1 || txt.indexOf("steakhouse") > -1 || txt.indexOf("grill") > -1)){ score += 108; }
  if(cat === "food_healthy" && (txt.indexOf("healthy") > -1 || txt.indexOf("salad") > -1 || txt.indexOf("juice") > -1 || txt.indexOf("smoothie") > -1 || txt.indexOf("vegetarian") > -1 || txt.indexOf("poke") > -1)){ score += 110; }
  if(cat === "coffee" && (txt.indexOf("coffee") > -1 || txt.indexOf("cafe") > -1 || txt.indexOf("espresso") > -1)){ score += 128; }
  if(cat === "groceries" && (txt.indexOf("grocery") > -1 || txt.indexOf("market") > -1 || txt.indexOf("supermarket") > -1 || txt.indexOf("walmart") > -1 || txt.indexOf("target") > -1)){ score += 128; }
  if(cat === "shopping" && (txt.indexOf("shopping") > -1 || txt.indexOf("mall") > -1 || txt.indexOf("outlet") > -1 || txt.indexOf("store") > -1 || txt.indexOf("boutique") > -1 || txt.indexOf("souvenir") > -1 || txt.indexOf("gift") > -1 || txt.indexOf("surf") > -1 || txt.indexOf("beach shop") > -1 || txt.indexOf("commons") > -1 || txt.indexOf("harborwalk") > -1 || txt.indexOf("publix") > -1 || txt.indexOf("walmart") > -1 || txt.indexOf("target") > -1)){ score += 132; }
  if(cat === "fuel" && (txt.indexOf("gas") > -1 || txt.indexOf("fuel") > -1 || txt.indexOf("shell") > -1 || txt.indexOf("bp") > -1 || txt.indexOf("chevron") > -1 || txt.indexOf("travel center") > -1)){ score += 130; }
  if(cat === "pharmacy" && (txt.indexOf("pharmacy") > -1 || txt.indexOf("drug") > -1 || txt.indexOf("cvs") > -1 || txt.indexOf("walgreens") > -1)){ score += 132; }
  if(cat === "attractions" && (txt.indexOf("attraction") > -1 || txt.indexOf("museum") > -1 || txt.indexOf("park") > -1 || txt.indexOf("beach") > -1 || txt.indexOf("landmark") > -1)){ score += 118; }
  if(cat === "parking" && txt.indexOf("parking") > -1){ score += 135; }
  if(cat === "beach" && (txt.indexOf("beach") > -1 || txt.indexOf("waterfront") > -1 || txt.indexOf("boardwalk") > -1 || txt.indexOf("pier") > -1 || txt.indexOf("marina") > -1 || txt.indexOf("boat ramp") > -1 || txt.indexOf("lake") > -1 || txt.indexOf("river") > -1)){ score += 132; }
  if(cat === "family" && (txt.indexOf("family") > -1 || txt.indexOf("kids") > -1 || txt.indexOf("playground") > -1 || txt.indexOf("mini golf") > -1 || txt.indexOf("aquarium") > -1 || txt.indexOf("zoo") > -1 || txt.indexOf("arcade") > -1 || txt.indexOf("park") > -1)){ score += 124; }
  if(cat === "essentials" && (txt.indexOf("grocery") > -1 || txt.indexOf("pharmacy") > -1 || txt.indexOf("urgent care") > -1 || txt.indexOf("gas") > -1 || txt.indexOf("walmart") > -1 || txt.indexOf("target") > -1 || txt.indexOf("laundromat") > -1 || txt.indexOf("visitor") > -1)){ score += 126; }
  if(cat === "local" && (txt.indexOf("visitor") > -1 || txt.indexOf("downtown") > -1 || txt.indexOf("restaurant") > -1 || txt.indexOf("attraction") > -1 || txt.indexOf("beach") > -1 || txt.indexOf("waterfront") > -1)){ score += 90; }

  /*
    Vacation Mode should avoid sending families to vague residential matches when
    the scan intent is practical/travel-oriented.
  */
  if(txt.indexOf("residential") > -1 || txt.indexOf("private") > -1 || txt.indexOf("subdivision") > -1){ score -= 90; }
  if(isFoodIQCat(cat) && (txt.indexOf("hotel") > -1 || txt.indexOf("resort") > -1 || txt.indexOf("condominium") > -1) && txt.indexOf("restaurant") < 0 && txt.indexOf("grill") < 0 && txt.indexOf("cafe") < 0){ score -= 80; }

  if(d <= 0.5){ score += 90; }
  else if(d <= 2){ score += 82; }
  else if(d <= 5){ score += 68; }
  else if(d <= 15){ score += 42; }
  else if(d <= 30){ score += 18; }
  else{ score -= 45; }

  score += categoryIntentScore(item,cat);
  score += personalPreferenceBoost(item,cat);
  score += travelStyleScore(item,cat);
  if(cat === "coffee" && /starbucks|coffee|cafe|espresso|matcha|tea|smoothie|nutrition/.test(txt)){ score += 45; }
  if(cat === "coffee" && /outlet|mall|shopping center|clothing|shoe store/.test(txt)){ score -= 85; }
  if(cat === "groceries" && /grocery|supermarket|kroger|publix|walmart|target|aldi|whole foods/.test(txt)){ score += 45; }
  if(cat === "groceries" && /outlet|mall|restaurant|clothing/.test(txt)){ score -= 70; }
  if(cat === "popular" || cat === "popular_tonight"){
    if(/bar|grill|pub|tap|tavern|sports|patio|brew|music|restaurant|happy hour|open late/.test(txt)){ score += 76; }
  }

  score -= Math.min(62,d * 1.3);
  return score;
}

function dedupeTravelItems(items){
  var seen = {};
  var out = [];
  var i;
  var item;
  var key;
  for(i=0;i<items.length;i++){
    item = items[i];
    if(!item){ continue; }
    key = String(Number(item.lat).toFixed(5)) + "," + String(Number(item.lng).toFixed(5));
    if(seen[key]){ continue; }
    seen[key] = true;
    out.push(item);
  }
  return out;
}

function ensureTravelResultSources(){
  if(!mapLoaded || !map){ return; }
  try{
    if(!map.getSource("diq-travel-results")){
      map.addSource("diq-travel-results",{ type:"geojson", data:emptyFC() });
      map.addLayer({ id:"diq-travel-result-halo", type:"circle", source:"diq-travel-results", paint:{ "circle-radius":["case",["==",["get","preferred"],1],18,14], "circle-color":["case",["==",["get","preferred"],1],"#ffce69","#58a6ff"], "circle-opacity":0.22, "circle-blur":0.9 } });
      map.addLayer({ id:"diq-travel-result-dot", type:"circle", source:"diq-travel-results", paint:{ "circle-radius":["case",["==",["get","preferred"],1],9,7], "circle-color":["case",["==",["get","preferred"],1],"#ffce69","#58a6ff"], "circle-stroke-color":"#061018", "circle-stroke-width":3 } });
      map.addLayer({ id:"diq-travel-result-label", type:"symbol", source:"diq-travel-results", layout:{ "text-field":["get","shortLabel"], "text-size":10, "text-offset":[0,1.55], "text-anchor":"top", "text-max-width":9, "text-allow-overlap":false }, paint:{ "text-color":"#ffffff", "text-halo-color":"#061018", "text-halo-width":1.25, "text-opacity":0.92 } });

      map.on("click","diq-travel-result-dot",function(e){
        var f = e && e.features && e.features.length ? e.features[0] : null;
        var idx = f && f.properties ? Number(f.properties.idx) : -1;
        if(idx >= 0 && travelScanResults[idx]){ openTravelInfoCard(travelScanResults[idx]); }
      });
      map.on("click","diq-travel-result-halo",function(e){
        var f = e && e.features && e.features.length ? e.features[0] : null;
        var idx = f && f.properties ? Number(f.properties.idx) : -1;
        if(idx >= 0 && travelScanResults[idx]){ openTravelInfoCard(travelScanResults[idx]); }
      });
    }
  }catch(e){}
}

function shortTravelLabel(label){
  var s = clean(label);
  if(s.length > 18){ s = s.slice(0,16) + "…"; }
  return s;
}

function renderTravelPins(items){
  var fc = emptyFC();
  var i;
  var item;
  if(!mapLoaded || !map){ return; }
  ensureTravelResultSources();
  travelScanResults = items && items.length ? items.slice(0,8) : [];
  fc.features = [];
  for(i=0;i<travelScanResults.length;i++){
    item = travelScanResults[i];
    if(!item || !finite(Number(item.lat)) || !finite(Number(item.lng))){ continue; }
    fc.features.push({
      type:"Feature",
      properties:{ idx:i, preferred:i === 0 ? 1 : 0, shortLabel:shortTravelLabel(item.displayName || item.label || "Stop") },
      geometry:{ type:"Point", coordinates:[Number(item.lng),Number(item.lat)] }
    });
  }
  try{ map.getSource("diq-travel-results").setData(fc); }catch(e){}
}

function fitTravelScan(items,center){
  var bounds;
  var i;
  var item;
  if(!mapLoaded || !map || !items || !items.length){ return; }
  try{
    item = items[0];
    bounds = new mapboxgl.LngLatBounds([Number(item.lng),Number(item.lat)],[Number(item.lng),Number(item.lat)]);
    if(center){ bounds.extend([Number(center.lng),Number(center.lat)]); }
    for(i=0;i<items.length && i<8;i++){
      item = items[i];
      if(item && finite(Number(item.lng)) && finite(Number(item.lat))){ bounds.extend([Number(item.lng),Number(item.lat)]); }
    }
    map.fitBounds(bounds,{ padding:routeVisibilityFitPadding(), duration:850, maxZoom:12.8, essential:true });
  }catch(e){}
}

function startTravelScanLoading(title,sub){
  var card = byId("diqTravelScanLoading");
  if(!card){ ensureTravelScanUI(); card = byId("diqTravelScanLoading"); }
  if(byId("diqTravelScanLoadTitle")){ byId("diqTravelScanLoadTitle").textContent = String(title || "SCANNING").toUpperCase(); }
  if(byId("diqTravelScanLoadSub")){ byId("diqTravelScanLoadSub").textContent = sub || "Finding places worth stopping for..."; }
  if(card){ card.className = "on"; }
}

function stopTravelScanLoading(){
  var card = byId("diqTravelScanLoading");
  if(card){ card.className = ""; }
}

function travelScanTitle(cat,center){
  var scope = center && center.scope === "near_destination" ? "NEAR DESTINATION" : (center && center.scope === "along_route" ? "ALONG ROUTE" : "NEAR YOU");
  return "SCANNING " + scope;
}

function travelScanSub(cat,center){
  var label = center && center.scope === "near_destination" ? String(center.label || "destination") : (center && center.scope === "along_route" ? "your route" : "you");
  var cfg = travelTripStyleConfig(activeTravelTripStyle);
  if(cfg && activeTravelTripStyle !== "general"){
    return "Finding " + travelCategoryLabel(cat).toLowerCase() + " that fit your " + cfg.label + " around " + label + "...";
  }
  return "Checking " + travelCategoryLabel(cat).toLowerCase() + " around " + label + "...";
}

function clearTravelChipState(){
  var nodes = document.querySelectorAll ? document.querySelectorAll("[data-travel-cat]") : [];
  var i;
  for(i=0;i<nodes.length;i++){ nodes[i].className = "diqTravelChip"; }
  nodes = document.querySelectorAll ? document.querySelectorAll("[data-food-iq]") : [];
  for(i=0;i<nodes.length;i++){
    if(String(nodes[i].className || "").indexOf("primary") > -1){ nodes[i].className = "foodChip primary"; }
    else{ nodes[i].className = "foodChip"; }
  }
}

function clearFoodChipState(){
  var nodes = document.querySelectorAll ? document.querySelectorAll("[data-food-iq]") : [];
  var i;
  for(i=0;i<nodes.length;i++){
    if(String(nodes[i].className || "").indexOf("primary") > -1){ nodes[i].className = "foodChip primary"; }
    else{ nodes[i].className = "foodChip"; }
  }
}

function clearTravelPins(){
  travelScanResults = [];
  closeTravelInfoCard();
  try{
    if(map && map.getSource && map.getSource("diq-travel-results")){
      map.getSource("diq-travel-results").setData(emptyFC());
    }
  }catch(e){}
}

function foodIQSourceLooksRelevant(cat,item){
  var q = normText(item && item.sourceQuery ? item.sourceQuery : "");
  if(!isFoodIQCat(cat)){ return true; }
  if(cat === "food_mexican"){ return q.indexOf("mexican") > -1 || q.indexOf("taco") > -1 || q.indexOf("burrito") > -1 || q.indexOf("tex mex") > -1; }
  if(cat === "food_chinese"){ return q.indexOf("chinese") > -1 || q.indexOf("asian") > -1 || q.indexOf("noodle") > -1 || q.indexOf("wok") > -1; }
  if(cat === "food_pizza"){ return q.indexOf("pizza") > -1 || q.indexOf("pizzeria") > -1; }
  if(cat === "food_bbq"){ return q.indexOf("bbq") > -1 || q.indexOf("barbecue") > -1 || q.indexOf("smokehouse") > -1 || q.indexOf("ribs") > -1; }
  if(cat === "food_burgers"){ return q.indexOf("burger") > -1 || q.indexOf("hamburger") > -1; }
  if(cat === "food_italian"){ return q.indexOf("italian") > -1 || q.indexOf("pasta") > -1 || q.indexOf("pizza") > -1; }
  if(cat === "food_steakhouse"){ return q.indexOf("steak") > -1 || q.indexOf("steakhouse") > -1; }
  if(cat === "food_healthy"){ return q.indexOf("healthy") > -1 || q.indexOf("salad") > -1 || q.indexOf("juice") > -1 || q.indexOf("smoothie") > -1 || q.indexOf("vegetarian") > -1 || q.indexOf("poke") > -1; }
  return true;
}

function foodIQObviousMismatch(cat,item){
  var txt = normText(String(item && item.label || "") + " " + String(item && item.full || ""));
  if(!isFoodIQCat(cat)){ return false; }
  if(cat === "food_mexican" && (txt.indexOf("seafood") > -1 || txt.indexOf("oyster") > -1 || txt.indexOf("shrimp") > -1 || txt.indexOf("fish") > -1 || txt.indexOf("crab") > -1) && txt.indexOf("mexican") < 0 && txt.indexOf("taco") < 0 && txt.indexOf("burrito") < 0 && txt.indexOf("tex mex") < 0){ return true; }
  if(cat === "food_chinese" && (txt.indexOf("seafood") > -1 || txt.indexOf("oyster") > -1 || txt.indexOf("shrimp") > -1 || txt.indexOf("fish") > -1 || txt.indexOf("crab") > -1) && txt.indexOf("chinese") < 0 && txt.indexOf("asian") < 0 && txt.indexOf("noodle") < 0){ return true; }
  if(cat === "food_pizza" && (txt.indexOf("seafood") > -1 || txt.indexOf("oyster") > -1 || txt.indexOf("shrimp") > -1) && txt.indexOf("pizza") < 0 && txt.indexOf("pizzeria") < 0){ return true; }
  if(cat === "food_bbq" && (txt.indexOf("seafood") > -1 || txt.indexOf("oyster") > -1 || txt.indexOf("shrimp") > -1) && txt.indexOf("bbq") < 0 && txt.indexOf("barbecue") < 0 && txt.indexOf("smokehouse") < 0){ return true; }
  return false;
}

/* V16.4 Food Truth: only business-category results qualify for Food IQ.
   Geoapify geocoding finds addresses and institutions, not verified restaurants. */
function travelFoodCategories(cat){
  if(cat==="food_dessert"){ return "catering.ice_cream,catering.bakery,catering.cafe"; }
  if(cat==="food_cafe"){ return "catering.cafe,catering.bakery"; }
  if(cat==="food_quick"){ return "catering.fast_food,catering.restaurant"; }
  return "catering.restaurant,catering.fast_food,catering.cafe,catering.bakery,catering.ice_cream";
}
function travelVerifiedFood(item,cat){
  var cats=item && item.verifiedCategories || [];
  var types=item && item.googleTypes || [];
  var txt=normText(item && (item.label || item.name) || "");
  var c=normText(cats.join(" ")+" "+types.join(" "));
  var hasFood=/catering|restaurant|cafe|coffee shop|bakery|ice cream|fast food|meal takeaway|meal delivery|food court|diner|pizza restaurant|steak house|barbecue restaurant|mexican restaurant|chinese restaurant/.test(c);
  if(!isFoodIQCat(cat)){ return true; }
  if(!hasFood || /school|police|hospital|fire station|courthouse|government|church|university|college|car dealer|bank|lodging|hotel/.test(c)){ return false; }
  if(/\b(school|police department|police station|sheriff|fire department|city hall|courthouse)\b/.test(txt)){ return false; }
  if(cat==="food_dessert"){ return /ice cream|bakery|dessert|donut|sweet|cake|cookie|gelato|frozen yogurt/.test(c+" "+txt); }
  if(cat==="food_cafe"){ return /cafe|coffee|bakery|espresso|tea/.test(c+" "+txt); }
  if(cat==="food_pizza"){ return /pizza|pizzeria/.test(c+" "+txt); }
  if(cat==="food_bbq"){ return /bbq|barbecue|smokehouse|ribs/.test(c+" "+txt); }
  if(cat==="food_mexican"){ return /mexican|taco|burrito|taqueria|tex mex/.test(c+" "+txt); }
  if(cat==="food_chinese"){ return /chinese|asian|noodle|wok/.test(c+" "+txt); }
  if(cat==="food_seafood"){ return /seafood|oyster|fish|shrimp|crab/.test(c+" "+txt); }
  if(cat==="food_burgers"){ return /burger|hamburger/.test(c+" "+txt); }
  if(cat==="food_italian"){ return /italian|pasta|pizza|trattoria/.test(c+" "+txt); }
  if(cat==="food_steakhouse"){ return /steak|steakhouse/.test(c+" "+txt); }
  if(cat==="food_healthy"){ return /salad|juice|smoothie|vegetarian|vegan|healthy|poke/.test(c+" "+txt); }
  if(cat==="food_breakfast"){ return /breakfast|brunch|diner|pancake|waffle|cafe|bakery/.test(c+" "+txt); }
  return true;
}
function normalizeTravelFoodPOI(feature,cat,center){
  var p=feature && feature.properties || {};
  var coords=feature && feature.geometry && feature.geometry.coordinates || [];
  var lat=Number(p.lat != null ? p.lat : coords[1]);
  var lng=Number(p.lon != null ? p.lon : coords[0]);
  var name=clean(p.name || "");
  var cats=p.categories || [];
  var item;
  if(!name || !finite(lat) || !finite(lng) || !cats.length){ return null; }
  item={label:name,name:name,full:clean(p.formatted || p.address_line2 || ""),lat:lat,lng:lng,
    source:"geoapify_places",verifiedCategories:cats,kind:"Food",scanCategory:cat,
    centerMiles:miles(center.lat,center.lng,lat,lng),distMiles:miles(center.lat,center.lng,lat,lng),
    place_id:clean(p.place_id || ""),photoUrl:""};
  if(!travelVerifiedFood(item,cat)){ return null; }
  return item;
}
function travelFoodPlacesUrl(cat,center){
  var radius= Math.round(Math.min(30000,Math.max(8000,travelScanRadius(cat,center.scope)*1609.34)));
  var circle=String(center.lng)+","+String(center.lat)+","+String(radius);
  return "https://api.geoapify.com/v2/places?categories="+encodeURIComponent(travelFoodCategories(cat))+
    "&filter="+encodeURIComponent("circle:"+circle)+
    "&bias="+encodeURIComponent("proximity:"+center.lng+","+center.lat)+
    "&limit=100&apiKey="+encodeURIComponent(GEOAPIFY_KEY);
}

/* V16.5 Adventure-inspired category truth: POI data is mandatory for curated
   travel scans. A geocoder result is never proof that a place matches a trip
   category, regardless of its proximity or the text used to find it. */
function travelV165CategoryGroup(cat){
  if(isFoodIQCat(cat) || cat==="food" || cat==="coffee" || cat==="patio" || cat==="popular" || cat==="popular_tonight" || cat==="local" || cat==="hidden_gems" || cat==="food_wine" || cat==="live_music"){ return "catering"; }
  if(cat==="golf_trip"){ return "sport.golf"; }
  if(cat==="hotels"){ return "accommodation"; }
  if(cat==="fuel"){ return "service.vehicle"; }
  if(cat==="pharmacy"){ return "healthcare"; }
  if(cat==="parking"){ return "parking"; }
  if(cat==="groceries" || cat==="shopping"){ return "commercial"; }
  if(cat==="beach" || cat==="waterfront" || cat==="scenic"){ return "tourism,leisure,natural"; }
  if(cat==="attractions" || cat==="family"){ return "tourism,entertainment,leisure"; }
  if(cat==="essentials" || cat==="preview"){ return "catering,accommodation,commercial,healthcare,tourism"; }
  return "tourism,leisure,catering";
}
function travelV165PlacesUrl(cat,center){
  var radius=cat==="golf_trip" ? 50000 : Math.round(Math.min(30000,Math.max(6000,travelScanRadius(cat,center.scope)*1609.34)));
  return "https://api.geoapify.com/v2/places?categories="+encodeURIComponent(travelV165CategoryGroup(cat))+
    "&filter="+encodeURIComponent("circle:"+center.lng+","+center.lat+","+radius)+
    "&bias="+encodeURIComponent("proximity:"+center.lng+","+center.lat)+
    "&limit=200&apiKey="+encodeURIComponent(GEOAPIFY_KEY);
}
function travelV165TrustedItem(feature,cat,center){
  var p=feature && feature.properties || {};
  var coords=feature && feature.geometry && feature.geometry.coordinates || [];
  var lat=Number(p.lat!=null?p.lat:coords[1]),lng=Number(p.lon!=null?p.lon:coords[0]);
  var cats=p.categories || [],name=clean(p.name || ""),d,item;
  if(!name || !cats.length || !finite(lat) || !finite(lng)){ return null; }
  d=miles(center.lat,center.lng,lat,lng);
  if(!finite(d) || d>Math.max(8,travelScanRadius(cat,center.scope))){ return null; }
  item={label:name,name:name,full:clean(p.formatted || p.address_line2 || ""),lat:lat,lng:lng,
    source:"geoapify_places",verifiedCategories:cats,scanCategory:cat,centerMiles:d,distMiles:d,
    place_id:clean(p.place_id || ""),kind:placeIQCategoryLabel(cat)};
  return travelV165Matches(item,cat) ? item : null;
}
function travelV165Matches(item,cat){
  var cats=(item.verifiedCategories || []).concat(item.googleTypes || []).join(" ").toLowerCase().replace(/_/g," ");
  var name=normText(item.name || item.label || "");
  var broad=cats+" "+name;
  if(!cats){ return false; }
  if(/police|fire station|fire department|school|college|university|courthouse|government|prison|jail|post office|hospital|bank|car dealer|real estate/.test(broad)){ return false; }
  if(isFoodIQCat(cat)){ return travelVerifiedFood(item,cat); }
  if(cat==="golf_trip"){
    return /(?:sport[. ]golf|golf course|golf club|golf_course|driving range)/.test(cats) && !/mini golf|miniature golf|golf cart|golf shop|golf store/.test(broad);
  }
  if(cat==="hotels"){ return /accommodation|lodging|hotel|motel|hostel|guest house|resort/.test(cats); }
  if(cat==="food"){ return /catering|restaurant|cafe|fast food|bakery/.test(cats); }
  if(cat==="coffee"){ return /catering[. ]cafe|coffee shop|coffee|cafe/.test(cats+" "+name); }
  if(cat==="groceries"){ return /commercial[. ]supermarket|grocery|supermarket|convenience/.test(cats); }
  if(cat==="shopping"){ return /commercial/.test(cats) && !/car dealer|vehicle|wholesale/.test(cats); }
  if(cat==="fuel"){ return /fuel|gas station/.test(cats); }
  if(cat==="pharmacy"){ return /pharmacy|chemist/.test(cats); }
  if(cat==="parking"){ return /parking/.test(cats); }
  if(cat==="attractions"){ return /tourism|museum|zoo|theme park|attraction|historic|landmark|leisure[. ]park/.test(cats); }
  if(cat==="family"){ return /tourism|entertainment|leisure[. ]park|playground|zoo|museum/.test(cats); }
  if(cat==="beach"){ return /beach|water|marina|pier|lake|river|natural|waterfront/.test(cats+" "+name); }
  if(cat==="waterfront"){ return /beach|water|marina|pier|lake|river|natural/.test(cats+" "+name); }
  if(cat==="scenic"){ return /tourism|natural|leisure[. ]park|viewpoint|waterfall|trail/.test(cats); }
  if(cat==="live_music"){ return /music|concert|nightclub|entertainment|catering[. ]bar/.test(cats+" "+name); }
  if(cat==="patio"){ return /catering[. ]restaurant|catering[. ]bar|catering[. ]cafe/.test(cats) && /patio|terrace|rooftop|garden|outdoor/.test(name); }
  if(cat==="food_wine"){ return /catering[. ]restaurant|catering[. ]bar|winery|brewery/.test(cats); }
  if(cat==="popular" || cat==="popular_tonight" || cat==="local" || cat==="hidden_gems"){
    return /catering[. ]restaurant|catering[. ]cafe|catering[. ]bar|catering[. ]fast food|catering[. ]bakery/.test(cats);
  }
  if(cat==="essentials"){ return /catering|accommodation|commercial[. ]supermarket|healthcare[. ]pharmacy|tourism/.test(cats); }
  if(cat==="preview"){ return /catering|accommodation|commercial[. ]supermarket|healthcare[. ]pharmacy|tourism/.test(cats); }
  return /tourism|leisure|catering/.test(cats);
}
function travelV165TrustPresentation(item,cat){
  item.placeIQWhy="Verified place category near your selected search area. Review the details before adding it to your trip.";
  item.placeIQBadge=travelCategoryLabel(cat).toUpperCase()+" • PLACE VERIFIED";
  item.placeIQStars="";
  item.placeIQScore=0;
  return item;
}

function startTravelScan(cat){
  var center = travelScanCenter();
  var queries;
  var token;
  var all = [];
  var pending = 0;
  var launched = 0;
  var finished = false;
  var golfRecoveryStarted = false;
  var golfDiag = null;
  if(clean(cat)==="golf_trip"){
    golfDiag={version:"V16.8",destination:dest ? clean(dest.label) : "",startedAt:new Date().toISOString(),
      providers:{geoapify:{requests:0,raw:0,accepted:0,errors:[]},googleSDK:{attempted:false,ready:false,raw:0,accepted:0,status:"not attempted"},googleProxy:{requests:0,raw:0,accepted:0,errors:[]}},
      recoveryStarted:false,results:0,finished:false,notes:[]};
    window.DriveIQTravelLastGolfDiagnostics=golfDiag;
  }

  cat = clean(cat || "local");
  if(cat === "food"){
    openFoodIQPanel();
    return;
  }
  if(!center){
    toast("Lock GPS first");
    requestGPS(true);
    return;
  }
  closeFoodIQPanel();
  if(!GEOAPIFY_KEY){
    toast("Travel scans unavailable");
    setIntel("NO GEO KEY","red");
    return;
  }

  travelScanCategory = cat;
  travelScanScope = center.scope;
  travelScanToken += 1;
  token = travelScanToken;
  queries = addVacationDestinationQueries(cat, addTravelStyleQueries(cat, travelCategoryQueries(cat), center), center);
  /* Make the chosen destination explicit in geocoder queries; proximity is only a bias. */
  if(center.scope === "near_destination" && dest){
    var placeText = clean(String(dest.label || "") + ", " + String(dest.full || ""));
    queries = dedupeQueryList(queries.map(function(q){
      return /\bnear\b/i.test(q) ? q : (q + " near " + placeText);
    }));
  }

  clearTravelPins();
  clearTravelChipState();
  clearFoodChipState();
  travelScanResults = [];
  try{ renderPlaceIQDeck([],cat); }catch(eDeck){}
  try{
    var chip = document.querySelector('[data-travel-cat="' + cat + '"]');
    if(!chip && isFoodIQCat(cat)){ chip = document.querySelector('[data-travel-cat="food"]'); }
    if(chip){ chip.className = "diqTravelChip on"; }
    var foodChip = document.querySelector('[data-food-iq="' + cat + '"]');
    if(foodChip){ foodChip.className = String(foodChip.className || "").indexOf("primary") > -1 ? "foodChip primary on" : "foodChip on"; }
  }catch(e0){}

  updateTravelScanScope();
  /* V16.7: Search owns the screen; keep the large Travel Scans menu folded. */
  setTravelScanCollapsed(true);
  startTravelScanLoading(travelScanTitle(cat,center), travelScanSub(cat,center));
  setIntel("SCANNING","blue");
  subline("Scanning " + travelCategoryLabel(cat).toLowerCase() + " " + (center.scope === "near_destination" ? "near destination" : "near you") + (travelTripStyleContextText() ? " • " + travelTripStyleContextText() : "") + "...");

  function finishIfReady(){
    var sorted;
    var sortedAll;
    var radius = travelScanRadius(cat,center.scope);
    if(finished || pending > 0 || launched < queries.length || token !== travelScanToken){ return; }
    /* V16.8: Don't declare an empty golf scan before a controlled nearby-area
       Places recovery. Every recovered item still passes category truth. */
    if(cat==="golf_trip" && !golfRecoveryStarted && !all.some(function(x){return travelV165Matches(x,cat);})){
      golfRecoveryStarted=true;
      if(golfDiag){ golfDiag.recoveryStarted=true; golfDiag.notes.push("Primary sources had no verified golf candidates; checking neighboring areas."); }
      launchGolfRecovery();
      if(pending>0){ return; }
    }
    finished = true;
    stopTravelScanLoading();

    all = dedupeTravelItems(all);
    sortedAll = all.sort(function(a,b){
      var sa = travelScanScore(a,cat);
      var sb = travelScanScore(b,cat);
      if(Math.abs(sb - sa) > 8){ return sb - sa; }
      var da = finite(Number(a.centerMiles)) ? Number(a.centerMiles) : 9999;
      var db = finite(Number(b.centerMiles)) ? Number(b.centerMiles) : 9999;
      return da - db;
    });

    sorted = sortedAll.filter(function(item){
      return item && finite(Number(item.centerMiles)) && Number(item.centerMiles) <= radius && travelV165Matches(item,cat) && !foodIQObviousMismatch(cat,item);
    }).slice(0,8);

    if(!sorted.length && sortedAll.length){
      if(byId("diqTravelScanLoadSub")){ byId("diqTravelScanLoadSub").textContent = "Expanding search radius..."; }
      sorted = sortedAll.filter(function(item){
        return item && finite(Number(item.centerMiles)) && Number(item.centerMiles) <= Math.max(radius,65) && travelV165Matches(item,cat) && !foodIQObviousMismatch(cat,item);
      }).slice(0,8);
    }

    /* V16.2: NEVER use faraway results just to fill the deck. */

    sorted = finalizePlaceIQResults(sorted,cat);
    sorted.forEach(function(item){ travelV165TrustPresentation(item,cat); });
    travelScanResults = sorted;
    if(golfDiag){ golfDiag.results=sorted.length; golfDiag.finished=true; golfDiag.finishedAt=new Date().toISOString();
      if(!sorted.length){ golfDiag.notes.push("No verified golf courses returned. Check provider errors and category coverage; no unrelated places were substituted."); }
    }
    renderTravelPins(sorted);
    renderPlaceIQDeck(sorted,cat);
    fitTravelScan(sorted,center);

    if(sorted.length){
      setIntel(String(sorted.length) + " FOUND","green");
      subline(String(sorted.length) + " " + travelCategoryLabel(cat).toLowerCase() + " spots " + (center.scope === "near_destination" ? "near destination" : "near you") + (travelTripStyleContextText() ? " • " + travelTripStyleContextText() : ""));
      toast(String(sorted.length) + " travel spots found");
      setTravelScanCollapsed(true);
    }else{
      setIntel("NO MATCH","gold");
      subline(cat==="golf_trip" ? "No verified golf courses found within the expanded search around " + (center.label || "this area") + "." : "No verified " + travelCategoryLabel(cat).toLowerCase() + " near " + (center.label || "this area") + ". Try another destination or search scope.");
      toast(cat==="golf_trip" ? "No verified golf courses found" : "No verified " + travelCategoryLabel(cat).toLowerCase() + " found");
      setTravelScanCollapsed(true);
    }
  }

  function launch(q){
    var urls;
    var i;
    urls = [travelGeoUrl(q,"autocomplete",center),travelGeoUrl(q,"search",center)];
    function fetchUrl(url){
      pending += 1;
      try{
        fetch(url)
          .then(function(res){ return res.json(); })
          .then(function(data){
            var features = data && data.features ? data.features : [];
            var j;
            var item;
            for(j=0;j<features.length;j++){
              item = normalizeTravelScanFeature(features[j],cat,center);
              if(item){ item.sourceQuery = q; all.push(item); }
            }
            pending -= 1;
            finishIfReady();
          })
          .catch(function(){ pending -= 1; finishIfReady(); });
      }catch(e){ pending -= 1; finishIfReady(); }
    }
    for(i=0;i<urls.length;i++){ fetchUrl(urls[i]); }
  }



  function launchGoogle(q){
    var url = googlePlacesProxyUrl(q,center);
    if(!url){ return; }
    if(golfDiag){golfDiag.providers.googleProxy.requests+=1;}
    pending += 1;
    try{
      fetch(url)
        .then(function(res){ return res.json(); })
        .then(function(data){
          var raw = data && data.results ? data.results : (data && data.places ? data.places : []);
          if(golfDiag){golfDiag.providers.googleProxy.raw+=raw.length;}
          var j;
          var item;
          for(j=0;j<raw.length;j++){
            item = normalizeGooglePlace(raw[j],cat,center);
            if(item){ item.sourceQuery = q; all.push(item); if(golfDiag){golfDiag.providers.googleProxy.accepted+=1;} }
          }
          pending -= 1;
          finishIfReady();
        })
        .catch(function(err){ if(golfDiag){golfDiag.providers.googleProxy.errors.push(String(err.message||err));} pending -= 1; finishIfReady(); });
    }catch(e){ if(golfDiag){golfDiag.providers.googleProxy.errors.push(String(e.message||e));} pending -= 1; finishIfReady(); }
  }
  /* V16.8: Adjacent 50 km circles cover real courses beyond a small town.
     This uses category-filtered Places only, never geocoder guesses. */
  function launchGolfRecovery(){
    if(cat!=="golf_trip" || !GEOAPIFY_KEY){ return; }
    var lat=Number(center.lat),lng=Number(center.lng);
    var offsets=[[0.30,0],[-0.30,0],[0,0.39],[0,-0.39]];
    offsets.forEach(function(offset){
      var clat=lat+offset[0],clng=lng+offset[1];
      var url="https://api.geoapify.com/v2/places?categories="+encodeURIComponent("sport.golf")+
        "&filter="+encodeURIComponent("circle:"+clng+","+clat+",50000")+
        "&bias="+encodeURIComponent("proximity:"+lng+","+lat)+"&limit=200&apiKey="+encodeURIComponent(GEOAPIFY_KEY);
      pending+=1;
      if(golfDiag){golfDiag.providers.geoapify.requests+=1;}
      fetch(url).then(function(res){if(!res.ok){throw Error("HTTP "+res.status);}return res.json();})
        .then(function(data){
          var features=data && data.features || [];
          if(golfDiag){golfDiag.providers.geoapify.raw+=features.length;}
          if(token===travelScanToken){
            features.forEach(function(feature){
              var item=travelV165TrustedItem(feature,cat,center);
              if(item){all.push(item);if(golfDiag){golfDiag.providers.geoapify.accepted+=1;}}
            });
          }
          pending-=1;finishIfReady();
        }).catch(function(err){
          if(golfDiag){golfDiag.providers.geoapify.errors.push("recovery: "+String(err.message||err));}
          pending-=1;finishIfReady();
        });
    });
  }

  /* V16.6: A dedicated Google Places golf search, independent of geocoding.
     Google types must explicitly identify a golf course. */
  function launchGolfSDK(){
    if(cat!=="golf_trip"){ return; }
    if(golfDiag){golfDiag.providers.googleSDK.attempted=true;}
    if(!travelPhotoKey()){
      if(golfDiag){golfDiag.providers.googleSDK.status="No Google Places key available on Travel page";}
      return;
    }
    pending+=1;
    var golfSDKDone=false;
    function golfSDKFinish(){
      if(golfSDKDone){ return; }
      golfSDKDone=true;
      pending=Math.max(0,pending-1);
      finishIfReady();
    }
    window.setTimeout(function(){
      if(!golfSDKDone && token===travelScanToken){ window.DriveIQTravelLastScanError="Golf Google Places timed out"; }
      golfSDKFinish();
    },8500);
    travelGooglePlacesReady(function(ready){
      if(golfSDKDone || token!==travelScanToken){ golfSDKFinish(); return; }
      if(!ready){ if(golfDiag){golfDiag.providers.googleSDK.status="Google Maps Places SDK unavailable";} golfSDKFinish(); return; }
      if(golfDiag){golfDiag.providers.googleSDK.ready=true;}
      try{
        var svc=new google.maps.places.PlacesService(document.createElement("div"));
        svc.textSearch({query:"golf courses and driving ranges near "+(dest ? clean(dest.label+" "+(dest.full||"")) : "destination"),
          location:new google.maps.LatLng(center.lat,center.lng),radius:50000},function(results,status){
          var i,r,loc,types,d,item;
          if(token!==travelScanToken){ return; }
          if(golfDiag){golfDiag.providers.googleSDK.status=String(status);golfDiag.providers.googleSDK.raw=results ? results.length : 0;}
          if(status===google.maps.places.PlacesServiceStatus.OK && results){
            for(i=0;i<results.length;i++){
              r=results[i];loc=r.geometry && r.geometry.location;types=r.types||[];
              if(!loc || types.indexOf("golf_course")<0){ continue; }
              d=miles(center.lat,center.lng,loc.lat(),loc.lng());
              if(d>travelScanRadius(cat,center.scope)){ continue; }
              item={label:clean(r.name),name:clean(r.name),full:clean(r.formatted_address||""),
                lat:loc.lat(),lng:loc.lng(),source:"google_places",googleTypes:types,
                verifiedCategories:[],centerMiles:d,distMiles:d,scanCategory:cat,
                place_id:r.place_id||"",rating:typeof r.rating==="number"?r.rating:null,
                reviews:typeof r.user_ratings_total==="number"?r.user_ratings_total:null,
                photoUrl:r.photos && r.photos[0] && r.photos[0].getUrl ? r.photos[0].getUrl({maxWidth:960}):""};
              if(travelV165Matches(item,cat)){ all.push(item); if(golfDiag){golfDiag.providers.googleSDK.accepted+=1;} }
            }
          }else{ window.DriveIQTravelLastScanError="Golf Places: "+String(status); }
          golfSDKFinish();
        });
      }catch(e){ window.DriveIQTravelLastScanError="Golf SDK: "+String(e.message||e); golfSDKFinish(); }
    });
  }
  function next(){
    if(finished || token !== travelScanToken){ return; }
    if(launched >= queries.length){ finishIfReady(); return; }
    /* V16.5: Geocoding is not a POI category provider. Do not launch it. */
    if(launched < 4){ launchGoogle(queries[launched]); }
    launched += 1;
    if(launched < queries.length){ window.setTimeout(next,110); }
    else{ finishIfReady(); }
  }

  /* One category-aware Geoapify Places scan for every Travel IQ category. */
  pending += 1;
  if(golfDiag){golfDiag.providers.geoapify.requests+=1;}
  try{
    fetch(travelV165PlacesUrl(cat,center)).then(function(res){
      if(!res.ok){ throw Error("Geoapify Places category search failed: " + res.status); }
      return res.json();
    }).then(function(data){
      var features=data && data.features || [],i,item;
      if(golfDiag){golfDiag.providers.geoapify.raw+=features.length;}
      if(token!==travelScanToken){ pending-=1; return; }
      for(i=0;i<features.length;i++){
        item=travelV165TrustedItem(features[i],cat,center);
        if(item){ all.push(item); if(golfDiag){golfDiag.providers.geoapify.accepted+=1;} }
      }
      pending -= 1; finishIfReady();
    }).catch(function(err){
      if(token===travelScanToken){ window.DriveIQTravelLastScanError=String(err && err.message || "Places unavailable"); }
      if(golfDiag){golfDiag.providers.geoapify.errors.push(String(err && err.message || err));}
      pending -= 1; finishIfReady();
    });
  }catch(e){ pending -= 1; finishIfReady(); }
  launchGolfSDK();
  next();
}

function travelInfoDistanceText(item){
  var d = item && finite(Number(item.centerMiles)) ? Number(item.centerMiles) : null;
  if(d === null){ return ""; }
  if(d < 0.1){ return "0.1 mi"; }
  if(d < 10){ return String(Math.round(d * 10) / 10) + " mi"; }
  return String(Math.round(d)) + " mi";
}

function closeTravelInfoCard(){
  var card = byId("diqTravelInfoCard");
  if(card){ card.className = ""; }
}

function speakTravelInfo(item){
  var line;
  var utter;
  if(!travelInfoVoiceEnabled || !item){ return; }
  line = clean(String(item.label || "Travel stop") + ". " + String(item.foodBadge || item.matchLabel || "Travel stop") + (travelInfoDistanceText(item) ? ", " + travelInfoDistanceText(item) : "") + ". Tap Route Here to navigate.");
  if(line.length > 190){ line = line.slice(0,187) + "."; }
  try{
    if(!window.speechSynthesis || !window.SpeechSynthesisUtterance){ return; }
    window.speechSynthesis.cancel();
    utter = new SpeechSynthesisUtterance(line);
    utter.rate = 0.96;
    utter.pitch = 1.0;
    utter.volume = 1.0;
    window.speechSynthesis.speak(utter);
  }catch(e){}
}

function openTravelInfoCard(item){
  var card = byId("diqTravelInfoCard");
  var title = byId("diqTravelInfoTitle");
  var sub = byId("diqTravelInfoSub");
  var kicker;
  var photo;
  var actions;
  var imgUrl;
  var ratingText;
  var distText;
  var why;
  var scoreText;

  if(!item || !card){ return; }

  item = enrichPlaceIQItem(item,travelScanCategory);

  kicker = card.querySelector ? card.querySelector(".kicker") : null;
  photo = byId("diqTravelInfoPhoto");
  actions = card.querySelector ? card.querySelector(".actions") : null;

  if(!photo){
    photo = document.createElement("div");
    photo.id = "diqTravelInfoPhoto";
    photo.className = "photo";
    try{ card.insertBefore(photo,card.firstChild); }catch(e0){}
  }

  if(kicker){ kicker.textContent = item.placeIQBadge || "PLACE IQ"; }
  if(title){ title.textContent = item.displayName || item.label || "Travel stop"; }

  card.__travelPhotoItem=item;
  imgUrl = maybeGooglePhotoUrl(item);
  if(!imgUrl){ travelPhotoResolve(item,function(url){
    if(url && card.__travelPhotoItem===item){
      photo.innerHTML='<img src="'+esc(url)+'" alt="'+esc(travelPhotoName(item))+'" />';
      photo.className="photo hasPhoto";
    }
  }); }
  if(imgUrl){
    photo.innerHTML = '<img src="' + esc(imgUrl) + '" alt="" />';
    var previewImage=photo.querySelector("img");
    if(previewImage){ previewImage.onerror=function(){ if(card.__travelPhotoItem===item){ photo.innerHTML='<div class="fallbackIcon">📍</div>'; photo.className="photo"; } }; }
    photo.className = "photo hasPhoto";
  }else{
    photo.innerHTML = '<div class="fallbackIcon">' + esc(item.placeIQEmoji || "📍") + '</div><div class="fallbackText">' + esc(item.placeIQCategory || "Place IQ") + '</div>';
    photo.className = "photo";
  }

  ratingText = finite(Number(item.rating)) ? (String(Math.round(Number(item.rating) * 10) / 10) + "★" + (item.reviews ? " • " + String(item.reviews) + " reviews" : "")) : "Drive IQ pick";
  distText = finite(Number(item.centerMiles)) ? fmtMiles(item.centerMiles) + (travelScanScope === "near_destination" ? " from destination" : " from scan center") : "Route-ready";
  why = item.placeIQWhy || "A useful stop that fits your trip.";
  scoreText = "Category verified • Check venue details before visiting";

  if(sub){
    sub.innerHTML = '<div class="meta">' + esc(ratingText) + ' • ' + esc(distText) + '</div>' +
      '<div class="why">' + esc(why) + '</div>' +
      '<div class="score">' + esc(scoreText) + '</div>';
  }

  if(actions && !byId("diqTravelInfoSave")){
    actions.innerHTML =
      '<button type="button" class="close" id="diqTravelInfoClose">CLOSE</button>' +
      '<button type="button" class="save" id="diqTravelInfoSave">SAVE</button>' +
      '<button type="button" class="share" id="diqTravelInfoShare">SHARE</button>' +
      '<button type="button" class="route" id="diqTravelInfoRoute">ADD STOP</button>';
  }

  if(byId("diqTravelInfoClose")){ byId("diqTravelInfoClose").onclick = closeTravelInfoCard; }
  if(byId("diqTravelInfoSave")){ byId("diqTravelInfoSave").onclick = function(){ saveFavoriteStop(item); addStopToTripBuilder(item); }; }
  if(byId("diqTravelInfoShare")){ byId("diqTravelInfoShare").onclick = function(){ shareDiscovery(item); }; }
  if(byId("diqTravelInfoRoute")){ byId("diqTravelInfoRoute").onclick = function(){ routeToTravelStop(item); }; }

  card.__item = item;
  card.className = "on";
}



/* ========================================================================
   TRAVEL IQ V13 — SEARCH ANY STOP
======================================================================== */
function stopSearchCenter(scope){
  var feature;
  var coords;
  var pick;

  scope = String(scope || stopSearchScope || "near_me");

  if(scope === "near_destination"){
    if(dest && finite(Number(dest.lat)) && finite(Number(dest.lng))){
      return {
        lat:Number(dest.lat),
        lng:Number(dest.lng),
        label:String(dest.label || "destination"),
        scope:"near_destination"
      };
    }
    if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
      return {
        lat:Number(lastFix.lat),
        lng:Number(lastFix.lng),
        label:"you",
        scope:"near_me",
        fallback:true
      };
    }
    return null;
  }

  if(scope === "along_route"){
    feature = getActiveRouteFeature();
    coords = feature && feature.geometry ? flattenRouteCoords(feature.geometry) : [];
    if(coords && coords.length){
      pick = coords[Math.max(0,Math.min(coords.length - 1,Math.floor(coords.length * 0.55)))];
      if(pick && finite(Number(pick[0])) && finite(Number(pick[1]))){
        return {
          lat:Number(pick[1]),
          lng:Number(pick[0]),
          label:"your route",
          scope:"along_route"
        };
      }
    }
    if(dest && finite(Number(dest.lat)) && finite(Number(dest.lng))){
      return {
        lat:Number(dest.lat),
        lng:Number(dest.lng),
        label:String(dest.label || "destination"),
        scope:"near_destination",
        fallback:true
      };
    }
    if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
      return {
        lat:Number(lastFix.lat),
        lng:Number(lastFix.lng),
        label:"you",
        scope:"near_me",
        fallback:true
      };
    }
    return null;
  }

  if(lastFix && finite(Number(lastFix.lat)) && finite(Number(lastFix.lng))){
    return {
      lat:Number(lastFix.lat),
      lng:Number(lastFix.lng),
      label:"you",
      scope:"near_me"
    };
  }

  if(dest && finite(Number(dest.lat)) && finite(Number(dest.lng))){
    return {
      lat:Number(dest.lat),
      lng:Number(dest.lng),
      label:String(dest.label || "destination"),
      scope:"near_destination",
      fallback:true
    };
  }

  return null;
}

function stopScopeLabel(scope){
  if(scope === "near_destination"){ return "near destination"; }
  if(scope === "along_route"){ return "along route"; }
  return "near you";
}

function syncStopSearchScope(){
  var buttons;
  var i;
  var scope;
  var center;

  try{
    buttons = document.querySelectorAll("#diqStopScope [data-stop-scope]");
    for(i=0;i<buttons.length;i++){
      scope = String(buttons[i].getAttribute("data-stop-scope") || "near_me");
      buttons[i].className = "diqStopScopeBtn" + (scope === stopSearchScope ? " on" : "");
    }
  }catch(e){}

  center = stopSearchCenter(stopSearchScope);

  if(stopSearchScope === "near_destination" && (!dest || !finite(Number(dest.lat)) || !finite(Number(dest.lng)))){
    setIntel("NEED DEST","gold");
  }else if(stopSearchScope === "along_route" && !getActiveRouteFeature()){
    setIntel("NEED ROUTE","gold");
  }else if(center){
    setIntel("STOP SEARCH READY","green");
  }
}

function setStopSearchScope(scope){
  scope = String(scope || "near_me");

  if(scope === "near_destination" && (!dest || !finite(Number(dest.lat)) || !finite(Number(dest.lng)))){
    toast("Choose a destination first");
    setIntel("NEED DEST","gold");
    return false;
  }

  if(scope === "along_route" && !getActiveRouteFeature()){
    toast("Build a route first");
    setIntel("NEED ROUTE","gold");
    return false;
  }

  stopSearchScope = scope;
  syncStopSearchScope();
  subline("Search any stop " + stopScopeLabel(scope));
  return true;
}

function clearStopSearchResults(){
  var box = byId("diqStopResults");
  stopSearchResults = [];
  if(!box){ return; }
  box.className = "diqStopResults";
  box.innerHTML = "";
  box.__items = [];
}

function normalizeStopSearchFeature(feature,query,center){
  var item = normalizeFeature(feature,query);
  if(!item){ return null; }

  item.sourceQuery = query;
  item.searchMode = "literal_stop_search";
  item.stopSearchScope = center ? center.scope : stopSearchScope;
  item.centerMiles = center ? miles(center.lat,center.lng,item.lat,item.lng) : null;
  item.distMiles = lastFix ? miles(lastFix.lat,lastFix.lng,item.lat,item.lng) : item.centerMiles;
  item.displayName = placeDisplayName(item);
  item.placeIQCategory = "Search Stop";
  item.placeIQBadge = "🔎 SEARCH MATCH";
  item.placeIQWhy = "A direct match for your stop search. Add it to the trip or route here.";
  item.placeIQScore = 0;
  item.placeIQStars = "";
  item.placeIQEmoji = "🔎";
  return item;
}

function stopSearchScore(item,query,center){
  var q = normText(query);
  var name = normText(item && (item.displayName || item.label || ""));
  var full = normText(item && item.full || "");
  var txt = clean(name + " " + full);
  var words = q ? q.split(" ") : [];
  var score = 0;
  var d = item && finite(Number(item.centerMiles)) ? Number(item.centerMiles) : 9999;
  var i;

  if(!item){ return -99999; }

  if(name === q){ score += 420; }
  else if(name.indexOf(q) === 0){ score += 300; }
  else if(name.indexOf(q) > -1){ score += 240; }
  else if(txt.indexOf(q) > -1){ score += 180; }

  for(i=0;i<words.length;i++){
    if(words[i] && name.indexOf(words[i]) > -1){ score += 34; }
    else if(words[i] && full.indexOf(words[i]) > -1){ score += 16; }
  }

  if(looksAddress(query)){
    if(item.kind === "Address"){ score += 180; }
    else{ score -= 45; }
  }else{
    if(item.kind === "Place" || item.kind === "Food" || item.kind === "Hotel" || item.kind === "Park"){ score += 55; }
    if(item.kind === "Area"){ score -= 35; }
  }

  if(finite(d)){
    if(d <= 1){ score += 90; }
    else if(d <= 3){ score += 72; }
    else if(d <= 8){ score += 52; }
    else if(d <= 20){ score += 28; }
    else if(d <= 50){ score += 10; }
    else{ score -= Math.min(80,Math.round(d)); }
  }

  if(center && center.scope === "along_route"){
    score += 20;
    item.routeFitLabel = "Along route";
  }else if(center && center.scope === "near_destination"){
    item.routeFitLabel = "Near destination";
  }else{
    item.routeFitLabel = "Near you";
  }

  return score;
}

function stopSearchDistanceLabel(item){
  var parts = [];
  if(item && item.routeFitLabel){ parts.push(String(item.routeFitLabel)); }
  if(item && finite(Number(item.centerMiles))){ parts.push(fmtMiles(Number(item.centerMiles))); }
  else if(item && finite(Number(item.distMiles))){ parts.push(fmtMiles(Number(item.distMiles))); }
  if(item && item.kind){ parts.push(String(item.kind)); }
  return parts.join(" • ");
}

function renderStopSearchResults(items,query){
  var box = byId("diqStopResults");
  var html = "";
  var i;
  var item;
  var nodes;

  stopSearchResults = items && items.length ? items.slice(0,8) : [];

  if(!box){ return; }

  if(!stopSearchResults.length){
    box.__items = [];
    box.innerHTML =
      '<div class="diqResultItem">' +
        '<div class="diqResultTitle">No strong stop matches yet</div>' +
        '<div class="diqResultSub">Try a business name, category, address, or broader phrase.</div>' +
      '</div>';
    box.className = "diqStopResults on";
    return;
  }

  for(i=0;i<stopSearchResults.length;i++){
    item = stopSearchResults[i];
    html +=
      '<div class="diqResultItem" data-stop-result="' + String(i) + '">' +
        '<div class="diqResultTop">' +
          '<div class="diqResultTitle">' + esc(item.displayName || item.label || "Stop") + '</div>' +
          '<div class="diqResultBadge">SEARCH MATCH</div>' +
        '</div>' +
        '<div class="diqResultSub">' +
          esc(stopSearchDistanceLabel(item) + (item.full ? " • " + item.full : "")) +
        '</div>' +
        '<div class="diqRouteBtns">' +
          '<button type="button" class="diqClear" data-stop-add="' + String(i) + '">ADD STOP</button>' +
          '<button type="button" class="diqRouteNow" data-stop-route="' + String(i) + '">ROUTE HERE</button>' +
        '</div>' +
      '</div>';
  }

  box.__items = stopSearchResults;
  box.innerHTML = html;
  box.className = "diqStopResults on";

  nodes = box.querySelectorAll("[data-stop-add]");
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){
      var idx = Number(this.getAttribute("data-stop-add"));
      var picked = box.__items && box.__items[idx];
      if(e && e.stopPropagation){ e.stopPropagation(); }
      if(!picked){ return; }
      addStopToTripBuilder(picked);
      try{
        localStorage.setItem("diq_added_stop_v1",JSON.stringify({
          name:picked.displayName || picked.label || "Stop",
          label:picked.displayName || picked.label || "Stop",
          lat:Number(picked.lat),
          lng:Number(picked.lng),
          category:"Search Stop",
          badge:"🔎 SEARCH MATCH",
          source:"travel_iq_search_stop_v13"
        }));
      }catch(err){}
      setIntel("STOP ADDED","green");
      toast("Added stop: " + String(picked.displayName || picked.label || "stop"));
    };
  }

  nodes = box.querySelectorAll("[data-stop-route]");
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){
      var idx = Number(this.getAttribute("data-stop-route"));
      var picked = box.__items && box.__items[idx];
      if(e && e.stopPropagation){ e.stopPropagation(); }
      if(!picked){ return; }

      addStopToTripBuilder(picked);
      try{
        localStorage.setItem("diq_added_stop_v1",JSON.stringify({
          name:picked.displayName || picked.label || "Stop",
          label:picked.displayName || picked.label || "Stop",
          lat:Number(picked.lat),
          lng:Number(picked.lng),
          category:"Search Stop",
          badge:"🔎 SEARCH MATCH",
          source:"travel_iq_search_stop_v13"
        }));
      }catch(err2){}

      chooseDestination({
        label:picked.displayName || picked.label || "Travel stop",
        full:picked.full || "",
        lat:Number(picked.lat),
        lng:Number(picked.lng),
        kind:picked.kind || "Search Stop"
      });
      buildRoute();
      clearStopSearchResults();
      setIntel("ROUTING STOP","blue");
      toast("Routing to " + String(picked.displayName || picked.label || "stop"));
    };
  }

  nodes = box.querySelectorAll("[data-stop-result]");
  for(i=0;i<nodes.length;i++){
    nodes[i].onclick = function(e){
      var idx = Number(this.getAttribute("data-stop-result"));
      var picked = box.__items && box.__items[idx];
      if(e && e.target && e.target.getAttribute &&
         (e.target.getAttribute("data-stop-add") !== null ||
          e.target.getAttribute("data-stop-route") !== null)){ return; }
      if(!picked){ return; }
      flyTo(picked.lng,picked.lat,15.2);
      try{ renderTravelPins([picked]); }catch(err3){}
      setIntel("STOP PREVIEW","green");
    };
  }

  try{
    renderTravelPins(stopSearchResults);
    fitTravelScan(stopSearchResults,stopSearchCenter(stopSearchScope));
  }catch(pinErr){}
}

function searchAnyStop(rawQuery){
  var query = clean(rawQuery);
  var center;
  var token;
  var urls;
  var all = [];
  var pending = 0;
  var launched = 0;
  var finished = false;

  if(!query || query.length < 2){
    clearStopSearchResults();
    toast("Enter a stop to search");
    return;
  }

  if(!GEOAPIFY_KEY){
    setIntel("NO GEO KEY","red");
    toast("Stop search unavailable");
    return;
  }

  center = stopSearchCenter(stopSearchScope);
  if(!center){
    if(stopSearchScope === "near_destination"){
      toast("Choose a destination first");
      setIntel("NEED DEST","gold");
    }else if(stopSearchScope === "along_route"){
      toast("Build a route first");
      setIntel("NEED ROUTE","gold");
    }else{
      toast("Lock GPS first");
      setIntel("NEED GPS","gold");
      requestGPS(true);
    }
    return;
  }

  if(center.fallback){
    stopSearchScope = center.scope;
    syncStopSearchScope();
  }

  stopSearchToken += 1;
  token = stopSearchToken;
  urls = [
    travelGeoUrl(query,"autocomplete",center),
    travelGeoUrl(query,"search",center)
  ];

  clearStopSearchResults();
  setIntel("SEARCHING STOP","blue");
  subline("Searching \"" + query + "\" " + stopScopeLabel(center.scope));
  toast("Searching for " + query);

  function finish(){
    var sorted;
    if(finished || pending > 0 || launched < urls.length || token !== stopSearchToken){ return; }
    finished = true;

    all = dedupeTravelItems(all);
    sorted = all.sort(function(a,b){
      var sa = stopSearchScore(a,query,center);
      var sb = stopSearchScore(b,query,center);
      if(Math.abs(sb - sa) > 5){ return sb - sa; }
      var da = finite(Number(a.centerMiles)) ? Number(a.centerMiles) : 9999;
      var db = finite(Number(b.centerMiles)) ? Number(b.centerMiles) : 9999;
      return da - db;
    }).slice(0,8);

    renderStopSearchResults(sorted,query);

    if(sorted.length){
      setIntel(String(sorted.length) + " STOP MATCHES","green");
      subline("Literal stop matches " + stopScopeLabel(center.scope) + " • choose Add Stop or Route Here");
      toast(String(sorted.length) + " stop matches found");
    }else{
      setIntel("NO STOP MATCH","gold");
      subline("No strong matches • try a broader business or category search");
      toast("No strong stop matches");
    }
  }

  function launch(url){
    pending += 1;
    launched += 1;
    try{
      fetch(url)
        .then(function(res){ return res.json(); })
        .then(function(data){
          var features = data && data.features ? data.features : [];
          var i;
          var item;
          for(i=0;i<features.length;i++){
            item = normalizeStopSearchFeature(features[i],query,center);
            if(item){ all.push(item); }
          }
          pending -= 1;
          finish();
        })
        .catch(function(){
          pending -= 1;
          finish();
        });
    }catch(e){
      pending -= 1;
      finish();
    }
  }

  launch(urls[0]);
  launch(urls[1]);
}

function bindSearchAnyStop(){
  var input = byId("diqStopInput");
  var searchBtn = byId("diqSearchStop");
  var scopeWrap = byId("diqStopScope");

  syncStopSearchScope();

  if(scopeWrap){
    scopeWrap.onclick = function(e){
      var target = e && e.target ? e.target : null;
      var scope;
      while(target && target !== scopeWrap){
        if(target.getAttribute && target.getAttribute("data-stop-scope")){
          scope = target.getAttribute("data-stop-scope");
          setStopSearchScope(scope);
          return;
        }
        target = target.parentNode;
      }
    };
  }

  if(searchBtn){
    searchBtn.onclick = function(){
      searchAnyStop(input ? input.value : "");
    };
  }

  if(input){
    input.addEventListener("keydown",function(e){
      if(e && e.key === "Enter"){
        if(stopSearchTimer){ window.clearTimeout(stopSearchTimer); }
        searchAnyStop(input.value);
      }
    },false);

    input.addEventListener("input",function(){
      var q = clean(input.value);
      if(stopSearchTimer){ window.clearTimeout(stopSearchTimer); }
      if(!q){ clearStopSearchResults(); return; }
      stopSearchTimer = window.setTimeout(function(){
        if(q.length >= 3){ searchAnyStop(q); }
      },520);
    },false);
  }
}

function bindButtons(){
  var input = byId("diqDestInput");
  bindShellBack();
  ensureTravelScanUI();
  bindTravelTripStyles();
  bindSearchAnyStop();
  try{ renderTripBuilderShell(loadTripBuilder()); renderMemoryShell(); bindPlaceIQDeckActions(); }catch(e){}

  if(input){
    input.addEventListener("input",function(){
      var q = clean(input.value);
      destinationSearchToken += 1;
      clearResults();

      if(searchTimer){ window.clearTimeout(searchTimer); }

      searchTimer = window.setTimeout(function(){
        geocode(q);
      },260);
    },false);

    input.addEventListener("keydown",function(e){
      if(e && e.key === "Enter"){
        if(searchTimer){ window.clearTimeout(searchTimer); }
        geocode(input.value);
      }
    },false);
  }

  if(byId("diqLockGps")){
    byId("diqLockGps").onclick = function(){ requestGPS(true); };
  }

  if(byId("diqRouteNow")){
    byId("diqRouteNow").onclick = function(){ currentTripBuilder(); buildRoute(); };
  }

  if(byId("diqPlanTripQuick")){
    byId("diqPlanTripQuick").onclick = function(){
      var typed = clean(input ? input.value : "");
      var selectedLabel = dest ? clean(dest.label) : "";
      var selectedFull = dest ? clean(dest.full) : "";
      if(!typed){ toast("Enter a destination first"); setIntel("NEED DEST","gold"); return; }
      /* Never silently scan the previously selected city when the field changed. */
      if(!dest || (normText(typed) !== normText(selectedLabel) && normText(typed) !== normText(selectedFull))){
        geocode(typed);
        toast("Select the matching destination, then tap Plan Trip");
        setIntel("SELECT DEST","gold");
        return;
      }
      currentTripBuilder();
      manualTravelScanScope = "near_destination";
      stopSearchScope = "near_destination";
      updateTravelScanScope();
      syncStopSearchScope();
      startTravelScan(travelTripStyleConfig(activeTravelTripStyle).primary || "preview");
    };
  }

  if(byId("diqContinuePlanning")){
    byId("diqContinuePlanning").onclick = function(){ renderTripBuilderShell(loadTripBuilder()); toast("Planning restored"); setIntel("PLAN READY","green"); };
  }

  if(byId("diqSaveTripPlan")){
    byId("diqSaveTripPlan").onclick = saveTripSnapshot;
  }

  if(byId("diqViewFavorites")){
    byId("diqViewFavorites").onclick = function(){ renderMemoryShell(); toast(String(getJSONList(LS.FAVORITE_STOPS).length) + " favorite stops saved"); };
  }

  if(byId("diqCenterMap")){
    byId("diqCenterMap").onclick = centerMap;
  }

  if(byId("diqStartDrive")){
    byId("diqStartDrive").onclick = startDrive;
  }

  if(byId("diqClearRoute")){
    byId("diqClearRoute").onclick = clearRoute;
  }

  if(byId("diqUpgradePlus")){
    byId("diqUpgradePlus").onclick = openUpgradeSheet;
  }

  if(byId("diqUpgradeClose")){
    byId("diqUpgradeClose").onclick = closeUpgradeSheet;
  }

  if(byId("diqUpgradeSheet")){
    byId("diqUpgradeSheet").onclick = function(e){
      if(e && e.target && e.target.id === "diqUpgradeSheet"){ closeUpgradeSheet(); }
    };
  }

  if(byId("diqPlusMonthly")){
    byId("diqPlusMonthly").onclick = function(){ beginUpgrade("com.loveforlocals.driveiq.plus.monthly"); };
  }

  if(byId("diqPlusYearly")){
    byId("diqPlusYearly").onclick = function(){ beginUpgrade("com.loveforlocals.driveiq.plus.yearly"); };
  }
}

function initMap(){
  if(!window.mapboxgl){
    setIntel("MAPBOX MISSING","red");
    toast("Mapbox missing");
    return;
  }

  if(!MAPBOX_TOKEN){
    setIntel("NO MAP TOKEN","red");
    toast("Missing Mapbox token");
    return;
  }

  try{
    mapboxgl.accessToken = MAPBOX_TOKEN;

    map = new mapboxgl.Map({
      container:"diqMap",
      style:"mapbox://styles/mapbox/navigation-night-v1",
      center:[-89.987,35.149],
      zoom:10.6,
      pitch:0,
      bearing:0,
      attributionControl:false
    });

    window.DRIVE_IQ_START_MAP = map;

    map.on("load",function(){
      mapLoaded = true;
      ensureMapSources();
      restoreState();
      restoreGPS();
      setIntel("MAP READY","green");
      toast("Map ready");
    });

    map.on("error",function(){
      setIntel("MAP WARNING","gold");
    });
  }catch(e){
    setIntel("MAP FAILED","red");
    toast("Map failed");
  }
}

function boot(){
  document.body.setAttribute("data-drive-iq-travel","v15-trip-styles-search-any-stop-local-iq");
  try{ document.body.classList.add("diqTravelPlanning"); document.body.classList.add("diqLocalIQReady"); document.body.classList.add("diqTravelTripStylesReady"); }catch(e){}
  restoreTravelTripStyle();
  bindButtons();
  initMap();
  setIntel("READY","green");
  setGps("LOCATING GPS");
  updateRoutePanel(null);
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",boot,false);
}else{
  boot();
}

})();

/* =====================================================================
   DRIVE IQ TRAVEL MODE V4 — SAVED ROUTE DURATION REPAIR + VACATION POLISH
   Keeps old saved routes from showing "--" when duration was missing.
===================================================================== */
(function(){
"use strict";

if(window.__DRIVE_IQ_TRAVEL_V3_DURATION_REPAIR__){ return; }
window.__DRIVE_IQ_TRAVEL_V3_DURATION_REPAIR__ = true;

function sp(v){ try{return JSON.parse(String(v||""));}catch(e){return null;} }
function finite(v){ return typeof v === "number" && isFinite(v); }
function fmtTime(seconds){
  var m = Math.round(Number(seconds || 0) / 60);
  var h;
  var r;
  if(!finite(m) || m <= 0){ return "--"; }
  h = Math.floor(m / 60);
  r = m % 60;
  if(h <= 0){ return String(r) + " min"; }
  if(r <= 0){ return String(h) + " hr"; }
  return String(h) + " hr " + String(r) + " min";
}
function firstNumber(list){
  var i;
  var n;
  for(i=0;i<list.length;i++){
    n = Number(list[i]);
    if(finite(n) && n > 0){ return n; }
  }
  return 0;
}
function durationFromFeature(feature){
  var p = feature && feature.properties ? feature.properties : {};
  var legs = p.legs || p.route_legs || [];
  var segs = p.segments || [];
  var candidates = [p.time,p.duration,p.durationSeconds,p.duration_seconds,p.travel_time,p.travelTime];
  var i;
  var n;
  for(i=0;i<legs.length;i++){
    if(legs[i]){ candidates.push(legs[i].time,legs[i].duration,legs[i].durationSeconds,legs[i].duration_seconds); }
  }
  for(i=0;i<segs.length;i++){
    if(segs[i]){ candidates.push(segs[i].time,segs[i].duration,segs[i].durationSeconds,segs[i].duration_seconds); }
  }
  n = firstNumber(candidates);
  if(n > 604800){ n = n / 1000; }
  return n;
}
function distanceFromFeature(feature){
  var p = feature && feature.properties ? feature.properties : {};
  return firstNumber([p.distance,p.distanceMeters,p.distance_meters,p.length,p.length_meters]);
}
function estimateDuration(distanceMeters){
  var mi = Number(distanceMeters || 0) * 0.000621371;
  var mph = mi < 5 ? 28 : (mi < 25 ? 42 : (mi < 90 ? 55 : 61));
  if(!finite(mi) || mi <= 0){ return 0; }
  return Math.round((mi / mph) * 3600);
}
function repair(){
  var route = sp(localStorage.getItem("diq_route_geo_v1"));
  var intel = sp(localStorage.getItem("diq_route_intel_v1")) || {};
  var feature = route && route.features && route.features.length ? route.features[0] : null;
  var d;
  var dur;
  var sub;
  var label;
  if(!feature){ return; }

  d = distanceFromFeature(feature);
  dur = durationFromFeature(feature);
  if(!dur && d){ dur = estimateDuration(d); }
  if(!dur){ return; }

  if(!intel.durationLabel || intel.durationLabel === "--"){
    intel.durationLabel = fmtTime(dur);
    if(d && !intel.miles){ intel.miles = Math.round((d * 0.000621371) * 10) / 10; }
    intel.summary = "Score " + String(intel.routeScore || 94) + " • " + intel.durationLabel;
    try{ localStorage.setItem("diq_route_intel_v1",JSON.stringify(intel)); }catch(e1){}
  }

  sub = document.getElementById("diqRouteSub");
  if(sub && sub.textContent && sub.textContent.indexOf("--") === 0){
    label = intel.durationLabel + " • " + String(intel.miles || Math.round((d * 0.000621371) * 10) / 10) + " mi • Destination pin locked";
    sub.textContent = label;
  }
}

window.addEventListener("pageshow",function(){ window.setTimeout(repair,450); });
window.addEventListener("load",function(){ window.setTimeout(repair,900); });
})();
/* =====================================================================
   DRIVE IQ START DRIVE V10 — WAYPOINT MEMORY PATCH
   Adds:
   - added_stop support
   - waypoint_mode flag
   - restores stop state into payload
   - Route IQ chip update
===================================================================== */
(function(){
"use strict";

if(window.__DIQ_STOP_WAYPOINT_PATCH__){ return; }
window.__DIQ_STOP_WAYPOINT_PATCH__=true;

function sp(v){
  try{return JSON.parse(String(v||""));}
  catch(e){return null;}
}

function jset(k,v){
  try{ localStorage.setItem(k,JSON.stringify(v)); }
  catch(e){}
}

window.addEventListener("pageshow",function(){

  var payload=sp(localStorage.getItem("diq_drive_payload_v1"))||{};
  var stop=sp(localStorage.getItem("diq_added_stop_v1"));

  if(!stop){ return; }

  payload.added_stop=stop;
  payload.waypoint_mode=true;
  payload.updated_at=(new Date()).toISOString();

  jset("diq_drive_payload_v1",payload);

  var title=document.getElementById("diqRouteTitle");
  var sub=document.getElementById("diqRouteSub");

  if(title){
    title.textContent="Stop Added";
  }

  if(sub){
    sub.textContent="🍔 " + String(stop.name||"Stop") + " • 1 waypoint active";
  }
});
})();

/* ========================================================================
   DRIVE IQ — TRAVEL MODE JS V15.1 MAP-FIRST COMPATIBILITY LOCK
   Safe companion patch for the V15.1 map-first HTML.
   - Keeps the map visible by adding diqMapFirst when Travel Mode loads.
   - Re-syncs Mapbox after panel minimize/restore and orientation changes.
   - Bridges the older HTML trip-style key with the newer JS trip-style key.
   - Does not change routing, GPS, purchase, or scan logic.
======================================================================== */
(function(){
"use strict";

if(window.__DRIVE_IQ_TRAVEL_V15_1_MAP_FIRST_COMPAT_LOCK__){ return; }
window.__DRIVE_IQ_TRAVEL_V15_1_MAP_FIRST_COMPAT_LOCK__ = true;

function byId(id){ return document.getElementById(id); }
function clean(v){ return String(v || "").replace(/\s+/g," ").trim(); }
function sp(v){ try{ return JSON.parse(String(v || "")); }catch(e){ return null; } }
function jset(k,v){ try{ localStorage.setItem(k,JSON.stringify(v)); }catch(e){} }
function sget(k){ try{ return localStorage.getItem(k); }catch(e){ return null; } }

var OLD_STYLE_KEY = "diq_travel_trip_style_v1";
var OLD_LABEL_KEY = "diq_travel_trip_style_label_v1";
var NEW_STYLE_KEY = "diq_travel_iq_trip_style_v1";

function resizeTravelMap(){
  try{
    if(window.DRIVE_IQ_TRAVEL_MAP && typeof window.DRIVE_IQ_TRAVEL_MAP.resize === "function"){
      window.setTimeout(function(){ window.DRIVE_IQ_TRAVEL_MAP.resize(); },80);
      window.setTimeout(function(){ window.DRIVE_IQ_TRAVEL_MAP.resize(); },320);
    }
  }catch(e){}
}

function ensureMapFirst(){
  var app = byId("diqTravelApp");
  if(app){ app.classList.add("diqMapFirst"); }
}

function bridgeTripStyleKeys(){
  var oldStyle = clean(sget(OLD_STYLE_KEY));
  var oldLabel = clean(sget(OLD_LABEL_KEY));
  var current = sp(sget(NEW_STYLE_KEY));
  if(oldStyle && (!current || current.key !== oldStyle)){
    jset(NEW_STYLE_KEY,{
      key:oldStyle,
      label:oldLabel || oldStyle,
      emoji:"",
      source:"html_bridge",
      updatedAt:(new Date()).toISOString()
    });
  }
}

function syncCompactState(){
  var app = byId("diqTravelApp");
  var title = byId("diqRouteTitle");
  var routeText = title ? clean(title.textContent).toLowerCase() : "";
  if(!app){ return; }
  if(routeText && routeText.indexOf("choose") < 0){ app.setAttribute("data-travel-has-plan","1"); }
  else{ app.setAttribute("data-travel-has-plan","0"); }
}

function bind(){
  ensureMapFirst();
  bridgeTripStyleKeys();
  syncCompactState();
  resizeTravelMap();

  try{
    window.addEventListener("resize",function(){ ensureMapFirst(); resizeTravelMap(); },false);
    window.addEventListener("orientationchange",function(){ ensureMapFirst(); resizeTravelMap(); },false);
    window.addEventListener("storage",function(e){ if(e && (e.key === OLD_STYLE_KEY || e.key === NEW_STYLE_KEY)){ bridgeTripStyleKeys(); } },false);
    window.setInterval(function(){ ensureMapFirst(); syncCompactState(); },1600);
  }catch(e1){}

  try{
    document.addEventListener("driveiq:travel-style-change",function(){ bridgeTripStyleKeys(); syncCompactState(); resizeTravelMap(); },false);
    document.addEventListener("click",function(e){
      var t = e && e.target ? e.target : null;
      var count = 0;
      while(t && count < 6){
        if(t.id === "diqTravelMinimize" || t.id === "diqTravelShowMenu" || (t.getAttribute && t.getAttribute("data-trip-style"))){
          window.setTimeout(function(){ ensureMapFirst(); bridgeTripStyleKeys(); syncCompactState(); resizeTravelMap(); },90);
          break;
        }
        t = t.parentNode;
        count += 1;
      }
    },true);
  }catch(e2){}
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",bind,false);
}else{
  bind();
}
})();

/* ========================================================================
   DRIVE IQ — TRAVEL MODE JS V15.2 POLISHED MAP-FIRST COMPATIBILITY
   Safe companion update for the polished V15.2 Travel Mode HTML/CSS.
   - Uses the real JS-created Travel Scans card id: #diqTravelScanCard.
   - Starts Travel Scans in compact dock mode.
   - Keeps the active planning card visible above the dock.
   - Aliases the live Mapbox object to DRIVE_IQ_TRAVEL_MAP.
   - Re-syncs map size after panel and scan-dock changes.
   - Does not replace routing, GPS, search, purchase, or Place IQ logic.
======================================================================== */
(function(){
"use strict";

if(window.__DRIVE_IQ_TRAVEL_V15_2_POLISHED_COMPAT__){ return; }
window.__DRIVE_IQ_TRAVEL_V15_2_POLISHED_COMPAT__ = true;

function byId(id){ return document.getElementById(id); }

function injectV152Styles(){
  var style;
  var css;

  if(byId("diqTravelV152CompatStyle")){ return; }

  css =
    "#diqTravelScanCard{" +
      "position:fixed!important;" +
      "left:0!important;" +
      "right:0!important;" +
      "bottom:0!important;" +
      "z-index:23!important;" +
      "width:100%!important;" +
      "max-height:72px!important;" +
      "min-height:72px!important;" +
      "border-radius:24px 24px 0 0!important;" +
      "background:radial-gradient(circle at 14% 0%,rgba(0,229,255,.11),transparent 34%),linear-gradient(180deg,rgba(5,12,22,.985),rgba(7,18,30,.975))!important;" +
      "border:0!important;" +
      "border-top:1px solid rgba(0,229,255,.20)!important;" +
      "box-shadow:0 -16px 40px rgba(0,0,0,.44)!important;" +
      "overflow:hidden!important;" +
      "backdrop-filter:blur(22px)!important;" +
      "-webkit-backdrop-filter:blur(22px)!important;" +
    "}" +
    "#diqTravelScanCard .diqTravelScanInner{" +
      "padding:8px 10px calc(8px + env(safe-area-inset-bottom,0px))!important;" +
    "}" +
    "#diqTravelScanCard .diqTravelScanHead{" +
      "min-height:48px!important;" +
      "margin:0!important;" +
    "}" +
    "#diqTravelScanCard .diqTravelScanTitle{" +
      "font-size:9px!important;" +
      "letter-spacing:1.15px!important;" +
    "}" +
    "#diqTravelScanCard .diqTravelScanMini{" +
      "min-height:30px!important;" +
      "padding:0 11px!important;" +
    "}" +
    "body.diqTravelScanCollapsed #diqTravelScanCard{" +
      "max-height:72px!important;" +
      "min-height:72px!important;" +
    "}" +
    "body.diqTravelScanCollapsed #diqTravelScanCard .diqTravelScopeToggle," +
    "body.diqTravelScanCollapsed #diqTravelScanCard .diqTravelChipRow," +
    "body.diqTravelScanCollapsed #diqTravelScanCard #diqTravelPreviewCard," +
    "body.diqTravelScanCollapsed #diqTravelScanCard #diqFoodIQPanel{" +
      "display:none!important;" +
    "}" +
    "body:not(.diqTravelScanCollapsed) #diqTravelScanCard{" +
      "max-height:min(38vh,330px)!important;" +
      "min-height:0!important;" +
      "overflow-y:auto!important;" +
      "-webkit-overflow-scrolling:touch!important;" +
    "}" +
    "body:not(.diqTravelScanCollapsed) #diqTravelScanCard .diqTravelScanInner{" +
      "padding-bottom:calc(12px + env(safe-area-inset-bottom,0px))!important;" +
    "}" +
    "#diqTravelApp.diqMapFirst .diqBottom{" +
      "bottom:calc(76px + env(safe-area-inset-bottom,0px))!important;" +
      "z-index:24!important;" +
    "}" +
    "#diqTravelInfoCard.on + #diqTravelScanCard{display:none!important;}" +
    "@media(max-width:420px){" +
      "#diqTravelScanCard{max-height:70px!important;min-height:70px!important;}" +
      "#diqTravelApp.diqMapFirst .diqBottom{bottom:calc(74px + env(safe-area-inset-bottom,0px))!important;}" +
    "}" +
    "@media(orientation:landscape){" +
      "#diqTravelScanCard{" +
        "left:auto!important;" +
        "right:0!important;" +
        "width:min(520px,54vw)!important;" +
        "border-radius:24px 0 0 0!important;" +
      "}" +
      "#diqTravelApp.diqMapFirst .diqBottom{" +
        "bottom:calc(10px + env(safe-area-inset-bottom,0px))!important;" +
      "}" +
    "}";

  style = document.createElement("style");
  style.id = "diqTravelV152CompatStyle";
  style.type = "text/css";
  style.appendChild(document.createTextNode(css));

  try{ document.head.appendChild(style); }catch(e){}
}

function syncMapAlias(){
  try{
    if(window.DRIVE_IQ_START_MAP && !window.DRIVE_IQ_TRAVEL_MAP){
      window.DRIVE_IQ_TRAVEL_MAP = window.DRIVE_IQ_START_MAP;
    }
  }catch(e){}
}

function resizeTravelMap(){
  syncMapAlias();
  try{
    if(window.DRIVE_IQ_TRAVEL_MAP && typeof window.DRIVE_IQ_TRAVEL_MAP.resize === "function"){
      window.setTimeout(function(){ window.DRIVE_IQ_TRAVEL_MAP.resize(); },80);
      window.setTimeout(function(){ window.DRIVE_IQ_TRAVEL_MAP.resize(); },280);
    }
  }catch(e){}
}

function collapseTravelScans(){
  var mini = byId("diqTravelScanMini");

  try{ document.body.classList.add("diqTravelScanCollapsed"); }catch(e1){}
  if(mini){ mini.textContent = "EXPAND"; }

  try{
    if(typeof window.DRIVE_IQ_TRAVEL_SET_SCAN_COLLAPSED === "function"){
      window.DRIVE_IQ_TRAVEL_SET_SCAN_COLLAPSED(true);
    }
  }catch(e2){}
}

function syncTravelShell(){
  var app = byId("diqTravelApp");
  var scanCard = byId("diqTravelScanCard");

  injectV152Styles();
  syncMapAlias();

  if(app){ app.classList.add("diqMapFirst"); }

  if(scanCard && !scanCard.getAttribute("data-v15-2-ready")){
    scanCard.setAttribute("data-v15-2-ready","1");
    collapseTravelScans();
  }
}

function bind(){
  var attempts = 0;
  var timer;

  injectV152Styles();
  syncTravelShell();
  resizeTravelMap();

  timer = window.setInterval(function(){
    attempts += 1;
    syncTravelShell();

    if(byId("diqTravelScanCard") || attempts >= 20){
      window.clearInterval(timer);
      collapseTravelScans();
      resizeTravelMap();
    }
  },250);

  try{
    window.addEventListener("resize",function(){
      syncTravelShell();
      resizeTravelMap();
    },false);

    window.addEventListener("orientationchange",function(){
      syncTravelShell();
      resizeTravelMap();
    },false);

    document.addEventListener("click",function(e){
      var target = e && e.target ? e.target : null;
      var count = 0;

      while(target && count < 6){
        if(
          target.id === "diqTravelMinimize" ||
          target.id === "diqTravelShowMenu" ||
          target.id === "diqTravelScanMini" ||
          (target.getAttribute && target.getAttribute("data-travel-cat"))
        ){
          window.setTimeout(function(){
            syncTravelShell();
            resizeTravelMap();
          },100);
          break;
        }

        target = target.parentNode;
        count += 1;
      }
    },true);
  }catch(e3){}
}

if(document.readyState === "loading"){
  document.addEventListener("DOMContentLoaded",bind,false);
}else{
  bind();
}
})();


/* V16.7 — Search-first Travel Scans dock guard. */
(function(){
  var st=document.createElement("style");
  st.id="diqTravelV167SearchFirst";
  st.textContent="body.diqTravelScanCollapsed #diqTravelScanCard{max-height:72px!important;min-height:72px!important;overflow:hidden!important;}body.diqTravelScanCollapsed #diqTravelScanCard .diqTravelScopeToggle,body.diqTravelScanCollapsed #diqTravelScanCard .diqTravelChipRow,body.diqTravelScanCollapsed #diqTravelScanCard #diqTravelPreviewCard{display:none!important;}";
  try{document.head.appendChild(st);}catch(e){}
})();

/* V16.8 safe console summary (no credentials). */
window.DriveIQTravelGolfDiagnostics=function(){ return window.DriveIQTravelLastGolfDiagnostics || {status:"Run a Golf Trip search first"}; };
